export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Date: { input: Date; output: Date; }
  Json: { input: any; output: any; }
};

export type ActivitiesCountsPayload = {
  attendances: Scalars['Int']['output'];
  attended: Scalars['Int']['output'];
  checkIns: Scalars['Int']['output'];
  evaluations: Scalars['Int']['output'];
};

export type ActivitiesPayload = {
  activities: Array<Activity>;
  attendances: Scalars['Int']['output'];
  attended: Scalars['Int']['output'];
  checkIns: Scalars['Int']['output'];
  count: Scalars['Int']['output'];
  evaluations: Scalars['Int']['output'];
  participants: Scalars['Int']['output'];
};

export type Activity = {
  attendance?: Maybe<Attendance>;
  date?: Maybe<Scalars['Date']['output']>;
  evaluation?: Maybe<Evaluation>;
  event?: Maybe<Event>;
  id: Scalars['ID']['output'];
  privateSerieAttendance?: Maybe<PrivateSerieAttendance>;
  type: ActivityType;
  user?: Maybe<User>;
};

export const ActivityType = {
  Attended: 'Attended',
  CheckIn: 'CheckIn',
  Evaluation: 'Evaluation',
  NotAttended: 'NotAttended',
  NotCheckIn: 'NotCheckIn',
  PrivateSerieAttendance: 'PrivateSerieAttendance'
} as const;

export type ActivityType = typeof ActivityType[keyof typeof ActivityType];
export type Addon = {
  availableForAllOfferings?: Maybe<Scalars['Boolean']['output']>;
  billingCategory?: Maybe<BillingCategory>;
  billingCategoryId?: Maybe<Scalars['String']['output']>;
  classes: Array<Class>;
  counts?: Maybe<AddonCountPayload>;
  createdAt: Scalars['Date']['output'];
  createdBy?: Maybe<User>;
  department?: Maybe<Department>;
  departmentId?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  enabledByDefault?: Maybe<Scalars['Boolean']['output']>;
  fees: Array<Fee>;
  id: Scalars['ID']['output'];
  images: Array<File>;
  options: Array<Scalars['String']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  organization?: Maybe<Organization>;
  organizationId?: Maybe<Scalars['String']['output']>;
  price: Scalars['Int']['output'];
  standalone: Scalars['Boolean']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
};

export type AddonCountPayload = {
  charged: Scalars['Int']['output'];
  offerings: Scalars['Int']['output'];
  sold: Scalars['Int']['output'];
};

export type AddonCreateInput = {
  availableForAllOfferings?: InputMaybe<Scalars['Boolean']['input']>;
  billingCategory?: InputMaybe<BillingCategoryNestedInput>;
  classes?: InputMaybe<ConnectManyInput>;
  department?: InputMaybe<ConnectUniqueInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  enabledByDefault?: InputMaybe<Scalars['Boolean']['input']>;
  fees?: InputMaybe<FeeManyInput>;
  images?: InputMaybe<ConnectManyInput>;
  membershipOfferings?: InputMaybe<ConnectManyInput>;
  options?: InputMaybe<StringManyInput>;
  order?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<ConnectUniqueInput>;
  price?: InputMaybe<Scalars['Int']['input']>;
  standalone?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type AddonListRelationFilter = {
  every?: InputMaybe<AddonWhereInput>;
  none?: InputMaybe<AddonWhereInput>;
  some?: InputMaybe<AddonWhereInput>;
};

export type AddonManyInput = {
  update?: InputMaybe<Array<InputMaybe<AddonUpdateInput>>>;
};

export type AddonOrderByInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  order?: InputMaybe<SortOrder>;
  price?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type AddonUpdateInput = {
  data?: InputMaybe<AddonCreateInput>;
  where?: InputMaybe<UniqueInput>;
};

export type AddonWhereInput = {
  AND?: InputMaybe<AddonWhereInput>;
  NOT?: InputMaybe<AddonWhereInput>;
  OR?: InputMaybe<Array<AddonWhereInput>>;
  billingCategoryId?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateFilter>;
  department?: InputMaybe<DepartmentWhereInput>;
  departmentId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  organization?: InputMaybe<OrganizationWhereInput>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<IntFilter>;
  title?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateFilter>;
};

export type AdyenToken = {
  accountHolderType?: InputMaybe<Scalars['String']['input']>;
  bankAccountNumber?: InputMaybe<Scalars['String']['input']>;
  bankAccountType?: InputMaybe<Scalars['String']['input']>;
  bankLocationId?: InputMaybe<Scalars['String']['input']>;
  brand?: InputMaybe<Scalars['String']['input']>;
  checkoutAttemptId?: InputMaybe<Scalars['String']['input']>;
  encryptedCardNumber?: InputMaybe<Scalars['String']['input']>;
  encryptedExpiryMonth?: InputMaybe<Scalars['String']['input']>;
  encryptedExpiryYear?: InputMaybe<Scalars['String']['input']>;
  encryptedSecurityCode?: InputMaybe<Scalars['String']['input']>;
  ownerName?: InputMaybe<Scalars['String']['input']>;
};

export const AgeType = {
  Month: 'Month',
  Year: 'Year'
} as const;

export type AgeType = typeof AgeType[keyof typeof AgeType];
export type Agreement = {
  availableForAllOfferings: Scalars['Boolean']['output'];
  createdAt: Scalars['Date']['output'];
  description: Scalars['String']['output'];
  enabledByDefault: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  order: Scalars['Int']['output'];
  organization?: Maybe<Organization>;
  organizationId?: Maybe<Scalars['String']['output']>;
  required: Scalars['Boolean']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
};

export type AgreementCreateInput = {
  availableForAllOfferings?: InputMaybe<Scalars['Boolean']['input']>;
  classes?: InputMaybe<ConnectManyInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  enabledByDefault?: InputMaybe<Scalars['Boolean']['input']>;
  membershipOfferings?: InputMaybe<ConnectManyInput>;
  offerings?: InputMaybe<ConnectManyInput>;
  order: Scalars['Int']['input'];
  organization?: InputMaybe<ConnectUniqueInput>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type AgreementManyInput = {
  connect?: InputMaybe<Array<InputMaybe<UniqueInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<UniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<UniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<AgreementUpdateInput>>>;
};

export type AgreementOrderByInput = {
  order?: InputMaybe<SortOrder>;
};

export type AgreementUpdateInput = {
  data?: InputMaybe<AgreementCreateInput>;
  where?: InputMaybe<UniqueInput>;
};

export const AmountType = {
  Dollar: 'Dollar',
  Percent: 'Percent'
} as const;

export type AmountType = typeof AmountType[keyof typeof AmountType];
export const AnnualFeeType = {
  Account: 'Account',
  Student: 'Student'
} as const;

export type AnnualFeeType = typeof AnnualFeeType[keyof typeof AnnualFeeType];
export type AppSetting = {
  activeDays?: Maybe<Scalars['Int']['output']>;
  defaultStripeFee?: Maybe<Scalars['Float']['output']>;
  salesStats: Array<User>;
  scoreAbove?: Maybe<Scalars['Int']['output']>;
  scoreBelow?: Maybe<Scalars['Int']['output']>;
  timezone?: Maybe<Scalars['String']['output']>;
};

export type AppSettingCreateInput = {
  activeDays?: InputMaybe<Scalars['Int']['input']>;
  defaultStripeFee?: InputMaybe<Scalars['Float']['input']>;
  salesStats?: InputMaybe<UserManyInput>;
  scoreAbove?: InputMaybe<Scalars['Int']['input']>;
  scoreBelow?: InputMaybe<Scalars['Int']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};

export type ApplePayConfiguration = {
  merchantId: Scalars['String']['output'];
  merchantName: Scalars['String']['output'];
};

export const AppliesToType = {
  All: 'All',
  Approved: 'Approved',
  Waitlist: 'Waitlist'
} as const;

export type AppliesToType = typeof AppliesToType[keyof typeof AppliesToType];
export type Attendance = {
  active?: Maybe<Scalars['Boolean']['output']>;
  assignedBy?: Maybe<User>;
  assignedById?: Maybe<Scalars['String']['output']>;
  assignedOn?: Maybe<Scalars['Date']['output']>;
  cancelled?: Maybe<Scalars['Boolean']['output']>;
  checkIns: Array<User>;
  class: Class;
  classId?: Maybe<Scalars['String']['output']>;
  classTime?: Maybe<ClassTime>;
  classTimeId?: Maybe<Scalars['String']['output']>;
  counts?: Maybe<AttendanceCount>;
  createdAt: Scalars['Date']['output'];
  date: Scalars['Date']['output'];
  day?: Maybe<Day>;
  displayNoteDelay?: Maybe<Scalars['Int']['output']>;
  displayNoteDelayType?: Maybe<TimeType>;
  displayNoteToParticipants?: Maybe<Scalars['Boolean']['output']>;
  endTime?: Maybe<Scalars['String']['output']>;
  events: Array<Event>;
  excluded: Array<User>;
  id: Scalars['ID']['output'];
  instructors: Array<User>;
  instructorsAdded: Array<User>;
  internalNote?: Maybe<Scalars['String']['output']>;
  invoiceItems: Array<InvoiceItem>;
  isSplit?: Maybe<Scalars['Int']['output']>;
  location?: Maybe<Location>;
  locationId?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  organization?: Maybe<Organization>;
  organizationId?: Maybe<Scalars['String']['output']>;
  originalDate?: Maybe<Scalars['Date']['output']>;
  startTime?: Maybe<Scalars['String']['output']>;
  studentAttendanceNotes: Array<StudentAttendanceNote>;
  students: Array<User>;
  studentsAdded: Array<User>;
  studentsAttended: Array<User>;
  studentsRemoved: Array<User>;
  updatedAt: Scalars['Date']['output'];
  zone?: Maybe<Zone>;
  zoneId?: Maybe<Scalars['String']['output']>;
};

export type AttendanceCount = {
  added: Scalars['Int']['output'];
  checkedIn: Scalars['Int']['output'];
  enrolled: Scalars['Int']['output'];
  ineligible: Array<Scalars['String']['output']>;
  needsEvaluation: Array<Scalars['String']['output']>;
  pendingCancel: Array<PendingCancel>;
  readyToCharge: Scalars['Int']['output'];
  waitlist: Scalars['Int']['output'];
};

export type AttendanceCreateInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  assignedBy?: InputMaybe<ConnectUniqueInput>;
  assignedOn?: InputMaybe<Scalars['Date']['input']>;
  cancelled?: InputMaybe<Scalars['Boolean']['input']>;
  checkIns?: InputMaybe<UserManyInput>;
  class?: InputMaybe<ClassNestedInput>;
  classTime?: InputMaybe<ConnectUniqueInput>;
  date?: InputMaybe<Scalars['Date']['input']>;
  day?: InputMaybe<Day>;
  displayNoteDelay?: InputMaybe<Scalars['Int']['input']>;
  displayNoteDelayType?: InputMaybe<TimeType>;
  displayNoteToParticipants?: InputMaybe<Scalars['Boolean']['input']>;
  endTime?: InputMaybe<Scalars['String']['input']>;
  events?: InputMaybe<EventManyInput>;
  excluded?: InputMaybe<UserManyInput>;
  instructors?: InputMaybe<UserManyInput>;
  instructorsAdded?: InputMaybe<UserManyInput>;
  instructorsRemoved?: InputMaybe<UserManyInput>;
  internalNote?: InputMaybe<Scalars['String']['input']>;
  isSplit?: InputMaybe<Scalars['Int']['input']>;
  location?: InputMaybe<ConnectUniqueInput>;
  note?: InputMaybe<Scalars['String']['input']>;
  organization?: InputMaybe<ConnectUniqueInput>;
  originalDate?: InputMaybe<Scalars['Date']['input']>;
  startTime?: InputMaybe<Scalars['String']['input']>;
  studentAttendanceNotes?: InputMaybe<StudentAttendanceNoteManyInput>;
  students?: InputMaybe<UserManyInput>;
  studentsAdded?: InputMaybe<ConnectManyInput>;
  studentsAttended?: InputMaybe<ConnectManyInput>;
  studentsRemoved?: InputMaybe<ConnectManyInput>;
  zone?: InputMaybe<ConnectUniqueInput>;
};

export type AttendanceListRelationFilter = {
  every?: InputMaybe<AttendanceWhereInput>;
  none?: InputMaybe<AttendanceWhereInput>;
  some?: InputMaybe<AttendanceWhereInput>;
};

export type AttendanceOrderByInput = {
  date?: InputMaybe<SortOrder>;
};

export type AttendanceUpdatedPayload = {
  checkIns?: Maybe<Array<Maybe<UserSubscription>>>;
  class?: Maybe<ClassSubscription>;
  counts?: Maybe<Scalars['Json']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  organization?: Maybe<OrganizationSubscription>;
  students?: Maybe<Array<Maybe<UserSubscription>>>;
  studentsAdded?: Maybe<Array<Maybe<UserSubscription>>>;
  studentsAttended?: Maybe<Array<Maybe<UserSubscription>>>;
};

export type AttendanceWhereInput = {
  AND?: InputMaybe<AttendanceWhereInput>;
  NOT?: InputMaybe<AttendanceWhereInput>;
  OR?: InputMaybe<Array<AttendanceWhereInput>>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  checkIns?: InputMaybe<UserListRelationFilter>;
  class?: InputMaybe<ClassWhereInput>;
  classId?: InputMaybe<StringFilter>;
  date?: InputMaybe<DateFilter>;
  id?: InputMaybe<StringFilter>;
  instructors?: InputMaybe<UserListRelationFilter>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  originalDate?: InputMaybe<DateFilter>;
  students?: InputMaybe<UserListRelationFilter>;
  studentsAdded?: InputMaybe<UserListRelationFilter>;
};

export type AttendancesCountsPayload = {
  count?: Maybe<Scalars['Int']['output']>;
  instructors: Array<FilterItem>;
  location?: Maybe<Scalars['Json']['output']>;
  locations: Array<Location>;
  month?: Maybe<Scalars['Json']['output']>;
  programs: Array<FilterItem>;
  staff?: Maybe<Scalars['Json']['output']>;
  tags: Array<FilterItem>;
  times: Array<Scalars['String']['output']>;
  today?: Maybe<Scalars['Json']['output']>;
  week?: Maybe<Scalars['Json']['output']>;
  zone?: Maybe<Scalars['Json']['output']>;
  zones: Array<Zone>;
};

export const Audience = {
  Account: 'Account',
  Attendance: 'Attendance',
  Class: 'Class',
  GroupOffering: 'GroupOffering',
  MembershipOffering: 'MembershipOffering',
  Waitlist: 'Waitlist'
} as const;

export type Audience = typeof Audience[keyof typeof Audience];
export type AuditEvent = {
  actorEmail?: Maybe<Scalars['String']['output']>;
  actorId: Scalars['String']['output'];
  actorLevel?: Maybe<Scalars['String']['output']>;
  actorOrg?: Maybe<Scalars['String']['output']>;
  actorSource?: Maybe<Scalars['String']['output']>;
  changedAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  newData?: Maybe<Scalars['Json']['output']>;
  oldData?: Maybe<Scalars['Json']['output']>;
  operation: AuditOperation;
  requestId?: Maybe<Scalars['String']['output']>;
  rowId?: Maybe<Scalars['String']['output']>;
  tableName: Scalars['String']['output'];
};

export type AuditEventWhereInput = {
  actorId?: InputMaybe<Scalars['String']['input']>;
  actorLevel?: InputMaybe<Scalars['String']['input']>;
  actorOrg?: InputMaybe<Scalars['String']['input']>;
  actorSource?: InputMaybe<Scalars['String']['input']>;
  from?: InputMaybe<Scalars['Date']['input']>;
  operation?: InputMaybe<AuditOperation>;
  requestId?: InputMaybe<Scalars['String']['input']>;
  rowId?: InputMaybe<Scalars['String']['input']>;
  tableName?: InputMaybe<Scalars['String']['input']>;
  to?: InputMaybe<Scalars['Date']['input']>;
};

export const AuditOperation = {
  DELETE: 'DELETE',
  INSERT: 'INSERT',
  UPDATE: 'UPDATE'
} as const;

export type AuditOperation = typeof AuditOperation[keyof typeof AuditOperation];
export type AuthPayload = {
  isNewOrg?: Maybe<Scalars['Boolean']['output']>;
  token: Scalars['String']['output'];
  user: User;
};

export type BalanceAccount = {
  accountHolderId?: Maybe<Scalars['String']['output']>;
  available?: Maybe<Scalars['Int']['output']>;
  balance?: Maybe<Scalars['Int']['output']>;
  balanceAccountId: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['Date']['output']>;
  dateNegative?: Maybe<Scalars['Date']['output']>;
  default?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  lastTopUp?: Maybe<Scalars['Date']['output']>;
  organization?: Maybe<Organization>;
  pending?: Maybe<Scalars['Int']['output']>;
  pendingConnection?: Maybe<Scalars['Boolean']['output']>;
  refundCushion?: Maybe<Scalars['Int']['output']>;
  refundsAuthorized?: Maybe<Scalars['Boolean']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  testDebit?: Maybe<Scalars['Boolean']['output']>;
  transferInstrumentId?: Maybe<Scalars['String']['output']>;
  verified?: Maybe<Scalars['Boolean']['output']>;
};

export type BalanceAccountCreateInput = {
  default?: InputMaybe<Scalars['Boolean']['input']>;
  refundsAuthorized?: InputMaybe<Scalars['Boolean']['input']>;
  refundsAuthorizedAt?: InputMaybe<Scalars['Date']['input']>;
  refundsAuthorizedBy?: InputMaybe<ConnectUniqueInput>;
  testDebitAt?: InputMaybe<Scalars['Date']['input']>;
  testDebitWhitelistedAt?: InputMaybe<Scalars['Date']['input']>;
  testDebitWhitelistedBy?: InputMaybe<ConnectUniqueInput>;
};

export type BalanceAccountManyInput = {
  create?: InputMaybe<Array<BalanceAccountCreateInput>>;
  delete?: InputMaybe<Array<UniqueInput>>;
  update?: InputMaybe<Array<BalanceAccountUpdateInput>>;
};

export type BalanceAccountUpdateInput = {
  data?: InputMaybe<BalanceAccountCreateInput>;
  where?: InputMaybe<UniqueInput>;
};

export type BatchPayload = {
  count: Scalars['Int']['output'];
};

export const BetaAccessType = {
  Departments: 'Departments',
  Meets: 'Meets',
  Memberships: 'Memberships',
  PrivateLessons: 'PrivateLessons',
  Programming: 'Programming',
  Volunteers: 'Volunteers'
} as const;

export type BetaAccessType = typeof BetaAccessType[keyof typeof BetaAccessType];
export type BetaAccessTypeManyInput = {
  set: Array<BetaAccessType>;
};

export type BillingCategory = {
  active: Scalars['Boolean']['output'];
  addons: Array<Addon>;
  charges: Array<Charge>;
  classes: Array<Class>;
  createdAt: Scalars['Date']['output'];
  credits: Array<Credit>;
  department?: Maybe<Department>;
  departmentAnnualFees: Array<Department>;
  departmentId?: Maybe<Scalars['String']['output']>;
  excludeFromReports: Scalars['Boolean']['output'];
  fees: Array<Fee>;
  hideInFilters: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  invoiceItems: Array<InvoiceItem>;
  meets: Array<Meet>;
  membershipOfferings: Array<MembershipOffering>;
  offerings: Array<Offering>;
  offeringsAdditionalFee: Array<Offering>;
  order: Scalars['Int']['output'];
  organization?: Maybe<Organization>;
  organizationId?: Maybe<Scalars['String']['output']>;
  programs: Array<Program>;
  recurringCharges: Array<RecurringCharge>;
  recurringCredits: Array<RecurringCredit>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
};

export type BillingCategoryCreateInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  department?: InputMaybe<ConnectUniqueInput>;
  excludeFromReports?: InputMaybe<Scalars['Boolean']['input']>;
  hideInFilters?: InputMaybe<Scalars['Boolean']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<ConnectUniqueInput>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type BillingCategoryManyInput = {
  create?: InputMaybe<Array<InputMaybe<BillingCategoryCreateInput>>>;
  update?: InputMaybe<Array<InputMaybe<BillingCategoryUpdateInput>>>;
};

export type BillingCategoryNestedInput = {
  connect?: InputMaybe<UniqueInput>;
  create?: InputMaybe<BillingCategoryCreateInput>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BillingCategoryOrderByInput = {
  order?: InputMaybe<SortOrder>;
};

export type BillingCategoryUpdateInput = {
  data?: InputMaybe<BillingCategoryCreateInput>;
  where?: InputMaybe<UniqueInput>;
};

export type BillingCategoryWhereInput = {
  AND?: InputMaybe<BillingCategoryWhereInput>;
  NOT?: InputMaybe<BillingCategoryWhereInput>;
  OR?: InputMaybe<Array<BillingCategoryWhereInput>>;
  departmentId?: InputMaybe<StringFilter>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<StringFilter>;
};

export const BillingMethod = {
  Annual: 'Annual',
  Included: 'Included',
  Monthly: 'Monthly'
} as const;

export type BillingMethod = typeof BillingMethod[keyof typeof BillingMethod];
export type BulkClass = {
  addons?: Maybe<Scalars['Json']['output']>;
  agreements?: Maybe<Scalars['Json']['output']>;
  allowCustomerCancellation?: Maybe<Scalars['Int']['output']>;
  allowCustomerMove?: Maybe<Scalars['Int']['output']>;
  allowNonMembers?: Maybe<Scalars['Int']['output']>;
  attendedOnCheckIn?: Maybe<Scalars['Int']['output']>;
  autoEnroll?: Maybe<Scalars['Int']['output']>;
  chargeAmounts?: Maybe<Scalars['Int']['output']>;
  checkIn?: Maybe<Scalars['Int']['output']>;
  communications?: Maybe<Scalars['Json']['output']>;
  coupons?: Maybe<Scalars['Json']['output']>;
  discounts?: Maybe<Scalars['Json']['output']>;
  endDate?: Maybe<Scalars['Json']['output']>;
  excludedDates?: Maybe<Scalars['Json']['output']>;
  fees?: Maybe<Scalars['Json']['output']>;
  hideDefaultStaff?: Maybe<Scalars['Int']['output']>;
  infoRequests?: Maybe<Scalars['Json']['output']>;
  instructors?: Maybe<Scalars['Json']['output']>;
  maintainWaitlist?: Maybe<Scalars['Int']['output']>;
  maxAge?: Maybe<Scalars['Int']['output']>;
  maxAgeType?: Maybe<AgeType>;
  maxEnrollment?: Maybe<Scalars['Int']['output']>;
  membershipOfferings?: Maybe<Scalars['Json']['output']>;
  membershipPrices?: Maybe<Scalars['Json']['output']>;
  minAge?: Maybe<Scalars['Int']['output']>;
  minAgeType?: Maybe<AgeType>;
  prorateExcludedDates?: Maybe<Scalars['Int']['output']>;
  prorateInProgressClasses?: Maybe<Scalars['Int']['output']>;
  prorateStartEnd?: Maybe<Scalars['Int']['output']>;
  publishDate?: Maybe<Scalars['Date']['output']>;
  registrationAdjustments?: Maybe<Scalars['Json']['output']>;
  registrationClose?: Maybe<Scalars['Date']['output']>;
  registrationOpen?: Maybe<Scalars['Date']['output']>;
  requiresRegistration?: Maybe<Scalars['Int']['output']>;
  startDate?: Maybe<Scalars['Json']['output']>;
  tags?: Maybe<Scalars['Json']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
  totalPerDepartment?: Maybe<Scalars['Json']['output']>;
  unpublishDate?: Maybe<Scalars['Date']['output']>;
};

export type BulkClassCheckoutInput = {
  add?: InputMaybe<Scalars['Boolean']['input']>;
  itemId?: InputMaybe<Scalars['String']['input']>;
};

export type BulkClassCreateInput = {
  addons?: InputMaybe<BulkClassCheckoutInput>;
  agreements?: InputMaybe<BulkClassCheckoutInput>;
  allowCustomerCancellation?: InputMaybe<Scalars['Boolean']['input']>;
  allowCustomerMove?: InputMaybe<Scalars['Boolean']['input']>;
  allowNonMembers?: InputMaybe<Scalars['Boolean']['input']>;
  attendedOnCheckIn?: InputMaybe<Scalars['Boolean']['input']>;
  autoEnroll?: InputMaybe<Scalars['Boolean']['input']>;
  chargeOnCheckIn?: InputMaybe<Scalars['Boolean']['input']>;
  checkIn?: InputMaybe<Scalars['Boolean']['input']>;
  communications?: InputMaybe<BulkClassCheckoutInput>;
  coupons?: InputMaybe<BulkClassCheckoutInput>;
  discounts?: InputMaybe<BulkClassCheckoutInput>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  excludedDates?: InputMaybe<BulkClassExcludedDatesInput>;
  fees?: InputMaybe<BulkClassCheckoutInput>;
  freePresentation?: InputMaybe<Scalars['String']['input']>;
  hideDefaultStaff?: InputMaybe<Scalars['Boolean']['input']>;
  infoRequests?: InputMaybe<BulkClassCheckoutInput>;
  instructors?: InputMaybe<BulkClassCheckoutInput>;
  maintainWaitlist?: InputMaybe<Scalars['Boolean']['input']>;
  maxAge?: InputMaybe<Scalars['Int']['input']>;
  maxAgeType?: InputMaybe<AgeType>;
  maxEnrollment?: InputMaybe<Scalars['Int']['input']>;
  membershipOfferings?: InputMaybe<BulkClassCheckoutInput>;
  membershipPrices?: InputMaybe<BulkClassPriceInput>;
  minAge?: InputMaybe<Scalars['Int']['input']>;
  minAgeType?: InputMaybe<AgeType>;
  price?: InputMaybe<Scalars['Int']['input']>;
  pricePerCheckIn?: InputMaybe<Scalars['Int']['input']>;
  prorateExcludedDates?: InputMaybe<Scalars['Boolean']['input']>;
  prorateInProgressClasses?: InputMaybe<Scalars['Boolean']['input']>;
  prorateStartEnd?: InputMaybe<Scalars['Boolean']['input']>;
  publishDate?: InputMaybe<Scalars['Date']['input']>;
  registrationAdjustments?: InputMaybe<BulkClassRegistrationAdjustmentInput>;
  registrationClose?: InputMaybe<Scalars['Date']['input']>;
  registrationOpen?: InputMaybe<Scalars['Date']['input']>;
  requiresRegistration?: InputMaybe<Scalars['Boolean']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
  tags?: InputMaybe<BulkClassCheckoutInput>;
  unpublishDate?: InputMaybe<Scalars['Date']['input']>;
  waitlistCapacity?: InputMaybe<Scalars['Int']['input']>;
};

export type BulkClassExcludedDatesInput = {
  add?: InputMaybe<Scalars['Boolean']['input']>;
  excludedDate?: InputMaybe<Scalars['Date']['input']>;
  remove?: InputMaybe<Scalars['Boolean']['input']>;
  update?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BulkClassPriceInput = {
  add?: InputMaybe<Scalars['Boolean']['input']>;
  membershipOfferingId: Scalars['String']['input'];
  price: Scalars['Int']['input'];
};

export type BulkClassRegistrationAdjustmentInput = {
  add?: InputMaybe<Scalars['Boolean']['input']>;
  membershipOfferingId: Scalars['String']['input'];
  registrationClose?: InputMaybe<Scalars['Date']['input']>;
  registrationOpen?: InputMaybe<Scalars['Date']['input']>;
};

export type BulkClassWhereInput = {
  id?: InputMaybe<StringFilter>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
};

export type BulkDataBoolean = {
  false?: Maybe<Scalars['Int']['output']>;
  true?: Maybe<Scalars['Int']['output']>;
};

export type BulkEditOfferingsInput = {
  values?: InputMaybe<Scalars['Json']['input']>;
};

export type BulkEditOfferingsWhereInput = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  organization?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<OfferingStatus>;
  template?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BulkOrganization = {
  needs?: Maybe<Scalars['Json']['output']>;
  tags?: Maybe<Scalars['Json']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type BulkOrganizationCreateInput = {
  accountManager?: InputMaybe<Scalars['String']['input']>;
  needs?: InputMaybe<BulkClassCheckoutInput>;
  salesPerson?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<BulkClassCheckoutInput>;
};

export type BulkRegisterInput = {
  enroll: Array<Scalars['String']['input']>;
  groupOfferingId?: InputMaybe<Scalars['String']['input']>;
  membershipOfferingId?: InputMaybe<Scalars['String']['input']>;
  sendRegistrationEmail: Scalars['Boolean']['input'];
  waitlist: Array<Scalars['String']['input']>;
};

export const CapacityStatus = {
  Available: 'Available',
  Empty: 'Empty',
  Full: 'Full',
  Waitlist: 'Waitlist',
  WaitlistAvailable: 'WaitlistAvailable'
} as const;

export type CapacityStatus = typeof CapacityStatus[keyof typeof CapacityStatus];
export type CapacityStatusFilter = {
  equals?: InputMaybe<CapacityStatus>;
  in?: InputMaybe<Array<CapacityStatus>>;
  not?: InputMaybe<CapacityStatus>;
  notIn?: InputMaybe<Array<CapacityStatus>>;
};

export type CaptynFinancialReportCount = {
  accounts?: Maybe<Scalars['Int']['output']>;
  amount?: Maybe<Scalars['Int']['output']>;
  annual?: Maybe<Scalars['Int']['output']>;
  monthly?: Maybe<Scalars['Int']['output']>;
  oneTime?: Maybe<Scalars['Int']['output']>;
};

export const CaptynPlanType = {
  Bronze: 'Bronze',
  Custom: 'Custom',
  Enterprise: 'Enterprise',
  Gold: 'Gold',
  Individual: 'Individual',
  Silver: 'Silver'
} as const;

export type CaptynPlanType = typeof CaptynPlanType[keyof typeof CaptynPlanType];
export type CaptynUsersCountsPayload = {
  total?: Maybe<Scalars['Int']['output']>;
};

export type CaptynUsersInput = {
  access?: InputMaybe<Scalars['String']['input']>;
  level?: InputMaybe<Scalars['String']['input']>;
  management?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  q?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
};

export type Charge = {
  amount: Scalars['Int']['output'];
  appliesTo?: Maybe<AppliesToType>;
  billingCategory?: Maybe<BillingCategory>;
  billingCategoryId?: Maybe<Scalars['String']['output']>;
  class?: Maybe<Class>;
  classId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Date']['output'];
  createdBy?: Maybe<User>;
  createdById?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  invoiceItem?: Maybe<InvoiceItem>;
  invoiceItemId?: Maybe<Scalars['String']['output']>;
  membershipOffering?: Maybe<MembershipOffering>;
  membershipOfferingId?: Maybe<Scalars['String']['output']>;
  offering?: Maybe<Offering>;
  offeringId?: Maybe<Scalars['String']['output']>;
  organization?: Maybe<Organization>;
  organizationId?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Date']['output'];
  user?: Maybe<User>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type ChargeAmount = {
  atRegistration: Scalars['Boolean']['output'];
  class: Class;
  classId: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  date?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  membershipOffering?: Maybe<MembershipOffering>;
  membershipOfferingId?: Maybe<Scalars['String']['output']>;
  price: Scalars['Int']['output'];
  status: ChargeAmountStatus;
  updatedAt: Scalars['Date']['output'];
};

export type ChargeAmountCreateInput = {
  atRegistration?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  membershipOffering?: InputMaybe<ConnectUniqueInput>;
  price: Scalars['Int']['input'];
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type ChargeAmountManyInput = {
  create?: InputMaybe<Array<InputMaybe<ChargeAmountCreateInput>>>;
  delete?: InputMaybe<Array<InputMaybe<UniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<ChargeAmountUpdateInput>>>;
};

export const ChargeAmountStatus = {
  Pending: 'Pending',
  Processed: 'Processed'
} as const;

export type ChargeAmountStatus = typeof ChargeAmountStatus[keyof typeof ChargeAmountStatus];
export type ChargeAmountStatusFilter = {
  equals?: InputMaybe<ChargeAmountStatus>;
  in?: InputMaybe<Array<ChargeAmountStatus>>;
  not?: InputMaybe<ChargeAmountStatus>;
  notIn?: InputMaybe<Array<ChargeAmountStatus>>;
};

export type ChargeAmountUpdateInput = {
  data?: InputMaybe<ChargeAmountCreateInput>;
  where?: InputMaybe<UniqueInput>;
};

export type ChargeAmountWhereInput = {
  OR?: InputMaybe<Array<ChargeAmountWhereInput>>;
  atRegistration?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<ChargeAmountStatusFilter>;
};

export type ChargeCreateInput = {
  amount?: InputMaybe<Scalars['Int']['input']>;
  appliesTo?: InputMaybe<AppliesToType>;
  billingCategory?: InputMaybe<ConnectUniqueInput>;
  class?: InputMaybe<ConnectUniqueInput>;
  createdBy?: InputMaybe<ConnectUniqueInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  membershipOffering?: InputMaybe<ConnectUniqueInput>;
  offering?: InputMaybe<ConnectUniqueInput>;
  organization?: InputMaybe<ConnectUniqueInput>;
  user?: InputMaybe<ConnectUniqueInput>;
};

export type ChargeInvoiceInput = {
  id: Scalars['ID']['input'];
  send?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ChargeManyInput = {
  connect?: InputMaybe<Array<InputMaybe<UniqueInput>>>;
  create?: InputMaybe<Array<InputMaybe<ChargeCreateInput>>>;
  delete?: InputMaybe<Array<InputMaybe<UniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<ChargeUpdateInput>>>;
};

export type ChargeNestedInput = {
  create?: InputMaybe<ChargeCreateInput>;
};

export const ChargeType = {
  Account: 'Account',
  Participant: 'Participant'
} as const;

export type ChargeType = typeof ChargeType[keyof typeof ChargeType];
export type ChargeUpdateInput = {
  data?: InputMaybe<ChargeCreateInput>;
  where?: InputMaybe<UniqueInput>;
};

export type ChargeWhereInput = {
  billingCategoryId?: InputMaybe<Scalars['String']['input']>;
  departmentId?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
};

export type CheckIn = {
  createdAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  updatedAt: Scalars['Date']['output'];
  used: Scalars['Boolean']['output'];
  userId: Scalars['ID']['output'];
};

export type CheckInAdjustment = {
  amount?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  membershipOffering?: Maybe<MembershipOffering>;
  membershipOfferingId?: Maybe<Scalars['String']['output']>;
  type?: Maybe<TimeType>;
  updatedAt: Scalars['Date']['output'];
};

export type CheckInAdjustmentCreateInput = {
  amount?: InputMaybe<Scalars['Int']['input']>;
  membership?: InputMaybe<ConnectUniqueInput>;
  type?: InputMaybe<TimeType>;
};

export type CheckInAdjustmentManyInput = {
  create?: InputMaybe<Array<InputMaybe<CheckInAdjustmentCreateInput>>>;
  delete?: InputMaybe<Array<InputMaybe<UniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<CheckInAdjustmentUpdateInput>>>;
};

export type CheckInAdjustmentUpdateInput = {
  data?: InputMaybe<CheckInAdjustmentCreateInput>;
  where?: InputMaybe<UniqueInput>;
};

export type CheckInCreateInput = {
  used: Scalars['Boolean']['input'];
  userId: Scalars['ID']['input'];
};

export type CheckInManyInput = {
  create?: InputMaybe<Array<InputMaybe<CheckInCreateInput>>>;
  delete?: InputMaybe<Array<InputMaybe<UniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<CheckInUpdateInput>>>;
};

export type CheckInUpdateInput = {
  data: CheckInCreateInput;
  where: UniqueInput;
};

export type Checkout = {
  id: Scalars['ID']['output'];
};

export type CheckoutAccountOwnerInput = {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  lastName: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type CheckoutInput = {
  accountOwner: CheckoutAccountOwnerInput;
  agreements: Array<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
  stripeToken: CheckoutTokenInput;
};

export type CheckoutTokenInput = {
  brand: Scalars['String']['input'];
  expMonth: Scalars['Int']['input'];
  expYear: Scalars['Int']['input'];
  id: Scalars['String']['input'];
  last4: Scalars['String']['input'];
  name: Scalars['String']['input'];
  tokenId: Scalars['String']['input'];
};

export type Class = {
  active?: Maybe<Scalars['Boolean']['output']>;
  additionalFeeAmount?: Maybe<Scalars['Int']['output']>;
  additionalFeeBillingCategory?: Maybe<BillingCategory>;
  additionalFeeBillingCategoryId?: Maybe<Scalars['String']['output']>;
  additionalFeeTitle?: Maybe<Scalars['String']['output']>;
  addons: Array<Addon>;
  agreements: Array<Agreement>;
  allowAdditionalStudents?: Maybe<Scalars['Boolean']['output']>;
  allowCustomerCancellation?: Maybe<Scalars['Boolean']['output']>;
  allowCustomerMove?: Maybe<Scalars['Boolean']['output']>;
  allowNonMembers?: Maybe<Scalars['Boolean']['output']>;
  applyAnnualFee?: Maybe<Scalars['Boolean']['output']>;
  attendedAfterCheckIn: Scalars['Boolean']['output'];
  attendedOnCheckIn: Scalars['Boolean']['output'];
  autoEnroll?: Maybe<Scalars['Boolean']['output']>;
  capacity?: Maybe<CapacityStatus>;
  chargeAmounts: Array<ChargeAmount>;
  chargeOnCheckIn?: Maybe<Scalars['Boolean']['output']>;
  chargeType?: Maybe<ChargeType>;
  charges: Array<Charge>;
  checkIn: Scalars['Boolean']['output'];
  classTimes: Array<ClassTime>;
  collectTaxes?: Maybe<Scalars['Boolean']['output']>;
  communications: Array<Communication>;
  coupons: Array<Coupon>;
  createdAt: Scalars['Date']['output'];
  credits: Array<Credit>;
  customerCheckIn?: Maybe<Scalars['Boolean']['output']>;
  customerInfoRequests: Array<Scalars['String']['output']>;
  department?: Maybe<Department>;
  departmentId?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  discounts: Array<Discount>;
  displayDaysTimes: Scalars['Boolean']['output'];
  displayMembershipPricing: Scalars['Boolean']['output'];
  displayOpenSpots: Scalars['Boolean']['output'];
  earlyCheckIn?: Maybe<Scalars['Int']['output']>;
  earlyCheckInClose?: Maybe<Scalars['Int']['output']>;
  earlyCheckInCloseType?: Maybe<TimeType>;
  earlyCheckInType?: Maybe<TimeType>;
  endDate: Scalars['Date']['output'];
  entryLevel?: Maybe<Scalars['Boolean']['output']>;
  evaluationReminderFrequency?: Maybe<Scalars['Int']['output']>;
  excludedDates: Array<Scalars['Date']['output']>;
  fees: Array<Fee>;
  freePresentation?: Maybe<Scalars['String']['output']>;
  frequency?: Maybe<Frequency>;
  hideDefaultStaff?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  instructors: Array<User>;
  integration?: Maybe<IntegrationType>;
  location?: Maybe<Location>;
  locationId?: Maybe<Scalars['String']['output']>;
  maintainWaitlist?: Maybe<Scalars['Boolean']['output']>;
  maxAge?: Maybe<Scalars['Int']['output']>;
  maxAgeType?: Maybe<AgeType>;
  maxCheckIns?: Maybe<Scalars['Int']['output']>;
  maxEnrollment?: Maybe<Scalars['Int']['output']>;
  meetParticipation?: Maybe<Scalars['Boolean']['output']>;
  membershipCheckInPrices: Array<PriceAdjustment>;
  membershipCheckIns: Array<CheckInAdjustment>;
  membershipCheckInsClose: Array<CheckInAdjustment>;
  membershipOfferings: Array<MembershipOffering>;
  membershipPrices: Array<PriceAdjustment>;
  minAge?: Maybe<Scalars['Int']['output']>;
  minAgeType?: Maybe<AgeType>;
  multiClassDiscount?: Maybe<Scalars['Boolean']['output']>;
  multiStudentDiscount?: Maybe<Scalars['Boolean']['output']>;
  noClassTimes?: Maybe<Scalars['Boolean']['output']>;
  organization?: Maybe<Organization>;
  organizationId?: Maybe<Scalars['String']['output']>;
  participantType?: Maybe<Scalars['String']['output']>;
  paymentFrequency: Frequency;
  paymentRate: RateType;
  paymentReminderDays?: Maybe<Scalars['Int']['output']>;
  price: Scalars['Int']['output'];
  priceAdjustments: Array<PriceAdjustment>;
  priceForAdditionalStudents?: Maybe<Scalars['Int']['output']>;
  pricePerCheckIn?: Maybe<Scalars['Int']['output']>;
  private?: Maybe<Scalars['Boolean']['output']>;
  program: Program;
  programId?: Maybe<Scalars['String']['output']>;
  prorateExcludedDates: Scalars['Boolean']['output'];
  prorateInProgressClasses: Scalars['Boolean']['output'];
  prorateStartEnd: Scalars['Boolean']['output'];
  publishDate?: Maybe<Scalars['Date']['output']>;
  publishOnWebsite?: Maybe<Scalars['Boolean']['output']>;
  registrationAdjustments: Array<RegistrationAdjustment>;
  registrationClose?: Maybe<Scalars['Date']['output']>;
  registrationOpen?: Maybe<Scalars['Date']['output']>;
  registrations: Array<GroupRegistration>;
  requiredMembershipOfferings: Array<MembershipOffering>;
  requiresRegistration: Scalars['Boolean']['output'];
  requiresUSASwimming?: Maybe<Scalars['Boolean']['output']>;
  rosterSorting: RosterSorting;
  sendPaymentReminders?: Maybe<Scalars['Boolean']['output']>;
  showEvaluationReminders?: Maybe<Scalars['Boolean']['output']>;
  startDate: Scalars['Date']['output'];
  status?: Maybe<OfferingStatus>;
  studentInfoRequests: Array<StudentInfoRequest>;
  tags: Array<Tag>;
  templates: Array<Offering>;
  title?: Maybe<Scalars['String']['output']>;
  toCustomerRequests: Array<CustomerRequest>;
  type?: Maybe<Scalars['String']['output']>;
  unpublishDate?: Maybe<Scalars['Date']['output']>;
  updatedAt: Scalars['Date']['output'];
  viewOthers: Scalars['Boolean']['output'];
  waitlistCapacity?: Maybe<Scalars['Int']['output']>;
  zone?: Maybe<Zone>;
  zoneId?: Maybe<Scalars['String']['output']>;
};


export type ClasschargeAmountsArgs = {
  where?: InputMaybe<ChargeAmountWhereInput>;
};


export type ClassmembershipOfferingsArgs = {
  where?: InputMaybe<MembershipOfferingWhereInput>;
};


export type ClassregistrationsArgs = {
  where?: InputMaybe<GroupRegistrationWhereInput>;
};


export type ClasstoCustomerRequestsArgs = {
  where?: InputMaybe<CustomerRequestWhereInput>;
};

export type ClassCreateInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  additionalFeeAmount?: InputMaybe<Scalars['Int']['input']>;
  additionalFeeBillingCategory?: InputMaybe<ConnectUniqueInput>;
  additionalFeeTitle?: InputMaybe<Scalars['String']['input']>;
  addons?: InputMaybe<ConnectManyInput>;
  agreements?: InputMaybe<AgreementManyInput>;
  allowAdditionalStudents?: InputMaybe<Scalars['Boolean']['input']>;
  allowCustomerCancellation?: InputMaybe<Scalars['Boolean']['input']>;
  allowCustomerMove?: InputMaybe<Scalars['Boolean']['input']>;
  allowNonMembers?: InputMaybe<Scalars['Boolean']['input']>;
  applyAnnualFee?: InputMaybe<Scalars['Boolean']['input']>;
  attendedAfterCheckIn?: InputMaybe<Scalars['Boolean']['input']>;
  attendedOnCheckIn?: InputMaybe<Scalars['Boolean']['input']>;
  autoEnroll?: InputMaybe<Scalars['Boolean']['input']>;
  capacity?: InputMaybe<CapacityStatus>;
  chargeAmounts?: InputMaybe<ChargeAmountManyInput>;
  chargeOnCheckIn?: InputMaybe<Scalars['Boolean']['input']>;
  chargeType?: InputMaybe<ChargeType>;
  charges?: InputMaybe<ChargeManyInput>;
  checkIn?: InputMaybe<Scalars['Boolean']['input']>;
  classTimes?: InputMaybe<ClassTimeManyInput>;
  collectTaxes?: InputMaybe<Scalars['Boolean']['input']>;
  communications?: InputMaybe<CommunicationManyInput>;
  coupons?: InputMaybe<CouponManyInput>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  credits?: InputMaybe<CreditManyInput>;
  customerCheckIn?: InputMaybe<Scalars['Boolean']['input']>;
  customerInfoRequests?: InputMaybe<StringManyInput>;
  department?: InputMaybe<ConnectUniqueInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  discounts?: InputMaybe<ConnectManyInput>;
  displayDaysTimes?: InputMaybe<Scalars['Boolean']['input']>;
  displayMembershipPricing?: InputMaybe<Scalars['Boolean']['input']>;
  displayOpenSpots?: InputMaybe<Scalars['Boolean']['input']>;
  earlyCheckIn?: InputMaybe<Scalars['Int']['input']>;
  earlyCheckInClose?: InputMaybe<Scalars['Int']['input']>;
  earlyCheckInCloseType?: InputMaybe<TimeType>;
  earlyCheckInType?: InputMaybe<TimeType>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  entryLevel?: InputMaybe<Scalars['Boolean']['input']>;
  evaluationReminderFrequency?: InputMaybe<Scalars['Int']['input']>;
  excludedDates?: InputMaybe<DateManyInput>;
  fees?: InputMaybe<FeeManyInput>;
  freePresentation?: InputMaybe<Scalars['String']['input']>;
  frequency?: InputMaybe<Frequency>;
  hideDefaultStaff?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  instructors?: InputMaybe<UserManyInput>;
  integration?: InputMaybe<IntegrationType>;
  location?: InputMaybe<ConnectUniqueInput>;
  maintainWaitlist?: InputMaybe<Scalars['Boolean']['input']>;
  maxAge?: InputMaybe<Scalars['Int']['input']>;
  maxAgeType?: InputMaybe<AgeType>;
  maxCheckIns?: InputMaybe<Scalars['Int']['input']>;
  maxEnrollment?: InputMaybe<Scalars['Int']['input']>;
  meetParticipation?: InputMaybe<Scalars['Boolean']['input']>;
  membershipCheckInPrices?: InputMaybe<PriceAdjustmentManyInput>;
  membershipCheckIns?: InputMaybe<CheckInAdjustmentManyInput>;
  membershipCheckInsClose?: InputMaybe<CheckInAdjustmentManyInput>;
  membershipOfferings?: InputMaybe<ConnectManyInput>;
  membershipPrices?: InputMaybe<PriceAdjustmentManyInput>;
  minAge?: InputMaybe<Scalars['Int']['input']>;
  minAgeType?: InputMaybe<AgeType>;
  multiClassDiscount?: InputMaybe<Scalars['Boolean']['input']>;
  multiStudentDiscount?: InputMaybe<Scalars['Boolean']['input']>;
  noClassTimes?: InputMaybe<Scalars['Boolean']['input']>;
  organization?: InputMaybe<ConnectUniqueInput>;
  participantType?: InputMaybe<Scalars['String']['input']>;
  paymentFrequency?: InputMaybe<Frequency>;
  paymentRate?: InputMaybe<RateType>;
  paymentReminderDays?: InputMaybe<Scalars['Int']['input']>;
  price?: InputMaybe<Scalars['Int']['input']>;
  priceAdjustments?: InputMaybe<PriceAdjustmentManyInput>;
  priceForAdditionalStudents?: InputMaybe<Scalars['Int']['input']>;
  pricePerCheckIn?: InputMaybe<Scalars['Int']['input']>;
  private?: InputMaybe<Scalars['Boolean']['input']>;
  program?: InputMaybe<ProgramConnectCreateInput>;
  prorateExcludedDates?: InputMaybe<Scalars['Boolean']['input']>;
  prorateInProgressClasses?: InputMaybe<Scalars['Boolean']['input']>;
  prorateStartEnd?: InputMaybe<Scalars['Boolean']['input']>;
  publishDate?: InputMaybe<Scalars['Date']['input']>;
  publishOnWebsite?: InputMaybe<Scalars['Boolean']['input']>;
  registrationAdjustments?: InputMaybe<RegistrationAdjustmentManyInput>;
  registrationClose?: InputMaybe<Scalars['Date']['input']>;
  registrationOpen?: InputMaybe<Scalars['Date']['input']>;
  requiredMembershipOfferings?: InputMaybe<ConnectManyInput>;
  requiresRegistration?: InputMaybe<Scalars['Boolean']['input']>;
  requiresUSASwimming?: InputMaybe<Scalars['Boolean']['input']>;
  rosterSorting?: InputMaybe<RosterSorting>;
  sendPaymentReminders?: InputMaybe<Scalars['Boolean']['input']>;
  showEvaluationReminders?: InputMaybe<Scalars['Boolean']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
  status?: InputMaybe<OfferingStatus>;
  studentInfoRequests?: InputMaybe<StudentInfoRequestManyInput>;
  tags?: InputMaybe<TagManyInput>;
  templates?: InputMaybe<ConnectManyInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  unpublishDate?: InputMaybe<Scalars['Date']['input']>;
  viewOthers?: InputMaybe<Scalars['Boolean']['input']>;
  waitlistCapacity?: InputMaybe<Scalars['Int']['input']>;
  zone?: InputMaybe<ConnectUniqueInput>;
};

export type ClassListRelationFilter = {
  every?: InputMaybe<ClassWhereInput>;
  none?: InputMaybe<ClassWhereInput>;
  some?: InputMaybe<ClassWhereInput>;
};

export type ClassManyInput = {
  connect?: InputMaybe<Array<InputMaybe<UniqueInput>>>;
  delete?: InputMaybe<Array<InputMaybe<UniqueInput>>>;
};

export type ClassNestedInput = {
  connect?: InputMaybe<UniqueInput>;
  update?: InputMaybe<ClassCreateInput>;
};

export type ClassOrderByInput = {
  createdAt?: InputMaybe<SortOrder>;
  startDate?: InputMaybe<SortOrder>;
};

export type ClassStatsInput = {
  endDate?: InputMaybe<Scalars['Date']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  startDate?: InputMaybe<Scalars['Date']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type ClassStatsPayload = {
  accountOwners?: Maybe<Scalars['Json']['output']>;
  billable?: Maybe<Scalars['Int']['output']>;
  coupons?: Maybe<Scalars['Int']['output']>;
  credits?: Maybe<Scalars['Int']['output']>;
  discounts?: Maybe<Scalars['Int']['output']>;
  due?: Maybe<Scalars['Int']['output']>;
  globalAddons?: Maybe<Scalars['Int']['output']>;
  globalAgreements?: Maybe<Scalars['Int']['output']>;
  globalCoupons: Array<Scalars['String']['output']>;
  globalDiscounts?: Maybe<Scalars['Int']['output']>;
  globalFees?: Maybe<Scalars['Int']['output']>;
  globalStudentInfoRequests?: Maybe<Scalars['Int']['output']>;
  net?: Maybe<Scalars['Int']['output']>;
  paid?: Maybe<Scalars['Int']['output']>;
  refunds?: Maybe<Scalars['Int']['output']>;
};

export type ClassSubscription = {
  checkIn?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type ClassTime = {
  active?: Maybe<Scalars['Boolean']['output']>;
  allDayPresentation?: Maybe<Scalars['String']['output']>;
  atAccountHome: Scalars['Boolean']['output'];
  class?: Maybe<Class>;
  classId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Date']['output'];
  date?: Maybe<Scalars['Date']['output']>;
  day?: Maybe<Day>;
  disableAttendance?: Maybe<Scalars['Boolean']['output']>;
  endTime?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  instructors: Array<User>;
  location?: Maybe<Location>;
  locationId?: Maybe<Scalars['String']['output']>;
  offering?: Maybe<Offering>;
  offeringId?: Maybe<Scalars['String']['output']>;
  startTime?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Date']['output'];
  zone?: Maybe<Zone>;
  zoneId?: Maybe<Scalars['String']['output']>;
};

export type ClassTimeCreateInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  allDayPresentation?: InputMaybe<Scalars['String']['input']>;
  atAccountHome?: InputMaybe<Scalars['Boolean']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  day?: InputMaybe<Day>;
  disableAttendance?: InputMaybe<Scalars['Boolean']['input']>;
  endTime?: InputMaybe<Scalars['String']['input']>;
  instructors?: InputMaybe<ConnectManyInput>;
  location?: InputMaybe<LocationNestedInput>;
  startTime?: InputMaybe<Scalars['String']['input']>;
  zone?: InputMaybe<ConnectUniqueInput>;
};

export type ClassTimeManyInput = {
  create?: InputMaybe<Array<InputMaybe<ClassTimeCreateInput>>>;
  delete?: InputMaybe<Array<InputMaybe<UniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<ClassTimeUpdateInput>>>;
};

export type ClassTimeUpdateInput = {
  data?: InputMaybe<ClassTimeCreateInput>;
  where?: InputMaybe<UniqueInput>;
};

export type ClassWhereInput = {
  AND?: InputMaybe<Array<ClassWhereInput>>;
  NOT?: InputMaybe<ClassWhereInput>;
  OR?: InputMaybe<Array<ClassWhereInput>>;
  allowNonMembers?: InputMaybe<Scalars['Boolean']['input']>;
  capacity?: InputMaybe<CapacityStatusFilter>;
  checkIn?: InputMaybe<Scalars['Boolean']['input']>;
  departmentId?: InputMaybe<StringFilter>;
  endDate?: InputMaybe<DateFilter>;
  id?: InputMaybe<StringFilter>;
  instructors?: InputMaybe<UserListRelationFilter>;
  integration?: InputMaybe<IntegrationType>;
  locationId?: InputMaybe<StringFilter>;
  meetParticipation?: InputMaybe<Scalars['Boolean']['input']>;
  membershipOfferings?: InputMaybe<MembershipOfferingListRelationFilter>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  programId?: InputMaybe<StringFilter>;
  publishDate?: InputMaybe<DateFilter>;
  registrationClose?: InputMaybe<DateFilter>;
  registrationOpen?: InputMaybe<DateFilter>;
  registrations?: InputMaybe<GroupRegistrationListRelationFilter>;
  requiresRegistration?: InputMaybe<Scalars['Boolean']['input']>;
  startDate?: InputMaybe<DateFilter>;
  status?: InputMaybe<OfferingStatusFilter>;
  unpublishDate?: InputMaybe<DateFilter>;
};

export type CommissionCount = {
  amount?: Maybe<Scalars['Int']['output']>;
  user?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['ID']['output']>;
};

export type CommissionSetting = {
  amount?: Maybe<Scalars['Float']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  endDate?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  startDate?: Maybe<Scalars['Date']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  user?: Maybe<User>;
};

export type CommissionSettingInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
  user?: InputMaybe<ConnectUniqueInput>;
};

export type CommissionSettingManyInput = {
  create?: InputMaybe<Array<CommissionSettingInput>>;
  delete?: InputMaybe<Array<UniqueInput>>;
  update?: InputMaybe<Array<CommissionSettingUpdateInput>>;
};

export type CommissionSettingUpdateInput = {
  data?: InputMaybe<CommissionSettingInput>;
  where?: InputMaybe<UniqueInput>;
};

export type Communication = {
  audience: Audience;
  availableForAllOfferings: Scalars['Boolean']['output'];
  cc: Scalars['String']['output'];
  copy: Scalars['Boolean']['output'];
  counts?: Maybe<CommunicationCounts>;
  createdAt: Scalars['Date']['output'];
  createdBy?: Maybe<User>;
  date: Scalars['Date']['output'];
  department?: Maybe<Department>;
  departmentId?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  enabledByDefault: Scalars['Boolean']['output'];
  files: Array<File>;
  from: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  manualGroupOfferings: Array<Class>;
  marketing: Scalars['Boolean']['output'];
  recipientTypes: Array<RecipientType>;
  ruleAmount: Scalars['Int']['output'];
  ruleAmountType: TimeType;
  scheduled: Array<ScheduledCommunication>;
  send: Scalars['Boolean']['output'];
  sendTime: SendTime;
  sendType: SendType;
  subject: Scalars['String']['output'];
  template?: Maybe<CommunicationTemplate>;
  title: Scalars['String']['output'];
  type: NotificationType;
  updatedAt: Scalars['Date']['output'];
};

export type CommunicationCounts = {
  groupOfferings: Scalars['Int']['output'];
  membershipOfferings: Scalars['Int']['output'];
  privateOfferings: Scalars['Int']['output'];
  sent: Scalars['Int']['output'];
};

export type CommunicationCreateInput = {
  audience?: InputMaybe<Audience>;
  availableForAllOfferings?: InputMaybe<Scalars['Boolean']['input']>;
  cc?: InputMaybe<Scalars['String']['input']>;
  copy?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<ConnectUniqueInput>;
  date?: InputMaybe<Scalars['Date']['input']>;
  department?: InputMaybe<ConnectUniqueInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  enabledByDefault?: InputMaybe<Scalars['Boolean']['input']>;
  files?: InputMaybe<FileManyInput>;
  filter?: InputMaybe<Scalars['String']['input']>;
  from?: InputMaybe<Scalars['String']['input']>;
  manualGroupOfferings?: InputMaybe<ClassManyInput>;
  marketing?: InputMaybe<Scalars['Boolean']['input']>;
  organization?: InputMaybe<ConnectUniqueInput>;
  recipientTypes?: InputMaybe<RecipientTypeManyInput>;
  ruleAmount?: InputMaybe<Scalars['Int']['input']>;
  ruleAmountType?: InputMaybe<TimeType>;
  scheduled?: InputMaybe<ScheduledCommunicationManyInput>;
  send?: InputMaybe<Scalars['Boolean']['input']>;
  sendTime?: InputMaybe<SendTime>;
  sendType?: InputMaybe<SendType>;
  subject?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<NotificationType>;
};

export type CommunicationManyInput = {
  connect?: InputMaybe<Array<InputMaybe<UniqueInput>>>;
  create?: InputMaybe<Array<InputMaybe<CommunicationCreateInput>>>;
  delete?: InputMaybe<Array<InputMaybe<UniqueInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<UniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<UniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<CommunicationUpdateInput>>>;
};

export const CommunicationTemplate = {
  CancellationConfirmation: 'CancellationConfirmation',
  ClassCancelled: 'ClassCancelled',
  CustomerAccountCreation: 'CustomerAccountCreation',
  DepartmentWelcome: 'DepartmentWelcome',
  EnrollmentConfirmation: 'EnrollmentConfirmation',
  LessonSeriesCompleted: 'LessonSeriesCompleted',
  PaymentFailed: 'PaymentFailed',
  PrivateLessonScheduled: 'PrivateLessonScheduled',
  ReceiptOfRegistration: 'ReceiptOfRegistration',
  WaitlistApproval: 'WaitlistApproval'
} as const;

export type CommunicationTemplate = typeof CommunicationTemplate[keyof typeof CommunicationTemplate];
export type CommunicationUpdateInput = {
  data?: InputMaybe<CommunicationCreateInput>;
  where?: InputMaybe<UniqueInput>;
};

export type CommunicationWhereInput = {
  AND?: InputMaybe<CommunicationWhereInput>;
  NOT?: InputMaybe<CommunicationWhereInput>;
  OR?: InputMaybe<Array<CommunicationWhereInput>>;
  departmentId?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  template?: InputMaybe<StringFilter>;
};

export type ConnectManyInput = {
  connect?: InputMaybe<Array<InputMaybe<UniqueInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<UniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<UniqueInput>>>;
};

export type ConnectStripeAccountInput = {
  code: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
};

export type ConnectStripeAccountPayload = {
  id?: Maybe<Scalars['String']['output']>;
};

export type ConnectUniqueInput = {
  connect?: InputMaybe<UniqueInput>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Coupon = {
  active: Scalars['Boolean']['output'];
  amount: Scalars['Int']['output'];
  amountType: AmountType;
  applyAtCheckout: Scalars['Boolean']['output'];
  applyOnce: Scalars['Boolean']['output'];
  availableForAllOfferings: Scalars['Boolean']['output'];
  code: Scalars['String']['output'];
  counts?: Maybe<CouponCountPayload>;
  createdAt: Scalars['Date']['output'];
  createdBy?: Maybe<User>;
  department?: Maybe<Department>;
  departmentId?: Maybe<Scalars['String']['output']>;
  enabledByDefault?: Maybe<Scalars['Boolean']['output']>;
  expirationDate: Scalars['Date']['output'];
  frequency: Frequency;
  id: Scalars['ID']['output'];
  maxAccountRedemptions: Scalars['Int']['output'];
  maxRedemptions: Scalars['Int']['output'];
  organization?: Maybe<Organization>;
  organizationId?: Maybe<Scalars['String']['output']>;
  startDate: Scalars['Date']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
};

export type CouponCountPayload = {
  offerings: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  usage: Scalars['Int']['output'];
};

export type CouponCreateInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  amount: Scalars['Int']['input'];
  amountType: AmountType;
  applyAtCheckout?: InputMaybe<Scalars['Boolean']['input']>;
  applyOnce?: InputMaybe<Scalars['Boolean']['input']>;
  availableForAllOfferings: Scalars['Boolean']['input'];
  classes?: InputMaybe<ConnectManyInput>;
  code: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  createdBy?: InputMaybe<ConnectUniqueInput>;
  department?: InputMaybe<ConnectUniqueInput>;
  enabledByDefault?: InputMaybe<Scalars['Boolean']['input']>;
  expirationDate: Scalars['Date']['input'];
  frequency: Frequency;
  maxAccountRedemptions?: InputMaybe<Scalars['Int']['input']>;
  maxRedemptions?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<ConnectUniqueInput>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
  title: Scalars['String']['input'];
};

export type CouponManyInput = {
  connect?: InputMaybe<Array<InputMaybe<UniqueInput>>>;
  create?: InputMaybe<Array<InputMaybe<CouponCreateInput>>>;
  delete?: InputMaybe<Array<InputMaybe<UniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<UniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<CouponUpdateInput>>>;
};

export type CouponUpdateInput = {
  data?: InputMaybe<CouponCreateInput>;
  where?: InputMaybe<UniqueInput>;
};

export type CouponWhereInput = {
  AND?: InputMaybe<CouponWhereInput>;
  NOT?: InputMaybe<CouponWhereInput>;
  OR?: InputMaybe<Array<CouponWhereInput>>;
  departmentId?: InputMaybe<Scalars['String']['input']>;
  expirationDate?: InputMaybe<DateFilter>;
  frequency?: InputMaybe<Frequency>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateEvaluationPdfInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  date: Scalars['String']['input'];
  instructorName: Scalars['String']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  organizationTitle: Scalars['String']['input'];
  programDescription?: InputMaybe<Scalars['String']['input']>;
  skills?: InputMaybe<Scalars['Json']['input']>;
  studentAge: Scalars['Int']['input'];
  studentName: Scalars['String']['input'];
};

export type CreateEvaluationPdfPayload = {
  id?: Maybe<Scalars['ID']['output']>;
  response?: Maybe<Scalars['Json']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type CreateInvoicePdfInput = {
  variables: Scalars['Json']['input'];
};

export type CreateInvoicePdfPayload = {
  id?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type Credit = {
  amount: Scalars['Int']['output'];
  billingCategory?: Maybe<BillingCategory>;
  billingCategoryId?: Maybe<Scalars['String']['output']>;
  class?: Maybe<Class>;
  classId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Date']['output'];
  createdBy?: Maybe<User>;
  createdById?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  events: Array<CreditEvent>;
  id: Scalars['ID']['output'];
  invoiceItemCredits: Array<InvoiceItemCredit>;
  issuedAmount: Scalars['Int']['output'];
  membershipOffering?: Maybe<MembershipOffering>;
  membershipOfferingId?: Maybe<Scalars['String']['output']>;
  offering?: Maybe<Offering>;
  offeringId?: Maybe<Scalars['String']['output']>;
  organization?: Maybe<Organization>;
  organizationId?: Maybe<Scalars['String']['output']>;
  recurringCredit?: Maybe<RecurringCredit>;
  recurringCreditId?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Date']['output'];
  user?: Maybe<User>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type CreditCreateInput = {
  amount?: InputMaybe<Scalars['Int']['input']>;
  billingCategory?: InputMaybe<ConnectUniqueInput>;
  class?: InputMaybe<ConnectUniqueInput>;
  createdBy?: InputMaybe<ConnectUniqueInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  events?: InputMaybe<CreditEventManyInput>;
  issuedAmount?: InputMaybe<Scalars['Int']['input']>;
  membershipOffering?: InputMaybe<ConnectUniqueInput>;
  offering?: InputMaybe<ConnectUniqueInput>;
  organization?: InputMaybe<ConnectUniqueInput>;
  recurringCredit?: InputMaybe<ConnectUniqueInput>;
  user?: InputMaybe<ConnectUniqueInput>;
};

export type CreditEvent = {
  amount: Scalars['Int']['output'];
  createdAt: Scalars['Date']['output'];
  createdBy: User;
  id: Scalars['ID']['output'];
  type: CreditEventType;
  updatedAt: Scalars['Date']['output'];
};

export type CreditEventCreateInput = {
  amount?: InputMaybe<Scalars['Int']['input']>;
  createdBy?: InputMaybe<ConnectUniqueInput>;
  type?: InputMaybe<CreditEventType>;
};

export type CreditEventManyInput = {
  create?: InputMaybe<Array<InputMaybe<CreditEventCreateInput>>>;
};

export const CreditEventType = {
  Deleted: 'Deleted',
  Edited: 'Edited'
} as const;

export type CreditEventType = typeof CreditEventType[keyof typeof CreditEventType];
export type CreditEventUpdateInput = {
  data?: InputMaybe<CreditEventCreateInput>;
  where?: InputMaybe<UniqueInput>;
};

export type CreditManyInput = {
  connect?: InputMaybe<Array<InputMaybe<UniqueInput>>>;
  create?: InputMaybe<Array<InputMaybe<CreditCreateInput>>>;
  delete?: InputMaybe<Array<InputMaybe<UniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<CreditUpdateInput>>>;
};

export type CreditUpdateInput = {
  data?: InputMaybe<CreditCreateInput>;
  where?: InputMaybe<UniqueInput>;
};

export type CustomerInfoRequestResponse = {
  answer?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Date']['output'];
  groupRegistration?: Maybe<GroupRegistration>;
  groupRegistrationId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  privateSerie?: Maybe<PrivateSerie>;
  privateSerieId?: Maybe<Scalars['String']['output']>;
  question?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Date']['output'];
  user?: Maybe<User>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type CustomerInfoRequestResponseCreateInput = {
  answer?: InputMaybe<Scalars['String']['input']>;
  question?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<ConnectUniqueInput>;
};

export type CustomerInfoRequestResponseManyInput = {
  connect?: InputMaybe<Array<InputMaybe<UniqueInput>>>;
  create?: InputMaybe<Array<InputMaybe<CustomerInfoRequestResponseCreateInput>>>;
  update?: InputMaybe<Array<InputMaybe<CustomerInfoRequestResponseUpdateInput>>>;
};

export type CustomerInfoRequestResponseUpdateInput = {
  data?: InputMaybe<CustomerInfoRequestResponseCreateInput>;
  where?: InputMaybe<UniqueInput>;
};

export type CustomerRequest = {
  accountOwner?: Maybe<User>;
  accountOwnerId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Date']['output'];
  description?: Maybe<Scalars['String']['output']>;
  finalDate?: Maybe<Scalars['Date']['output']>;
  groupRegistration?: Maybe<GroupRegistration>;
  groupRegistrationId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  membership?: Maybe<Membership>;
  membershipId?: Maybe<Scalars['String']['output']>;
  organization?: Maybe<Organization>;
  organizationId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<CustomerRequestStatus>;
  student?: Maybe<User>;
  studentId?: Maybe<Scalars['String']['output']>;
  toClass?: Maybe<Class>;
  toClassId?: Maybe<Scalars['String']['output']>;
  type?: Maybe<CustomerRequestType>;
  updatedAt: Scalars['Date']['output'];
};

export type CustomerRequestCreateInput = {
  accountOwner?: InputMaybe<ConnectUniqueInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  finalDate?: InputMaybe<Scalars['Date']['input']>;
  groupRegistration?: InputMaybe<ConnectUniqueInput>;
  membership?: InputMaybe<ConnectUniqueInput>;
  organization?: InputMaybe<ConnectUniqueInput>;
  status?: InputMaybe<CustomerRequestStatus>;
  student?: InputMaybe<ConnectUniqueInput>;
  toClass?: InputMaybe<ConnectUniqueInput>;
  type?: InputMaybe<CustomerRequestType>;
};

export type CustomerRequestNestedInput = {
  update?: InputMaybe<CustomerRequestCreateInput>;
};

export const CustomerRequestStatus = {
  Approved: 'Approved',
  Declined: 'Declined',
  Pending: 'Pending'
} as const;

export type CustomerRequestStatus = typeof CustomerRequestStatus[keyof typeof CustomerRequestStatus];
export type CustomerRequestStatusFilter = {
  equals?: InputMaybe<CustomerRequestStatus>;
  in?: InputMaybe<Array<CustomerRequestStatus>>;
  not?: InputMaybe<CustomerRequestStatus>;
  notIn?: InputMaybe<Array<CustomerRequestStatus>>;
};

export const CustomerRequestType = {
  Cancel: 'Cancel',
  Move: 'Move'
} as const;

export type CustomerRequestType = typeof CustomerRequestType[keyof typeof CustomerRequestType];
export type CustomerRequestUpdateInput = {
  data?: InputMaybe<CustomerRequestCreateInput>;
  where?: InputMaybe<UniqueInput>;
};

export type CustomerRequestWhereInput = {
  AND?: InputMaybe<CustomerRequestWhereInput>;
  NOT?: InputMaybe<CustomerRequestWhereInput>;
  OR?: InputMaybe<Array<CustomerRequestWhereInput>>;
  status?: InputMaybe<CustomerRequestStatusFilter>;
  type?: InputMaybe<CustomerRequestType>;
};

export type CustomerServiceItem = {
  additionalData?: Maybe<Scalars['Json']['output']>;
  createdAt: Scalars['Date']['output'];
  evaluation?: Maybe<Evaluation>;
  evaluationId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  integration?: Maybe<Scalars['Json']['output']>;
  membershipOffering?: Maybe<MembershipOffering>;
  organization?: Maybe<Organization>;
  organizationId?: Maybe<Scalars['String']['output']>;
  payment?: Maybe<Payment>;
  privateSerie?: Maybe<PrivateSerie>;
  privateSerieAttendance?: Maybe<PrivateSerieAttendance>;
  privateSerieAttendanceId?: Maybe<Scalars['String']['output']>;
  privateSerieId?: Maybe<Scalars['String']['output']>;
  recurringCharge?: Maybe<RecurringCharge>;
  recurringChargeId?: Maybe<Scalars['String']['output']>;
  recurringCredit?: Maybe<RecurringCredit>;
  recurringCreditId?: Maybe<Scalars['String']['output']>;
  type?: Maybe<CustomerServiceItemType>;
  unread?: Maybe<Scalars['Boolean']['output']>;
  updatedAt: Scalars['Date']['output'];
  user?: Maybe<User>;
  userId?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type CustomerServiceItemCreateInput = {
  integration?: InputMaybe<Scalars['Json']['input']>;
  organization?: InputMaybe<ConnectUniqueInput>;
  privateSerie?: InputMaybe<ConnectUniqueInput>;
  type?: InputMaybe<CustomerServiceItemType>;
  unread?: InputMaybe<Scalars['Boolean']['input']>;
  user?: InputMaybe<ConnectUniqueInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export const CustomerServiceItemType = {
  AttendanceNeedComplete: 'AttendanceNeedComplete',
  Dispute: 'Dispute',
  DisputeReversed: 'DisputeReversed',
  EvaluationWithDifferentProgram: 'EvaluationWithDifferentProgram',
  ExpiredCard: 'ExpiredCard',
  IntegrationCancel: 'IntegrationCancel',
  IntegrationExpiration: 'IntegrationExpiration',
  IntegrationMerge: 'IntegrationMerge',
  IntegrationNewUser: 'IntegrationNewUser',
  NoPaymentInformation: 'NoPaymentInformation',
  OutstandingBalance: 'OutstandingBalance',
  RecurringWithoutRegistration: 'RecurringWithoutRegistration',
  SeriesForClaim: 'SeriesForClaim',
  SeriesNeedScheduling: 'SeriesNeedScheduling'
} as const;

export type CustomerServiceItemType = typeof CustomerServiceItemType[keyof typeof CustomerServiceItemType];
export type CustomerServiceItemTypeFilter = {
  equals?: InputMaybe<CustomerServiceItemType>;
  in?: InputMaybe<Array<CustomerServiceItemType>>;
  not?: InputMaybe<CustomerServiceItemType>;
  notIn?: InputMaybe<Array<CustomerServiceItemType>>;
};

export type CustomerServiceItemWhereInput = {
  AND?: InputMaybe<CustomerServiceItemWhereInput>;
  NOT?: InputMaybe<CustomerServiceItemWhereInput>;
  OR?: InputMaybe<Array<CustomerServiceItemWhereInput>>;
  id?: InputMaybe<StringFilter>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<CustomerServiceItemTypeFilter>;
  unread?: InputMaybe<Scalars['Boolean']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type DateFilter = {
  equals?: InputMaybe<Scalars['Date']['input']>;
  gt?: InputMaybe<Scalars['Date']['input']>;
  gte?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<Scalars['Date']['input']>>;
  lt?: InputMaybe<Scalars['Date']['input']>;
  lte?: InputMaybe<Scalars['Date']['input']>;
  not?: InputMaybe<Scalars['Date']['input']>;
  notIn?: InputMaybe<Array<Scalars['Date']['input']>>;
};

export type DateManyInput = {
  set: Array<Scalars['Date']['input']>;
};

export const Day = {
  Friday: 'Friday',
  Monday: 'Monday',
  Saturday: 'Saturday',
  Sunday: 'Sunday',
  Thursday: 'Thursday',
  Tuesday: 'Tuesday',
  Wednesday: 'Wednesday'
} as const;

export type Day = typeof Day[keyof typeof Day];
export type DayFilter = {
  equals?: InputMaybe<Day>;
  in?: InputMaybe<Array<Day>>;
  not?: InputMaybe<Day>;
  notIn?: InputMaybe<Array<Day>>;
};

export type DayManyInput = {
  set: Array<Day>;
};

export type DefaultOrderByInput = {
  createdAt?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type DefaultWhereInput = {
  departmentId?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
};

export type DeleteStripeSourceInput = {
  stripeTokenId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type DeleteStripeSourcePayload = {
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type Department = {
  active?: Maybe<Scalars['Boolean']['output']>;
  allowMultipleCoupons?: Maybe<Scalars['Boolean']['output']>;
  annualFeeAmount?: Maybe<Scalars['Int']['output']>;
  annualFeeAtBeginningOfYear?: Maybe<Scalars['Boolean']['output']>;
  annualFeeBillingCategory?: Maybe<BillingCategory>;
  annualFeeBillingCategoryId?: Maybe<Scalars['String']['output']>;
  annualFeeCanBeAppliedAtOfferingLevel?: Maybe<Scalars['Boolean']['output']>;
  annualFeeMax?: Maybe<Scalars['Int']['output']>;
  annualFeeType?: Maybe<AnnualFeeType>;
  balanceAccountId?: Maybe<Scalars['String']['output']>;
  billingCategories: Array<BillingCategory>;
  classes: Array<Class>;
  contactName?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Date']['output'];
  default: Scalars['Boolean']['output'];
  email?: Maybe<Scalars['String']['output']>;
  filters: Array<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  meetAccess?: Maybe<Scalars['Boolean']['output']>;
  membershipOfferings: Array<MembershipOffering>;
  offerings: Array<Offering>;
  order: Scalars['Int']['output'];
  organization?: Maybe<Organization>;
  organizationId?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  programs: Array<Program>;
  settingOnboards: Array<Scalars['String']['output']>;
  showProgramDescription: Scalars['Boolean']['output'];
  stripeExpressAccountId: Scalars['String']['output'];
  tags: Array<Tag>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
  users: Array<User>;
};


export type DepartmenttagsArgs = {
  orderBy?: InputMaybe<TagOrderByInput>;
};

export type DepartmentCreateInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  allowMultipleCoupons?: InputMaybe<Scalars['Boolean']['input']>;
  annualFeeAmount?: InputMaybe<Scalars['Int']['input']>;
  annualFeeAtBeginningOfYear?: InputMaybe<Scalars['Boolean']['input']>;
  annualFeeBillingCategory?: InputMaybe<ConnectUniqueInput>;
  annualFeeCanBeAppliedAtOfferingLevel?: InputMaybe<Scalars['Boolean']['input']>;
  annualFeeMax?: InputMaybe<Scalars['Int']['input']>;
  annualFeeType?: InputMaybe<AnnualFeeType>;
  balanceAccountId?: InputMaybe<Scalars['String']['input']>;
  billingCategories?: InputMaybe<BillingCategoryManyInput>;
  classes?: InputMaybe<ConnectManyInput>;
  contactName?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  default?: InputMaybe<Scalars['Boolean']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<StringManyInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  meetAccess?: InputMaybe<Scalars['Boolean']['input']>;
  membershipOfferings?: InputMaybe<ConnectManyInput>;
  offerings?: InputMaybe<ConnectManyInput>;
  order?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<ConnectUniqueInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  programs?: InputMaybe<ProgramManyInput>;
  settingOnboards?: InputMaybe<StringManyInput>;
  showProgramDescription?: InputMaybe<Scalars['Boolean']['input']>;
  stripeExpressAccountId?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<TagManyInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  users?: InputMaybe<UserManyInput>;
};

export type DepartmentManyInput = {
  connect?: InputMaybe<Array<InputMaybe<UniqueInput>>>;
  create?: InputMaybe<Array<InputMaybe<DepartmentCreateInput>>>;
  set?: InputMaybe<Array<InputMaybe<UniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<DepartmentUpdateInput>>>;
};

export type DepartmentOrderByInput = {
  order?: InputMaybe<SortOrder>;
};

export type DepartmentUpdateInput = {
  data?: InputMaybe<DepartmentCreateInput>;
  where?: InputMaybe<UniqueInput>;
};

export type DepartmentWhereInput = {
  AND?: InputMaybe<DepartmentWhereInput>;
  NOT?: InputMaybe<DepartmentWhereInput>;
  OR?: InputMaybe<Array<DepartmentWhereInput>>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
};

export type Designator = {
  course: MeetCourseType;
  designator: Scalars['String']['output'];
  distance: Scalars['Int']['output'];
  gender: Gender;
  id: Scalars['ID']['output'];
  maxAge: Scalars['Int']['output'];
  minAge: Scalars['Int']['output'];
  stroke: Scalars['String']['output'];
  time: Scalars['Date']['output'];
  timeStandard: TimeStandard;
  timeStandardId: Scalars['ID']['output'];
  type: MeetEventType;
};

export type DesignatorCreateInput = {
  course?: InputMaybe<MeetCourseType>;
  designator?: InputMaybe<Scalars['String']['input']>;
  distance?: InputMaybe<Scalars['Int']['input']>;
  gender?: InputMaybe<Gender>;
  maxAge?: InputMaybe<Scalars['Int']['input']>;
  minAge?: InputMaybe<Scalars['Int']['input']>;
  stroke?: InputMaybe<Scalars['String']['input']>;
  time?: InputMaybe<Scalars['Date']['input']>;
  type?: InputMaybe<MeetEventType>;
};

export type DesignatorManyInput = {
  create?: InputMaybe<Array<InputMaybe<DesignatorCreateInput>>>;
  delete?: InputMaybe<Array<InputMaybe<UniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<DesignatorUpdateInput>>>;
};

export type DesignatorUpdateInput = {
  data?: InputMaybe<DesignatorCreateInput>;
  where?: InputMaybe<UniqueInput>;
};

export type DisconnectStripeAccountInput = {
  organizationId: Scalars['ID']['input'];
  stripeAccountId?: InputMaybe<Scalars['String']['input']>;
};

export type DisconnectStripeAccountPayload = {
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type Discount = {
  amount: Scalars['Float']['output'];
  amountType: AmountType;
  availableForAllOfferings: Scalars['Boolean']['output'];
  counts?: Maybe<DiscountCountPayload>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  createdBy?: Maybe<User>;
  department: Department;
  departmentId?: Maybe<Scalars['String']['output']>;
  discountType: DiscountType;
  enabledByDefault?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  max: Scalars['Int']['output'];
  min: Scalars['Int']['output'];
  organization?: Maybe<Organization>;
  organizationId?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Date']['output'];
};

export type DiscountCountPayload = {
  offerings: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  usage: Scalars['Int']['output'];
};

export type DiscountCreateInput = {
  amount: Scalars['Float']['input'];
  amountType: AmountType;
  availableForAllOfferings?: InputMaybe<Scalars['Boolean']['input']>;
  classes?: InputMaybe<ConnectManyInput>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  createdBy?: InputMaybe<ConnectUniqueInput>;
  department?: InputMaybe<ConnectUniqueInput>;
  discountType: DiscountType;
  enabledByDefault?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  max?: InputMaybe<Scalars['Int']['input']>;
  min: Scalars['Int']['input'];
  organization?: InputMaybe<ConnectUniqueInput>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type DiscountManyInput = {
  connect?: InputMaybe<Array<InputMaybe<UniqueInput>>>;
  create?: InputMaybe<Array<InputMaybe<DiscountCreateInput>>>;
  delete?: InputMaybe<Array<InputMaybe<UniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<DiscountUpdateInput>>>;
};

export const DiscountType = {
  MultiClass: 'MultiClass',
  MultiStudent: 'MultiStudent'
} as const;

export type DiscountType = typeof DiscountType[keyof typeof DiscountType];
export type DiscountUpdateInput = {
  data?: InputMaybe<DiscountCreateInput>;
  where?: InputMaybe<UniqueInput>;
};

export type DiscountWhereInput = {
  AND?: InputMaybe<DiscountWhereInput>;
  NOT?: InputMaybe<DiscountWhereInput>;
  OR?: InputMaybe<Array<DiscountWhereInput>>;
  departmentId?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
};

export type DownloadPreviewInvoicePayload = {
  name?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export const EmailSendingType = {
  Captyn: 'Captyn',
  Custom: 'Custom'
} as const;

export type EmailSendingType = typeof EmailSendingType[keyof typeof EmailSendingType];
export type EmailSetting = {
  emailDomain?: Maybe<Scalars['String']['output']>;
  emailType?: Maybe<EmailSendingType>;
};

export const EmailType = {
  Bulk: 'Bulk',
  Code: 'Code',
  CustomerRequestReceived: 'CustomerRequestReceived',
  DeleteAccountRequest: 'DeleteAccountRequest',
  Direct: 'Direct',
  Email: 'Email',
  EmailOnly: 'EmailOnly',
  EnrollmentSummary: 'EnrollmentSummary',
  LessonCancellationRescheduleRequest: 'LessonCancellationRescheduleRequest',
  LessonSeriesAbandoned: 'LessonSeriesAbandoned',
  LessonSeriesAddedTo: 'LessonSeriesAddedTo',
  LessonSeriesAssignment: 'LessonSeriesAssignment',
  LessonSeriesClaimed: 'LessonSeriesClaimed',
  LessonSeriesPosting: 'LessonSeriesPosting',
  LessonSeriesTransfer: 'LessonSeriesTransfer',
  LessonSeriesTransferAdminNotification: 'LessonSeriesTransferAdminNotification',
  MoveConfirmation: 'MoveConfirmation',
  OneTimeClassEntry: 'OneTimeClassEntry',
  OrganizationUpdates: 'OrganizationUpdates',
  PaymentDetailsUpdated: 'PaymentDetailsUpdated',
  PrivateLessonCanceled: 'PrivateLessonCanceled',
  PrivateLessonScheduled: 'PrivateLessonScheduled',
  RegistrationLink: 'RegistrationLink',
  RegistrationReceived: 'RegistrationReceived',
  UpgradeNativeApp: 'UpgradeNativeApp',
  UpgradeWebsite: 'UpgradeWebsite',
  WaitlistApproval: 'WaitlistApproval'
} as const;

export type EmailType = typeof EmailType[keyof typeof EmailType];
export type EnrollmentFiltersPayload = {
  participant?: Maybe<Array<Maybe<Filter>>>;
  program?: Maybe<Array<Maybe<Filter>>>;
  registrationStatus?: Maybe<Array<Maybe<Filter>>>;
  tag?: Maybe<Array<Maybe<Filter>>>;
};

export type EnrollmentSummaryPayload = {
  data?: Maybe<Scalars['Json']['output']>;
  success: Scalars['Boolean']['output'];
};

export type Evaluation = {
  class?: Maybe<Class>;
  classId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Date']['output'];
  file?: Maybe<File>;
  fileId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  instructor: User;
  instructorId?: Maybe<Scalars['String']['output']>;
  note: Scalars['String']['output'];
  organization?: Maybe<Organization>;
  organizationId?: Maybe<Scalars['String']['output']>;
  preview?: Maybe<File>;
  previewId?: Maybe<Scalars['String']['output']>;
  program: Program;
  programId?: Maybe<Scalars['String']['output']>;
  recommendedProgram: Program;
  recommendedProgramId?: Maybe<Scalars['String']['output']>;
  skillsCompleted: Array<Scalars['String']['output']>;
  updatedAt: Scalars['Date']['output'];
  user: User;
  userId?: Maybe<Scalars['String']['output']>;
};

export type EvaluationCreateInput = {
  class?: InputMaybe<ConnectUniqueInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  instructor?: InputMaybe<ConnectUniqueInput>;
  note?: InputMaybe<Scalars['String']['input']>;
  organization?: InputMaybe<ConnectUniqueInput>;
  program?: InputMaybe<ConnectUniqueInput>;
  recommendedProgram?: InputMaybe<ConnectUniqueInput>;
  skillsCompleted?: InputMaybe<StringManyInput>;
  user?: InputMaybe<ConnectUniqueInput>;
};

export type EvaluationManyInput = {
  update?: InputMaybe<Array<InputMaybe<EvaluationUpdateInput>>>;
};

export type EvaluationUpdateInput = {
  data?: InputMaybe<EvaluationCreateInput>;
  where?: InputMaybe<UniqueInput>;
};

export type EvaluationWhereInput = {
  AND?: InputMaybe<EvaluationWhereInput>;
  NOT?: InputMaybe<EvaluationWhereInput>;
  OR?: InputMaybe<Array<EvaluationWhereInput>>;
  user?: InputMaybe<UserWhereInput>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type Event = {
  attendance?: Maybe<Attendance>;
  attendanceId?: Maybe<Scalars['String']['output']>;
  by?: Maybe<User>;
  byId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Date']['output'];
  date?: Maybe<Scalars['Date']['output']>;
  groupRegistration?: Maybe<GroupRegistration>;
  groupRegistrationEvent?: Maybe<GroupRegistration>;
  groupRegistrationEventId?: Maybe<Scalars['String']['output']>;
  groupRegistrationId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  invoiceItem?: Maybe<InvoiceItem>;
  invoiceItemId?: Maybe<Scalars['String']['output']>;
  membership?: Maybe<Membership>;
  membershipId?: Maybe<Scalars['String']['output']>;
  organization?: Maybe<Organization>;
  organizationId?: Maybe<Scalars['String']['output']>;
  privateSerie?: Maybe<PrivateSerie>;
  privateSerieAttendanceId?: Maybe<Scalars['String']['output']>;
  privateSerieId?: Maybe<Scalars['String']['output']>;
  to?: Maybe<Array<User>>;
  type: EventType;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type EventCreateInput = {
  by?: InputMaybe<ConnectUniqueInput>;
  date?: InputMaybe<Scalars['Date']['input']>;
  groupRegistration?: InputMaybe<ConnectUniqueInput>;
  invoiceItem?: InputMaybe<ConnectUniqueInput>;
  pass?: InputMaybe<ConnectUniqueInput>;
  privateSerieAttendance?: InputMaybe<ConnectUniqueInput>;
  to?: InputMaybe<ConnectManyInput>;
  type: EventType;
  user?: InputMaybe<ConnectUniqueInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type EventManyInput = {
  create?: InputMaybe<Array<InputMaybe<EventCreateInput>>>;
  delete?: InputMaybe<Array<InputMaybe<UniqueInput>>>;
};

export type EventOrderByInput = {
  createdAt?: InputMaybe<SortOrder>;
  date?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export const EventType = {
  Abandoned: 'Abandoned',
  AccountManagerChanged: 'AccountManagerChanged',
  ApplicationFeeChanged: 'ApplicationFeeChanged',
  ApplicationFeeRemoved: 'ApplicationFeeRemoved',
  Approved: 'Approved',
  Assigned: 'Assigned',
  Attended: 'Attended',
  CancelApproved: 'CancelApproved',
  CancelDenied: 'CancelDenied',
  CancelEdited: 'CancelEdited',
  CancelIgnored: 'CancelIgnored',
  CancelRemoved: 'CancelRemoved',
  CancelRequestEdited: 'CancelRequestEdited',
  CancelRequested: 'CancelRequested',
  Canceled: 'Canceled',
  CheckIn: 'CheckIn',
  CheckOut: 'CheckOut',
  Claimed: 'Claimed',
  Completed: 'Completed',
  CreditsSet: 'CreditsSet',
  DeclarationCreated: 'DeclarationCreated',
  DeclarationUpdated: 'DeclarationUpdated',
  Declined: 'Declined',
  DetailsUpdated: 'DetailsUpdated',
  Error: 'Error',
  EventsSelected: 'EventsSelected',
  LessonCanceled: 'LessonCanceled',
  LessonCompleted: 'LessonCompleted',
  LessonRescheduled: 'LessonRescheduled',
  LessonScheduled: 'LessonScheduled',
  LessonVerified: 'LessonVerified',
  LessonsAdded: 'LessonsAdded',
  LessonsRemoved: 'LessonsRemoved',
  LocationSearch: 'LocationSearch',
  Locked: 'Locked',
  MoveApproved: 'MoveApproved',
  MoveDenied: 'MoveDenied',
  MoveIgnored: 'MoveIgnored',
  MoveRemoved: 'MoveRemoved',
  MoveRequested: 'MoveRequested',
  Moved: 'Moved',
  MovedFrom: 'MovedFrom',
  NewOffering: 'NewOffering',
  NewParticipant: 'NewParticipant',
  NotAttended: 'NotAttended',
  NotCheckIn: 'NotCheckIn',
  NotificationSent: 'NotificationSent',
  OfferingSettingsComplete: 'OfferingSettingsComplete',
  OrganizationCreated: 'OrganizationCreated',
  OrganizationReactivated: 'OrganizationReactivated',
  OrganizationSettingsComplete: 'OrganizationSettingsComplete',
  OrganizationSuspended: 'OrganizationSuspended',
  Paused: 'Paused',
  PaymentRetry: 'PaymentRetry',
  Posted: 'Posted',
  ProcessorDisplay: 'ProcessorDisplay',
  ProcessorUse: 'ProcessorUse',
  Purchased: 'Purchased',
  Reenrolled: 'Reenrolled',
  Refunded: 'Refunded',
  RegistrationReceived: 'RegistrationReceived',
  RescheduleRequested: 'RescheduleRequested',
  Revoked: 'Revoked',
  SalespersonChanged: 'SalespersonChanged',
  SignedIn: 'SignedIn',
  SignupType: 'SignupType',
  StripeConnected: 'StripeConnected',
  TeamChange: 'TeamChange',
  Transferred: 'Transferred',
  Unattended: 'Unattended',
  Unlocked: 'Unlocked',
  UnmarkedAbandoned: 'UnmarkedAbandoned',
  UnmarkedCompleted: 'UnmarkedCompleted',
  Unpaused: 'Unpaused',
  Unverified: 'Unverified',
  UsaSwimmingRegistration: 'UsaSwimmingRegistration',
  UsaSwimmingRenew: 'UsaSwimmingRenew',
  Verified: 'Verified',
  Visited: 'Visited',
  Waitlisted: 'Waitlisted'
} as const;

export type EventType = typeof EventType[keyof typeof EventType];
export type EventTypeFilter = {
  equals?: InputMaybe<EventType>;
  in?: InputMaybe<Array<EventType>>;
  not?: InputMaybe<EventType>;
  notIn?: InputMaybe<Array<EventType>>;
};

export type EventWhereInput = {
  AND?: InputMaybe<EventWhereInput>;
  NOT?: InputMaybe<EventWhereInput>;
  OR?: InputMaybe<Array<EventWhereInput>>;
  attendance?: InputMaybe<AttendanceWhereInput>;
  byId?: InputMaybe<StringFilter>;
  date?: InputMaybe<DateFilter>;
  type?: InputMaybe<EventTypeFilter>;
  user?: InputMaybe<UserWhereInput>;
  userId?: InputMaybe<StringFilter>;
};

export type EventsCountsPayload = {
  attendances?: Maybe<Scalars['Int']['output']>;
  checkIns?: Maybe<Scalars['Int']['output']>;
  count?: Maybe<Scalars['Int']['output']>;
  participants?: Maybe<Scalars['Int']['output']>;
};

export type ExportInvoicesInput = {
  date?: InputMaybe<Scalars['Date']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<StringFilter>;
  includeCaptyn?: InputMaybe<Scalars['Boolean']['input']>;
  itemized?: InputMaybe<Scalars['Boolean']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  sweepId?: InputMaybe<Scalars['String']['input']>;
};

export type ExportMeetEntriesReportInput = {
  byEvent?: InputMaybe<Scalars['Boolean']['input']>;
  eventId?: InputMaybe<Scalars['String']['input']>;
  meetId: Scalars['ID']['input'];
  relaysOnly?: InputMaybe<Scalars['Boolean']['input']>;
  userId?: InputMaybe<StringFilter>;
};

export type ExportMeetFeesReportInput = {
  host?: InputMaybe<Scalars['Boolean']['input']>;
  meetId: Scalars['ID']['input'];
};

export type ExportVolunteersInput = {
  filter?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<StringFilter>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  slots?: InputMaybe<Scalars['Boolean']['input']>;
  volunteerEventId?: InputMaybe<Scalars['ID']['input']>;
  volunteerIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type Fee = {
  amount: Scalars['Float']['output'];
  amountType: AmountType;
  availableForAllOfferings: Scalars['Boolean']['output'];
  billingCategory?: Maybe<BillingCategory>;
  billingCategoryId?: Maybe<Scalars['String']['output']>;
  counts?: Maybe<FeeCountPayload>;
  createdAt: Scalars['Date']['output'];
  createdBy?: Maybe<User>;
  enabledByDefault: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  order?: Maybe<Scalars['Int']['output']>;
  organization?: Maybe<Organization>;
  organizationId?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
  warningAcceptedAt?: Maybe<Scalars['Date']['output']>;
  warningAcceptedBy?: Maybe<User>;
};

export type FeeCountPayload = {
  offerings: Scalars['Int']['output'];
};

export type FeeCreateInput = {
  amount: Scalars['Float']['input'];
  amountType: AmountType;
  availableForAllOfferings: Scalars['Boolean']['input'];
  billingCategory?: InputMaybe<BillingCategoryNestedInput>;
  classes?: InputMaybe<ConnectManyInput>;
  createdBy?: InputMaybe<ConnectUniqueInput>;
  enabledByDefault: Scalars['Boolean']['input'];
  order?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<ConnectUniqueInput>;
  title: Scalars['String']['input'];
  warningAcceptedAt?: InputMaybe<Scalars['Date']['input']>;
  warningAcceptedBy?: InputMaybe<ConnectUniqueInput>;
};

export type FeeManyInput = {
  connect?: InputMaybe<Array<InputMaybe<UniqueInput>>>;
  create?: InputMaybe<Array<InputMaybe<FeeCreateInput>>>;
  delete?: InputMaybe<Array<InputMaybe<UniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<UniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<FeeUpdateInput>>>;
};

export type FeeOrderByInput = {
  order?: InputMaybe<SortOrder>;
};

export type FeeUpdateDataInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  amountType?: InputMaybe<AmountType>;
  availableForAllOfferings?: InputMaybe<Scalars['Boolean']['input']>;
  billingCategory?: InputMaybe<BillingCategoryNestedInput>;
  enabledByDefault?: InputMaybe<Scalars['Boolean']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<ConnectUniqueInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  warningAcceptedAt?: InputMaybe<Scalars['Date']['input']>;
  warningAcceptedBy?: InputMaybe<ConnectUniqueInput>;
};

export type FeeUpdateInput = {
  data?: InputMaybe<FeeUpdateDataInput>;
  where?: InputMaybe<UniqueInput>;
};

export type File = {
  createdAt: Scalars['Date']['output'];
  fileName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  messages: Array<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  type: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
  uploadedBy?: Maybe<User>;
  url: Scalars['String']['output'];
};

export type FileCreateInput = {
  fileName?: InputMaybe<Scalars['String']['input']>;
  messages?: InputMaybe<StringManyInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  organization?: InputMaybe<ConnectUniqueInput>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type FileManyInput = {
  connect?: InputMaybe<Array<InputMaybe<UniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<UniqueInput>>>;
};

export type Filter = {
  label?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type FilterItem = {
  departmentId?: Maybe<Scalars['String']['output']>;
  hideInFilters?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['String']['output'];
  order?: Maybe<Scalars['Int']['output']>;
  title: Scalars['String']['output'];
};

export type FilteredClassesCountsPayload = {
  ages: Array<Scalars['Int']['output']>;
  approvedRegistrations?: Maybe<Scalars['Int']['output']>;
  availableSoon?: Maybe<Scalars['Int']['output']>;
  canceledRegistrations?: Maybe<Scalars['Int']['output']>;
  completedRegistrations?: Maybe<Scalars['Int']['output']>;
  days: Array<Day>;
  declinedRegistrations?: Maybe<Scalars['Int']['output']>;
  instructors: Array<FilterItem>;
  locations: Array<Location>;
  movedRegistrations?: Maybe<Scalars['Int']['output']>;
  pendingRegistrations?: Maybe<Scalars['Int']['output']>;
  programs: Array<FilterItem>;
  registrationNotRequired?: Maybe<Scalars['Int']['output']>;
  registrationRequired?: Maybe<Scalars['Int']['output']>;
  tags: Array<FilterItem>;
  times: Array<Scalars['String']['output']>;
  totalAccountOwners?: Maybe<Scalars['Int']['output']>;
  totalAvailability?: Maybe<Scalars['Int']['output']>;
  totalClasses?: Maybe<Scalars['Int']['output']>;
  totalRegistrations?: Maybe<Scalars['Int']['output']>;
  unlimitedEnrollments?: Maybe<Scalars['Int']['output']>;
  waitlistRegistrations?: Maybe<Scalars['Int']['output']>;
  zones: Array<FilterItem>;
};

export type FilteredClassesPayload = {
  classes: Array<Maybe<Class>>;
  summary?: Maybe<Scalars['Json']['output']>;
};

export type FilteredInvoicesCountsPayload = {
  total?: Maybe<Scalars['Int']['output']>;
};

export type FilteredOfferingsCountsPayload = {
  abandoned?: Maybe<Scalars['Int']['output']>;
  active?: Maybe<Scalars['Int']['output']>;
  closed?: Maybe<Scalars['Int']['output']>;
  count?: Maybe<Scalars['Int']['output']>;
  participants?: Maybe<Scalars['Int']['output']>;
  pending?: Maybe<Scalars['Int']['output']>;
  registrations?: Maybe<Scalars['Int']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type FilteredPrivateSeriesCountsPayload = {
  abandoned?: Maybe<Scalars['Int']['output']>;
  actionNeeded?: Maybe<Scalars['Int']['output']>;
  cart?: Maybe<Scalars['Int']['output']>;
  closed?: Maybe<Scalars['Int']['output']>;
  count?: Maybe<Scalars['Int']['output']>;
  inProgress?: Maybe<Scalars['Int']['output']>;
  participants?: Maybe<Scalars['Int']['output']>;
  pending?: Maybe<Scalars['Int']['output']>;
  posted?: Maybe<Scalars['Int']['output']>;
  staffAssigned?: Maybe<Scalars['Int']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type FilteredUsersCountsPayload = {
  financial?: Maybe<UserFinancialSummaryPayload>;
  groupOfferings?: Maybe<UserEnrollmentCountsPayload>;
  membershipOfferings?: Maybe<UserEnrollmentCountsPayload>;
  participants?: Maybe<Scalars['Int']['output']>;
  privateOfferings?: Maybe<UserEnrollmentCountsPayload>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type FinancialBlockData = {
  addons?: Maybe<HistoricalFinancialReportCount>;
  all?: Maybe<HistoricalFinancialReportCount>;
  annual?: Maybe<HistoricalFinancialReportCount>;
  charges?: Maybe<HistoricalFinancialReportCount>;
  custom?: Maybe<HistoricalFinancialReportCount>;
  fees?: Maybe<HistoricalFinancialReportCount>;
  meet?: Maybe<HistoricalFinancialReportCount>;
  monthly?: Maybe<HistoricalFinancialReportCount>;
  refunds?: Maybe<HistoricalFinancialReportCount>;
  registrations?: Maybe<HistoricalFinancialReportCount>;
};

export type FinancialBlocksPayload = {
  blocksData?: Maybe<FinancialBlockData>;
  compareBlocksData?: Maybe<FinancialBlockData>;
};

export type FinancialReportInput = {
  accountManager?: InputMaybe<Scalars['ID']['input']>;
  balanceAccountId?: InputMaybe<Scalars['ID']['input']>;
  billingCategory?: InputMaybe<Scalars['ID']['input']>;
  department?: InputMaybe<Scalars['ID']['input']>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
  includeRefunds?: InputMaybe<Scalars['Boolean']['input']>;
  itemized?: InputMaybe<Scalars['Boolean']['input']>;
  organizationId: Scalars['ID']['input'];
  organizationStatus?: InputMaybe<Scalars['String']['input']>;
  payoutId?: InputMaybe<Scalars['ID']['input']>;
  payoutPage?: InputMaybe<Scalars['ID']['input']>;
  report?: InputMaybe<Scalars['Boolean']['input']>;
  salesPerson?: InputMaybe<Scalars['ID']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
  stripeAccountId?: InputMaybe<Scalars['String']['input']>;
  superAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  totalsOnly?: InputMaybe<Scalars['Boolean']['input']>;
  transactionTypes?: InputMaybe<Array<InputMaybe<PaymentType>>>;
};

export type FinancialReportPayload = {
  csv?: Maybe<Scalars['String']['output']>;
  invoiceItems?: Maybe<Scalars['Int']['output']>;
  refundsIssued?: Maybe<Scalars['Int']['output']>;
  totalCharged?: Maybe<Scalars['Int']['output']>;
  totalTransactions?: Maybe<Scalars['Int']['output']>;
};

export type FindFiltersPayload = {
  ages: Array<Scalars['Int']['output']>;
  days: Array<Day>;
  departments: Array<FilterItem>;
  instructors: Array<FilterItem>;
  locations: Array<Location>;
  programs: Array<FilterItem>;
  tags: Array<FilterItem>;
  times: Array<Scalars['String']['output']>;
  zones: Array<FilterItem>;
};

export const Frequency = {
  Annual: 'Annual',
  Custom: 'Custom',
  Monthly: 'Monthly',
  OneTime: 'OneTime'
} as const;

export type Frequency = typeof Frequency[keyof typeof Frequency];
export type FrequencyFilter = {
  equals?: InputMaybe<Frequency>;
  in?: InputMaybe<Array<Frequency>>;
  not?: InputMaybe<Frequency>;
  notIn?: InputMaybe<Array<Frequency>>;
};

export const Gender = {
  Female: 'Female',
  Male: 'Male'
} as const;

export type Gender = typeof Gender[keyof typeof Gender];
export type GooglePayConfiguration = {
  authJwt: Scalars['String']['output'];
  gatewayMerchantId: Scalars['String']['output'];
  merchantId: Scalars['String']['output'];
  merchantOrigin: Scalars['String']['output'];
};

export type GroupRegistration = {
  accountOwner: User;
  accountOwnerId?: Maybe<Scalars['String']['output']>;
  active?: Maybe<Scalars['Boolean']['output']>;
  class: Class;
  classId?: Maybe<Scalars['String']['output']>;
  coupons: Array<Coupon>;
  createdAt: Scalars['Date']['output'];
  createdBy?: Maybe<User>;
  createdById?: Maybe<Scalars['String']['output']>;
  customerInfoRequestResponses: Array<CustomerInfoRequestResponse>;
  customerRequest?: Maybe<CustomerRequest>;
  dateApproved: Scalars['Date']['output'];
  events: Array<Event>;
  finalDate: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  invoiceItems: Array<InvoiceItem>;
  note?: Maybe<Scalars['String']['output']>;
  organization?: Maybe<Organization>;
  organizationId?: Maybe<Scalars['String']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  roster: Array<User>;
  status: GroupRegistrationStatus;
  student: User;
  studentId?: Maybe<Scalars['String']['output']>;
  studentInfoRequestResponses: Array<StudentInfoRequestResponse>;
  unread?: Maybe<Scalars['Boolean']['output']>;
  updatedAt: Scalars['Date']['output'];
};

export type GroupRegistrationCreateInput = {
  accountOwner?: InputMaybe<ConnectUniqueInput>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  class?: InputMaybe<ConnectUniqueInput>;
  coupons?: InputMaybe<ConnectManyInput>;
  createdBy?: InputMaybe<ConnectUniqueInput>;
  customerInfoRequestResponses?: InputMaybe<CustomerInfoRequestResponseManyInput>;
  customerRequest?: InputMaybe<CustomerRequestNestedInput>;
  dateApproved?: InputMaybe<Scalars['Date']['input']>;
  events?: InputMaybe<EventManyInput>;
  finalDate?: InputMaybe<Scalars['Date']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  organization?: InputMaybe<ConnectUniqueInput>;
  reason?: InputMaybe<Scalars['String']['input']>;
  roster?: InputMaybe<ConnectManyInput>;
  status?: InputMaybe<GroupRegistrationStatus>;
  student?: InputMaybe<ConnectUniqueInput>;
  studentInfoRequestResponses?: InputMaybe<StudentInfoRequestResponseManyInput>;
  unread?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GroupRegistrationListRelationFilter = {
  every?: InputMaybe<GroupRegistrationWhereInput>;
  none?: InputMaybe<GroupRegistrationWhereInput>;
  some?: InputMaybe<GroupRegistrationWhereInput>;
};

export type GroupRegistrationManyInput = {
  update?: InputMaybe<Array<InputMaybe<GroupRegistrationUpdateInput>>>;
};

export const GroupRegistrationStatus = {
  Approved: 'Approved',
  Canceled: 'Canceled',
  Completed: 'Completed',
  Declined: 'Declined',
  Error: 'Error',
  Moved: 'Moved',
  Pending: 'Pending',
  Waitlist: 'Waitlist'
} as const;

export type GroupRegistrationStatus = typeof GroupRegistrationStatus[keyof typeof GroupRegistrationStatus];
export type GroupRegistrationStatusFilter = {
  equals?: InputMaybe<GroupRegistrationStatus>;
  in?: InputMaybe<Array<GroupRegistrationStatus>>;
  not?: InputMaybe<GroupRegistrationStatus>;
  notIn?: InputMaybe<Array<GroupRegistrationStatus>>;
};

export type GroupRegistrationUpdateInput = {
  data?: InputMaybe<GroupRegistrationCreateInput>;
  where?: InputMaybe<UniqueInput>;
};

export type GroupRegistrationWhereInput = {
  AND?: InputMaybe<GroupRegistrationWhereInput>;
  NOT?: InputMaybe<GroupRegistrationWhereInput>;
  OR?: InputMaybe<Array<GroupRegistrationWhereInput>>;
  accountOwner?: InputMaybe<UserWhereInput>;
  accountOwnerId?: InputMaybe<Scalars['String']['input']>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  class?: InputMaybe<ClassWhereInput>;
  classId?: InputMaybe<StringFilter>;
  customerRequest?: InputMaybe<CustomerRequestWhereInput>;
  finalDate?: InputMaybe<DateFilter>;
  id?: InputMaybe<StringFilter>;
  organization?: InputMaybe<OrganizationWhereInput>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  roster?: InputMaybe<UserListRelationFilter>;
  status?: InputMaybe<GroupRegistrationStatusFilter>;
  student?: InputMaybe<UserWhereInput>;
  studentId?: InputMaybe<Scalars['String']['input']>;
};

export type GroupRegistrationsCountsPayload = {
  canceled?: Maybe<Scalars['Int']['output']>;
  closed?: Maybe<Scalars['Int']['output']>;
  completed?: Maybe<Scalars['Int']['output']>;
  count?: Maybe<Scalars['Int']['output']>;
  declined?: Maybe<Scalars['Int']['output']>;
  enrolled?: Maybe<Scalars['Int']['output']>;
  moved?: Maybe<Scalars['Int']['output']>;
  pending?: Maybe<Scalars['Int']['output']>;
  waitlist?: Maybe<Scalars['Int']['output']>;
};

export type GroupRegistrationsForUserPayload = {
  count?: Maybe<Scalars['Int']['output']>;
  groupRegistrations: Array<Maybe<GroupRegistration>>;
};

export type HealthQuestion = {
  createdAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  order: Scalars['Int']['output'];
  organization?: Maybe<Organization>;
  organizationId?: Maybe<Scalars['String']['output']>;
  question: Scalars['String']['output'];
  responses: Array<HealthQuestionResponse>;
  slug: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
};

export type HealthQuestionCreateInput = {
  order?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<ConnectUniqueInput>;
  question?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type HealthQuestionManyInput = {
  create?: InputMaybe<Array<InputMaybe<HealthQuestionCreateInput>>>;
  update?: InputMaybe<Array<InputMaybe<HealthQuestionUpdateInput>>>;
};

export type HealthQuestionOrderByInput = {
  order?: InputMaybe<SortOrder>;
};

export type HealthQuestionResponse = {
  createdAt: Scalars['Date']['output'];
  healthQuestion: HealthQuestion;
  healthQuestionId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  response: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
  user?: Maybe<User>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type HealthQuestionResponseCreateInput = {
  healthQuestion?: InputMaybe<ConnectUniqueInput>;
  response: Scalars['String']['input'];
};

export type HealthQuestionResponseManyInput = {
  create?: InputMaybe<Array<InputMaybe<HealthQuestionResponseCreateInput>>>;
  delete?: InputMaybe<Array<InputMaybe<UniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<HealthQuestionResponseUpdateInput>>>;
};

export type HealthQuestionResponseUpdateInput = {
  data?: InputMaybe<HealthQuestionResponseCreateInput>;
  where?: InputMaybe<UniqueInput>;
};

export type HealthQuestionUpdateInput = {
  data?: InputMaybe<HealthQuestionCreateInput>;
  where?: InputMaybe<UniqueInput>;
};

export type HistoricalFinancialReportCount = {
  accounts?: Maybe<Scalars['Int']['output']>;
  amount?: Maybe<Scalars['Int']['output']>;
  count?: Maybe<Scalars['Int']['output']>;
  organizations?: Maybe<Scalars['Int']['output']>;
};

export type HistoricalFinancialReportCounts = {
  addons?: Maybe<HistoricalFinancialReportCount>;
  annual?: Maybe<HistoricalFinancialReportCount>;
  captyn?: Maybe<HistoricalFinancialReportCount>;
  captynCharges?: Maybe<CaptynFinancialReportCount>;
  charges?: Maybe<HistoricalFinancialReportCount>;
  commissions?: Maybe<Array<Maybe<CommissionCount>>>;
  custom?: Maybe<HistoricalFinancialReportCount>;
  date?: Maybe<Scalars['Date']['output']>;
  fees?: Maybe<HistoricalFinancialReportCount>;
  invoiceItems?: Maybe<Scalars['Int']['output']>;
  invoices?: Maybe<Scalars['Int']['output']>;
  meet?: Maybe<HistoricalFinancialReportCount>;
  monthly?: Maybe<HistoricalFinancialReportCount>;
  other?: Maybe<HistoricalFinancialReportCount>;
  refunds?: Maybe<HistoricalFinancialReportCount>;
  registrations?: Maybe<HistoricalFinancialReportCount>;
  total?: Maybe<HistoricalFinancialReportCount>;
};

export type HistoricalFinancialReportPayload = {
  month?: Maybe<Scalars['Json']['output']>;
  range?: Maybe<HistoricalFinancialReportCounts>;
};

export type ImportDataInput = {
  fileId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
  sendWelcomeEmail?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type ImportMeetResultsInput = {
  excluded?: InputMaybe<Array<Scalars['String']['input']>>;
  file: Scalars['ID']['input'];
  matches?: InputMaybe<Array<MeetMatchInput>>;
  organization: Scalars['ID']['input'];
  run: Scalars['Boolean']['input'];
};

export type ImportMeetResultsPayload = {
  csv?: Maybe<Scalars['Boolean']['output']>;
  duplicates: Scalars['Int']['output'];
  matched: Scalars['Int']['output'];
  meets: Scalars['Int']['output'];
  results: Scalars['Int']['output'];
  unknown: Array<User>;
};

export const InfoRequestType = {
  Predefined: 'Predefined',
  Text: 'Text',
  YesNo: 'YesNo'
} as const;

export type InfoRequestType = typeof InfoRequestType[keyof typeof InfoRequestType];
export type IntFilter = {
  equals?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  not?: InputMaybe<Scalars['Int']['input']>;
  notIn?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export const IntegrationType = {
  Finis: 'Finis',
  FleetFeet: 'FleetFeet',
  Store: 'Store',
  SwimAmerica: 'SwimAmerica',
  SwimCloud: 'SwimCloud',
  USASwimming: 'USASwimming'
} as const;

export type IntegrationType = typeof IntegrationType[keyof typeof IntegrationType];
export type IntegrationTypeFilter = {
  equals?: InputMaybe<IntegrationType>;
  in?: InputMaybe<Array<IntegrationType>>;
  not?: InputMaybe<IntegrationType>;
  notIn?: InputMaybe<Array<IntegrationType>>;
};

export type IntegrationTypeManyInput = {
  set: Array<IntegrationType>;
};

export type IntegrationsTypeFilter = {
  hasSome?: InputMaybe<Array<IntegrationType>>;
};

export type Invoice = {
  automated?: Maybe<Scalars['Boolean']['output']>;
  createdAt: Scalars['Date']['output'];
  file?: Maybe<File>;
  id: Scalars['ID']['output'];
  invoiceDate?: Maybe<Scalars['Date']['output']>;
  invoiceItems: Array<InvoiceItem>;
  noPayment?: Maybe<Scalars['Boolean']['output']>;
  organization?: Maybe<Organization>;
  organizationId?: Maybe<Scalars['String']['output']>;
  receipt?: Maybe<File>;
  status?: Maybe<InvoiceStatus>;
  totals?: Maybe<InvoiceAggregate>;
  updatedAt: Scalars['Date']['output'];
  user?: Maybe<User>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type InvoiceAggregate = {
  totalCredits?: Maybe<Scalars['Int']['output']>;
  totalDiscounts?: Maybe<Scalars['Int']['output']>;
  totalOwed?: Maybe<Scalars['Int']['output']>;
  totalPaid?: Maybe<Scalars['Int']['output']>;
  totalRefunded?: Maybe<Scalars['Int']['output']>;
};

export type InvoiceChartDataset = {
  data: Array<Maybe<Scalars['Int']['output']>>;
  label: Scalars['String']['output'];
};

export type InvoiceChartsPayload = {
  compareLabels: Array<Maybe<Scalars['String']['output']>>;
  datasets: Array<Maybe<InvoiceChartDataset>>;
  financialBlocks?: Maybe<FinancialBlocksPayload>;
  labels: Array<Maybe<Scalars['String']['output']>>;
};

export type InvoiceCreateInput = {
  automated?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  invoiceDate?: InputMaybe<Scalars['Date']['input']>;
  invoiceItems?: InputMaybe<InvoiceItemManyInput>;
  noPayment?: InputMaybe<Scalars['Boolean']['input']>;
  organization?: InputMaybe<ConnectUniqueInput>;
  status?: InputMaybe<InvoiceStatus>;
  user?: InputMaybe<ConnectUniqueInput>;
};

export type InvoiceItem = {
  addon?: Maybe<Addon>;
  addonId?: Maybe<Scalars['String']['output']>;
  amount: Scalars['Int']['output'];
  attendance?: Maybe<Attendance>;
  balanceAccountId?: Maybe<Scalars['String']['output']>;
  billingCategory?: Maybe<BillingCategory>;
  billingCategoryId?: Maybe<Scalars['String']['output']>;
  captyn?: Maybe<Frequency>;
  charge?: Maybe<Charge>;
  chargeAmount?: Maybe<ChargeAmount>;
  coupons: Array<InvoiceItemCoupon>;
  createdAt: Scalars['Date']['output'];
  credits: Array<InvoiceItemCredit>;
  description: Scalars['String']['output'];
  discounts: Array<InvoiceItemDiscount>;
  events: Array<Event>;
  fee?: Maybe<Fee>;
  feeId?: Maybe<Scalars['String']['output']>;
  groupRegistration?: Maybe<GroupRegistration>;
  groupRegistrationId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  invoice?: Maybe<Invoice>;
  invoiceId?: Maybe<Scalars['String']['output']>;
  meet?: Maybe<Meet>;
  membership?: Maybe<Membership>;
  membershipId?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  payments: Array<InvoiceItemPayment>;
  privateSerie?: Maybe<PrivateSerie>;
  privateSerieId?: Maybe<Scalars['String']['output']>;
  quantity: Scalars['Int']['output'];
  recurringCharge?: Maybe<RecurringCharge>;
  recurringChargeId?: Maybe<Scalars['String']['output']>;
  refunds: Array<Refund>;
  status?: Maybe<InvoiceStatus>;
  updatedAt: Scalars['Date']['output'];
  user?: Maybe<User>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type InvoiceItemCoupon = {
  amount: Scalars['Int']['output'];
  coupon?: Maybe<Coupon>;
  couponId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  invoiceItem?: Maybe<InvoiceItem>;
  invoiceItemId?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Date']['output'];
};

export type InvoiceItemCouponCreateInput = {
  amount: Scalars['Int']['input'];
  coupon?: InputMaybe<ConnectUniqueInput>;
};

export type InvoiceItemCouponManyInput = {
  create?: InputMaybe<Array<InputMaybe<InvoiceItemCouponCreateInput>>>;
};

export type InvoiceItemCreateInput = {
  addon?: InputMaybe<ConnectUniqueInput>;
  amount?: InputMaybe<Scalars['Int']['input']>;
  attendance?: InputMaybe<ConnectUniqueInput>;
  billingCategory?: InputMaybe<ConnectUniqueInput>;
  captyn?: InputMaybe<Frequency>;
  charge?: InputMaybe<ChargeNestedInput>;
  coupons?: InputMaybe<InvoiceItemCouponManyInput>;
  credits?: InputMaybe<ConnectManyInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  discounts?: InputMaybe<InvoiceItemDiscountManyInput>;
  events?: InputMaybe<EventManyInput>;
  fee?: InputMaybe<ConnectUniqueInput>;
  groupRegistration?: InputMaybe<ConnectUniqueInput>;
  membership?: InputMaybe<ConnectUniqueInput>;
  note?: InputMaybe<Scalars['String']['input']>;
  payments?: InputMaybe<InvoiceItemPaymentManyInput>;
  privateSerie?: InputMaybe<ConnectUniqueInput>;
  privateSerieAttendance?: InputMaybe<ConnectUniqueInput>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  recurringCharge?: InputMaybe<ConnectUniqueInput>;
  refunds?: InputMaybe<ConnectManyInput>;
  status?: InputMaybe<InvoiceStatus>;
  user?: InputMaybe<ConnectUniqueInput>;
};

export type InvoiceItemCredit = {
  amount: Scalars['Int']['output'];
  createdAt: Scalars['Date']['output'];
  credit?: Maybe<Credit>;
  creditId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  invoiceItem?: Maybe<InvoiceItem>;
  invoiceItemId?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Date']['output'];
};

export type InvoiceItemDiscount = {
  amount: Scalars['Int']['output'];
  createdAt: Scalars['Date']['output'];
  description?: Maybe<Scalars['String']['output']>;
  discount?: Maybe<Discount>;
  discountId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  invoiceItem?: Maybe<InvoiceItem>;
  invoiceItemId?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Date']['output'];
};

export type InvoiceItemDiscountCreateInput = {
  amount: Scalars['Int']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  discount?: InputMaybe<ConnectUniqueInput>;
};

export type InvoiceItemDiscountManyInput = {
  create?: InputMaybe<Array<InputMaybe<InvoiceItemDiscountCreateInput>>>;
};

export type InvoiceItemManyInput = {
  connect?: InputMaybe<Array<InputMaybe<UniqueInput>>>;
  create?: InputMaybe<Array<InputMaybe<InvoiceItemCreateInput>>>;
  update?: InputMaybe<Array<InputMaybe<InvoiceItemUpdateInput>>>;
};

export type InvoiceItemPayment = {
  amount: Scalars['Int']['output'];
  createdAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  invoiceItem: InvoiceItem;
  payment: Payment;
  paymentId?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Date']['output'];
};

export type InvoiceItemPaymentCreateInput = {
  amount: Scalars['Int']['input'];
  invoiceItem?: InputMaybe<ConnectUniqueInput>;
  payment?: InputMaybe<ConnectUniqueInput>;
};

export type InvoiceItemPaymentManyInput = {
  create?: InputMaybe<Array<InputMaybe<InvoiceItemPaymentCreateInput>>>;
};

export type InvoiceItemUpdateInput = {
  data?: InputMaybe<InvoiceItemCreateInput>;
  where?: InputMaybe<UniqueInput>;
};

export type InvoiceItemWhereInput = {
  AND?: InputMaybe<InvoiceItemWhereInput>;
  NOT?: InputMaybe<InvoiceItemWhereInput>;
  OR?: InputMaybe<Array<InvoiceItemWhereInput>>;
  addonId?: InputMaybe<StringFilter>;
  amount?: InputMaybe<IntFilter>;
  captyn?: InputMaybe<FrequencyFilter>;
  createdAt?: InputMaybe<DateFilter>;
  id?: InputMaybe<StringFilter>;
  invoice?: InputMaybe<InvoiceWhereInput>;
  status?: InputMaybe<InvoiceStatusFilter>;
};

export type InvoiceItemWhereManyInput = {
  every?: InputMaybe<InvoiceItemWhereInput>;
  none?: InputMaybe<InvoiceItemWhereInput>;
  some?: InputMaybe<InvoiceItemWhereInput>;
};

export type InvoiceManyInput = {
  update?: InputMaybe<Array<InputMaybe<InvoiceUpdateInput>>>;
};

export type InvoiceOrderByInput = {
  createdAt?: InputMaybe<SortOrder>;
  invoiceDate?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export const InvoiceStatus = {
  Error: 'Error',
  Paid: 'Paid',
  Pending: 'Pending',
  Preview: 'Preview',
  Refunded: 'Refunded'
} as const;

export type InvoiceStatus = typeof InvoiceStatus[keyof typeof InvoiceStatus];
export type InvoiceStatusFilter = {
  equals?: InputMaybe<InvoiceStatus>;
  in?: InputMaybe<Array<InvoiceStatus>>;
  not?: InputMaybe<InvoiceStatus>;
  notIn?: InputMaybe<Array<InvoiceStatus>>;
};

export type InvoiceUpdateInput = {
  data?: InputMaybe<InvoiceCreateInput>;
  where?: InputMaybe<UniqueInput>;
};

export type InvoiceWhereInput = {
  AND?: InputMaybe<InvoiceWhereInput>;
  NOT?: InputMaybe<InvoiceWhereInput>;
  OR?: InputMaybe<Array<InvoiceWhereInput>>;
  id?: InputMaybe<StringFilter>;
  invoiceItems?: InputMaybe<InvoiceItemWhereManyInput>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<InvoiceStatusFilter>;
  user?: InputMaybe<UserWhereInput>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type Job = {
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  status: MeetStatus;
  title: Scalars['String']['output'];
};

export type JobConnectCreateInput = {
  connect?: InputMaybe<UniqueInput>;
  create?: InputMaybe<JobCreateInput>;
};

export type JobCreateInput = {
  description: Scalars['String']['input'];
  organization?: InputMaybe<ConnectUniqueInput>;
  status: MeetStatus;
  title: Scalars['String']['input'];
};

export type JobCredit = {
  amount: Scalars['Float']['output'];
  createdAt: Scalars['Date']['output'];
  createdBy: User;
  id: Scalars['ID']['output'];
  note?: Maybe<Scalars['String']['output']>;
  type: JobCreditType;
  volunteer: MeetVolunteer;
};

export type JobCreditCreateInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  createdBy?: InputMaybe<ConnectUniqueInput>;
  job?: InputMaybe<ConnectUniqueInput>;
  meet?: InputMaybe<ConnectUniqueInput>;
  note?: InputMaybe<Scalars['String']['input']>;
  timeslot?: InputMaybe<ConnectUniqueInput>;
  type?: InputMaybe<EventType>;
};

export type JobCreditManyInput = {
  create?: InputMaybe<Array<InputMaybe<JobCreditCreateInput>>>;
  delete?: InputMaybe<Array<InputMaybe<UniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<JobCreditUpdateInput>>>;
};

export const JobCreditType = {
  Add: 'Add',
  CheckIn: 'CheckIn',
  Remove: 'Remove',
  Set: 'Set',
  UnCheckIn: 'UnCheckIn',
  Unverified: 'Unverified',
  Verified: 'Verified'
} as const;

export type JobCreditType = typeof JobCreditType[keyof typeof JobCreditType];
export type JobCreditUpdateInput = {
  data?: InputMaybe<JobCreditCreateInput>;
  where?: InputMaybe<UniqueInput>;
};

export type JobCreditWhereInput = {
  userId: Scalars['ID']['input'];
};

export type JobOrderByInput = {
  title?: InputMaybe<SortOrder>;
};

export type JobUpdateInput = {
  data?: InputMaybe<JobCreateInput>;
  where?: InputMaybe<UniqueInput>;
};

export type JobWhereInput = {
  organizationId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<MeetStatus>;
};

export type LegalEntity = {
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  verified?: Maybe<Scalars['Boolean']['output']>;
};

export const Level = {
  AccountOwner: 'AccountOwner',
  Admin: 'Admin',
  Captyn: 'Captyn',
  Instructor: 'Instructor',
  Kiosk: 'Kiosk',
  Manager: 'Manager',
  Organization: 'Organization',
  Sales: 'Sales',
  Student: 'Student',
  SuperAdmin: 'SuperAdmin'
} as const;

export type Level = typeof Level[keyof typeof Level];
export type LevelFilter = {
  equals?: InputMaybe<Level>;
  in?: InputMaybe<Array<Level>>;
  not?: InputMaybe<Level>;
  notIn?: InputMaybe<Array<Level>>;
};

export type Location = {
  active: Scalars['Boolean']['output'];
  address1?: Maybe<Scalars['String']['output']>;
  address2?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Date']['output'];
  hideInFilters: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  organization?: Maybe<Organization>;
  organizationId?: Maybe<Scalars['String']['output']>;
  shortTitle?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
  zip?: Maybe<Scalars['String']['output']>;
  zones: Array<Zone>;
};


export type LocationzonesArgs = {
  orderBy?: InputMaybe<LocationOrderByInput>;
};

export type LocationCreateInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  address1?: InputMaybe<Scalars['String']['input']>;
  address2?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  hideInFilters?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  lat?: InputMaybe<Scalars['Float']['input']>;
  lng?: InputMaybe<Scalars['Float']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<ConnectUniqueInput>;
  shortTitle?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
  zones?: InputMaybe<ZoneManyInput>;
};

export type LocationInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  lat: Scalars['Float']['input'];
  lng: Scalars['Float']['input'];
  state?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type LocationManyInput = {
  create?: InputMaybe<Array<InputMaybe<LocationCreateInput>>>;
  update?: InputMaybe<Array<InputMaybe<LocationUpdateInput>>>;
};

export type LocationNestedInput = {
  connect?: InputMaybe<UniqueInput>;
  create?: InputMaybe<LocationCreateInput>;
};

export type LocationOrderByInput = {
  order?: InputMaybe<SortOrder>;
};

export type LocationUpdateInput = {
  data?: InputMaybe<LocationCreateInput>;
  where?: InputMaybe<UniqueInput>;
};

export type LocationWhereInput = {
  hideInFilters?: InputMaybe<Scalars['Boolean']['input']>;
  organizationId: Scalars['String']['input'];
};

export type LoginInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
  password?: InputMaybe<Scalars['String']['input']>;
};

export type ManageJobCreditsIdInput = {
  id: Scalars['ID']['input'];
  volunteerId?: InputMaybe<Scalars['ID']['input']>;
};

export type ManageJobCreditsInput = {
  action: JobCreditType;
  amount: Scalars['Float']['input'];
  filter?: InputMaybe<Scalars['String']['input']>;
  ids: Array<ManageJobCreditsIdInput>;
  note?: InputMaybe<Scalars['String']['input']>;
  volunteerEventId?: InputMaybe<Scalars['ID']['input']>;
};

export type MeInput = {
  organizationId: Scalars['ID']['input'];
};

export type Meet = {
  accounts: Array<User>;
  ageUpDate?: Maybe<Scalars['Date']['output']>;
  allFeesToSameAccount: Scalars['Boolean']['output'];
  allowNoTimeEntries: Scalars['Boolean']['output'];
  billingCategory?: Maybe<BillingCategory>;
  chargeAdjustments: Array<MeetChargeAdjustment>;
  charges?: Maybe<Scalars['Json']['output']>;
  chargesDue: Scalars['Int']['output'];
  city?: Maybe<Scalars['String']['output']>;
  counts?: Maybe<Scalars['Json']['output']>;
  course?: Maybe<MeetCourseType>;
  createdAt: Scalars['Date']['output'];
  department?: Maybe<Department>;
  description?: Maybe<Scalars['String']['output']>;
  eligibleCourses?: Maybe<Scalars['String']['output']>;
  enableVolunteerSignup: Scalars['Boolean']['output'];
  enableVolunteers: Scalars['Boolean']['output'];
  endDate?: Maybe<Scalars['Date']['output']>;
  enforceTimeStandards: Scalars['Boolean']['output'];
  entryDeadline?: Maybe<Scalars['Date']['output']>;
  entryType: MeetEntryType;
  eventSelection: Scalars['Boolean']['output'];
  excluded: Array<User>;
  externalId?: Maybe<Scalars['Int']['output']>;
  files: Array<File>;
  hostFacilityFee: Scalars['Int']['output'];
  hostSwimmerFee: Scalars['Int']['output'];
  hostTeamFee: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  import?: Maybe<File>;
  importId?: Maybe<Scalars['ID']['output']>;
  invoiceItems: Array<InvoiceItem>;
  lineItemFees: Array<Fee>;
  lsc?: Maybe<Scalars['String']['output']>;
  lscNumber?: Maybe<Scalars['String']['output']>;
  maxCombined?: Maybe<Scalars['Int']['output']>;
  maxEnrollment?: Maybe<Scalars['Int']['output']>;
  maxIndividual?: Maybe<Scalars['Int']['output']>;
  maxRelay?: Maybe<Scalars['Int']['output']>;
  meetCharges: Array<MeetCharge>;
  meetDeclarations: Array<MeetDeclaration>;
  meetFees: Array<MeetFee>;
  meetPresentations: Array<MeetPresentation>;
  minAge?: Maybe<Scalars['Int']['output']>;
  optIn: Scalars['Boolean']['output'];
  optInPerDay: Scalars['Boolean']['output'];
  organization: Organization;
  organizations: Array<Organization>;
  participants: Array<User>;
  perEventFee: Scalars['Boolean']['output'];
  processingResults: Scalars['Boolean']['output'];
  publishDate?: Maybe<Scalars['Date']['output']>;
  publishOnWebsite: Scalars['Boolean']['output'];
  readyToCharge: Scalars['Int']['output'];
  responseEndDate?: Maybe<Scalars['Date']['output']>;
  responseStartDate?: Maybe<Scalars['Date']['output']>;
  sessions: Array<MeetSession>;
  startDate?: Maybe<Scalars['Date']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  status: MeetStatus;
  tags: Array<Tag>;
  teams?: Maybe<Scalars['Json']['output']>;
  timeConversions?: Maybe<Scalars['String']['output']>;
  timesAfter?: Maybe<Scalars['Date']['output']>;
  timeslots: Array<MeetTimeslot>;
  title: Scalars['String']['output'];
  unpublishDate?: Maybe<Scalars['Date']['output']>;
  updatedAt: Scalars['Date']['output'];
  volunteerEvent?: Maybe<VolunteerEvent>;
  volunteers: Array<MeetVolunteer>;
  webhookData: Scalars['Json']['output'];
};

export type MeetAttendance = {
  attending: Scalars['Boolean']['output'];
  createdAt: Scalars['Date']['output'];
  date?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  meetDeclaration: MeetDeclaration;
  meetDeclarationId: Scalars['ID']['output'];
  relays: Scalars['Boolean']['output'];
  session: MeetSession;
  sessionId?: Maybe<Scalars['ID']['output']>;
  updatedAt: Scalars['Date']['output'];
};

export type MeetAttendanceCreateInput = {
  attending?: InputMaybe<Scalars['Boolean']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  relays?: InputMaybe<Scalars['Boolean']['input']>;
  session?: InputMaybe<ConnectUniqueInput>;
};

export type MeetAttendanceManyInput = {
  create?: InputMaybe<Array<InputMaybe<MeetAttendanceCreateInput>>>;
  delete?: InputMaybe<Array<InputMaybe<UniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<MeetAttendanceUpdateInput>>>;
};

export type MeetAttendanceUpdateInput = {
  data?: InputMaybe<MeetAttendanceCreateInput>;
  where?: InputMaybe<UniqueInput>;
};

export type MeetCharge = {
  fees: Array<MeetFee>;
  id: Scalars['ID']['output'];
  individualEvents: Scalars['Int']['output'];
  participant: User;
  participantId: Scalars['ID']['output'];
  relayEvents: Scalars['Int']['output'];
};

export type MeetChargeAdjustment = {
  billingCategory: BillingCategory;
  billingCategoryId: Scalars['ID']['output'];
  department: Department;
  departmentId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
};

export type MeetChargeAdjustmentCreateInput = {
  billingCategory?: InputMaybe<ConnectUniqueInput>;
  department?: InputMaybe<ConnectUniqueInput>;
};

export type MeetChargeAdjustmentManyInput = {
  create?: InputMaybe<Array<InputMaybe<MeetChargeAdjustmentCreateInput>>>;
  delete?: InputMaybe<Array<InputMaybe<UniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<MeetChargeAdjustmentUpdateInput>>>;
};

export type MeetChargeAdjustmentUpdateInput = {
  data?: InputMaybe<MeetChargeAdjustmentCreateInput>;
  where?: InputMaybe<UniqueInput>;
};

export type MeetChargeCreateInput = {
  fees?: InputMaybe<ConnectManyInput>;
  individualEvents?: InputMaybe<Scalars['Int']['input']>;
  participant?: InputMaybe<ConnectUniqueInput>;
  relayEvents?: InputMaybe<Scalars['Int']['input']>;
};

export type MeetChargeManyInput = {
  create?: InputMaybe<Array<InputMaybe<MeetChargeCreateInput>>>;
  delete?: InputMaybe<Array<InputMaybe<UniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<MeetChargeUpdateInput>>>;
};

export type MeetChargeUpdateInput = {
  data?: InputMaybe<MeetChargeCreateInput>;
  where?: InputMaybe<UniqueInput>;
};

export type MeetCountsPayload = {
  entered: Scalars['Int']['output'];
  exceeded: Scalars['Int']['output'];
  individualEntries: Scalars['Int']['output'];
  individualFemaleEntries: Scalars['Int']['output'];
  individualMaleEntries: Scalars['Int']['output'];
  missing: Scalars['Int']['output'];
  optIn: Scalars['Int']['output'];
  optOut: Scalars['Int']['output'];
  relayEntries: Scalars['Int']['output'];
  relaySwimmers: Scalars['Int']['output'];
  teams: Array<Scalars['String']['output']>;
  totalEntries: Scalars['Int']['output'];
  undeclared: Scalars['Int']['output'];
};

export type MeetCourseFilter = {
  equals?: InputMaybe<MeetCourseType>;
  in?: InputMaybe<Array<InputMaybe<MeetCourseType>>>;
  notIn?: InputMaybe<Array<InputMaybe<MeetCourseType>>>;
};

export const MeetCourseType = {
  LCM: 'LCM',
  SCM: 'SCM',
  Yards: 'Yards'
} as const;

export type MeetCourseType = typeof MeetCourseType[keyof typeof MeetCourseType];
export type MeetCreateInput = {
  ageUpDate?: InputMaybe<Scalars['Date']['input']>;
  allFeesToSameAccount?: InputMaybe<Scalars['Boolean']['input']>;
  allowNoTimeEntries?: InputMaybe<Scalars['Boolean']['input']>;
  billingCategory?: InputMaybe<BillingCategoryNestedInput>;
  chargeAdjustments?: InputMaybe<MeetChargeAdjustmentManyInput>;
  city?: InputMaybe<Scalars['String']['input']>;
  course?: InputMaybe<MeetCourseType>;
  department?: InputMaybe<ConnectUniqueInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  eligibleCourses?: InputMaybe<Scalars['String']['input']>;
  enableVolunteerSignup?: InputMaybe<Scalars['Boolean']['input']>;
  enableVolunteers?: InputMaybe<Scalars['Boolean']['input']>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  enforceTimeStandards?: InputMaybe<Scalars['Boolean']['input']>;
  entryDeadline?: InputMaybe<Scalars['Date']['input']>;
  entryType?: InputMaybe<MeetEntryType>;
  eventSelection?: InputMaybe<Scalars['Boolean']['input']>;
  excluded?: InputMaybe<UserManyInput>;
  files?: InputMaybe<FileManyInput>;
  hostFacilityFee?: InputMaybe<Scalars['Int']['input']>;
  hostSwimmerFee?: InputMaybe<Scalars['Int']['input']>;
  hostTeamFee?: InputMaybe<Scalars['Int']['input']>;
  lineItemFees?: InputMaybe<FeeManyInput>;
  lsc?: InputMaybe<Scalars['String']['input']>;
  lscNumber?: InputMaybe<Scalars['String']['input']>;
  maxCombined?: InputMaybe<Scalars['Int']['input']>;
  maxEnrollment?: InputMaybe<Scalars['Int']['input']>;
  maxIndividual?: InputMaybe<Scalars['Int']['input']>;
  maxRelay?: InputMaybe<Scalars['Int']['input']>;
  meetCharges?: InputMaybe<MeetChargeManyInput>;
  meetDeclarations?: InputMaybe<MeetDeclarationManyInput>;
  meetFees?: InputMaybe<MeetFeeManyInput>;
  meetPresentations?: InputMaybe<MeetPresentationManyInput>;
  minAge?: InputMaybe<Scalars['Int']['input']>;
  optIn?: InputMaybe<Scalars['Boolean']['input']>;
  optInPerDay?: InputMaybe<Scalars['Boolean']['input']>;
  organization?: InputMaybe<ConnectUniqueInput>;
  organizations?: InputMaybe<ConnectManyInput>;
  perEventFee?: InputMaybe<Scalars['Boolean']['input']>;
  publishDate?: InputMaybe<Scalars['Date']['input']>;
  publishOnWebsite?: InputMaybe<Scalars['Boolean']['input']>;
  responseEndDate?: InputMaybe<Scalars['Date']['input']>;
  responseStartDate?: InputMaybe<Scalars['Date']['input']>;
  sessions?: InputMaybe<MeetSessionManyInput>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<MeetStatus>;
  tags?: InputMaybe<TagManyInput>;
  teams?: InputMaybe<Scalars['Json']['input']>;
  timeConversions?: InputMaybe<Scalars['String']['input']>;
  timeStandards?: InputMaybe<ConnectUniqueInput>;
  timesAfter?: InputMaybe<Scalars['Date']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  unpublishDate?: InputMaybe<Scalars['Date']['input']>;
  volunteerEvent?: InputMaybe<ConnectUniqueInput>;
};

export type MeetDeclaration = {
  attendances: Array<MeetAttendance>;
  attending: Scalars['Boolean']['output'];
  createdAt: Scalars['Date']['output'];
  dates: Array<Scalars['Date']['output']>;
  entries: Array<MeetEntry>;
  events: Array<Event>;
  id: Scalars['ID']['output'];
  locked: Scalars['Boolean']['output'];
  note?: Maybe<Scalars['String']['output']>;
  team?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Date']['output'];
  user: User;
  userId: Scalars['ID']['output'];
};

export type MeetDeclarationCreateInput = {
  attendances?: InputMaybe<MeetAttendanceManyInput>;
  attending?: InputMaybe<Scalars['Boolean']['input']>;
  dates?: InputMaybe<DateManyInput>;
  entries?: InputMaybe<MeetEntryManyInput>;
  events?: InputMaybe<EventManyInput>;
  locked?: InputMaybe<Scalars['Boolean']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<ConnectUniqueInput>;
};

export type MeetDeclarationManyInput = {
  create?: InputMaybe<Array<InputMaybe<MeetDeclarationCreateInput>>>;
  delete?: InputMaybe<Array<InputMaybe<UniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<MeetDeclarationUpdateInput>>>;
};

export type MeetDeclarationUpdateInput = {
  data?: InputMaybe<MeetDeclarationCreateInput>;
  where?: InputMaybe<UniqueInput>;
};

export type MeetDeclarationWhereInput = {
  meetEventId?: InputMaybe<Scalars['ID']['input']>;
  meetId: Scalars['ID']['input'];
};

export type MeetEntry = {
  bonus?: Maybe<Scalars['Boolean']['output']>;
  course?: Maybe<MeetCourseType>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  exhibition?: Maybe<Scalars['Boolean']['output']>;
  heat?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  lane?: Maybe<Scalars['Int']['output']>;
  meetDeclaration?: Maybe<MeetDeclaration>;
  meetEvent?: Maybe<MeetEvent>;
  meetEventId: Scalars['ID']['output'];
  note?: Maybe<Scalars['String']['output']>;
  nt?: Maybe<Scalars['Boolean']['output']>;
  relay?: Maybe<MeetRelay>;
  relayId?: Maybe<Scalars['ID']['output']>;
  stroke?: Maybe<Scalars['String']['output']>;
  time?: Maybe<Scalars['Date']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type MeetEntryCreateInput = {
  bonus?: InputMaybe<Scalars['Boolean']['input']>;
  course?: InputMaybe<MeetCourseType>;
  exhibition?: InputMaybe<Scalars['Boolean']['input']>;
  heat?: InputMaybe<Scalars['Int']['input']>;
  lane?: InputMaybe<Scalars['Int']['input']>;
  meetDeclaration?: InputMaybe<ConnectUniqueInput>;
  meetEvent?: InputMaybe<ConnectUniqueInput>;
  note?: InputMaybe<Scalars['String']['input']>;
  relay?: InputMaybe<ConnectUniqueInput>;
  stroke?: InputMaybe<Scalars['String']['input']>;
  time?: InputMaybe<Scalars['Date']['input']>;
};

export type MeetEntryInput = {
  bonus?: InputMaybe<Scalars['Boolean']['input']>;
  course?: InputMaybe<MeetCourseType>;
  exhibition?: InputMaybe<Scalars['Boolean']['input']>;
  heat?: InputMaybe<Scalars['Int']['input']>;
  lane?: InputMaybe<Scalars['Int']['input']>;
  locked?: InputMaybe<Scalars['Boolean']['input']>;
  meetEventId?: InputMaybe<Scalars['ID']['input']>;
  meetId: Scalars['ID']['input'];
  nt?: InputMaybe<Scalars['Boolean']['input']>;
  participantIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  relayId?: InputMaybe<Scalars['ID']['input']>;
  stroke?: InputMaybe<Scalars['String']['input']>;
  team?: InputMaybe<Scalars['String']['input']>;
  time?: InputMaybe<Scalars['Date']['input']>;
  update?: InputMaybe<Scalars['Boolean']['input']>;
  userId: Scalars['ID']['input'];
};

export type MeetEntryManyInput = {
  create?: InputMaybe<Array<InputMaybe<MeetEntryCreateInput>>>;
  delete?: InputMaybe<Array<InputMaybe<UniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<MeetEntryUpdateInput>>>;
};

export const MeetEntryType = {
  Captyn: 'Captyn',
  Swimcloud: 'Swimcloud',
  Unknown: 'Unknown'
} as const;

export type MeetEntryType = typeof MeetEntryType[keyof typeof MeetEntryType];
export type MeetEntryUpdateInput = {
  data?: InputMaybe<MeetEntryCreateInput>;
  where?: InputMaybe<UniqueInput>;
};

export type MeetEvent = {
  alternateGenders?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  distance?: Maybe<Scalars['Int']['output']>;
  entries: Array<MeetEntry>;
  excluded: Array<User>;
  fasterThanLCM?: Maybe<Scalars['Date']['output']>;
  fasterThanSCM?: Maybe<Scalars['Date']['output']>;
  fasterThanYards?: Maybe<Scalars['Date']['output']>;
  fee?: Maybe<Scalars['Int']['output']>;
  format?: Maybe<MeetSessionFormat>;
  gender?: Maybe<Gender>;
  id: Scalars['ID']['output'];
  maxAge?: Maybe<Scalars['Int']['output']>;
  minAge?: Maybe<Scalars['Int']['output']>;
  number?: Maybe<Scalars['String']['output']>;
  relays: Array<MeetRelay>;
  session?: Maybe<MeetSession>;
  slowerThanLCM?: Maybe<Scalars['Date']['output']>;
  slowerThanSCM?: Maybe<Scalars['Date']['output']>;
  slowerThanYards?: Maybe<Scalars['Date']['output']>;
  stroke?: Maybe<Scalars['String']['output']>;
  type?: Maybe<MeetEventType>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type MeetEventCreateInput = {
  alternateGenders?: InputMaybe<Scalars['Boolean']['input']>;
  distance?: InputMaybe<Scalars['Int']['input']>;
  excluded?: InputMaybe<UserManyInput>;
  fasterThanLCM?: InputMaybe<Scalars['Date']['input']>;
  fasterThanSCM?: InputMaybe<Scalars['Date']['input']>;
  fasterThanYards?: InputMaybe<Scalars['Date']['input']>;
  fee?: InputMaybe<Scalars['Int']['input']>;
  format?: InputMaybe<MeetSessionFormat>;
  gender?: InputMaybe<Gender>;
  maxAge?: InputMaybe<Scalars['Int']['input']>;
  minAge?: InputMaybe<Scalars['Int']['input']>;
  number?: InputMaybe<Scalars['String']['input']>;
  relays?: InputMaybe<MeetRelayManyInput>;
  session?: InputMaybe<ConnectUniqueInput>;
  slowerThanLCM?: InputMaybe<Scalars['Date']['input']>;
  slowerThanSCM?: InputMaybe<Scalars['Date']['input']>;
  slowerThanYards?: InputMaybe<Scalars['Date']['input']>;
  stroke?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<MeetEventType>;
};

export type MeetEventEligibilityCourseResult = {
  course: MeetCourseType;
  diff?: Maybe<Scalars['Float']['output']>;
  eligible: Scalars['Boolean']['output'];
  meetResult?: Maybe<MeetResult>;
  percentage?: Maybe<Scalars['Float']['output']>;
  standard?: Maybe<Scalars['Date']['output']>;
};

export type MeetEventEligibilityResult = {
  courseResults: Array<MeetEventEligibilityCourseResult>;
  event: MeetEvent;
};

export type MeetEventManyInput = {
  create?: InputMaybe<Array<InputMaybe<MeetEventCreateInput>>>;
  delete?: InputMaybe<Array<InputMaybe<UniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<MeetEventUpdateInput>>>;
};

export const MeetEventType = {
  Individual: 'Individual',
  IndividualRelay: 'IndividualRelay',
  Relay: 'Relay'
} as const;

export type MeetEventType = typeof MeetEventType[keyof typeof MeetEventType];
export type MeetEventUpdateInput = {
  data?: InputMaybe<MeetEventCreateInput>;
  where?: InputMaybe<UniqueInput>;
};

export type MeetFee = {
  createdAt: Scalars['Date']['output'];
  externalId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  price: Scalars['Int']['output'];
  title: Scalars['String']['output'];
  type: MeetFeeType;
  updatedAt: Scalars['Date']['output'];
};

export type MeetFeeCreateInput = {
  price?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<MeetFeeType>;
};

export type MeetFeeManyInput = {
  create?: InputMaybe<Array<InputMaybe<MeetFeeCreateInput>>>;
  delete?: InputMaybe<Array<InputMaybe<UniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<MeetFeeUpdateInput>>>;
};

export const MeetFeeType = {
  Custom: 'Custom',
  Individual: 'Individual',
  Relay: 'Relay'
} as const;

export type MeetFeeType = typeof MeetFeeType[keyof typeof MeetFeeType];
export type MeetFeeUpdateInput = {
  data?: InputMaybe<MeetFeeCreateInput>;
  where?: InputMaybe<UniqueInput>;
};

export const MeetGenderTerminology = {
  BoysGirls: 'BoysGirls',
  MaleFemale: 'MaleFemale',
  MenWomen: 'MenWomen'
} as const;

export type MeetGenderTerminology = typeof MeetGenderTerminology[keyof typeof MeetGenderTerminology];
export type MeetJob = {
  credits: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  job: Job;
  slots: Scalars['Int']['output'];
};

export type MeetJobConnectCreateInput = {
  connect?: InputMaybe<UniqueInput>;
  create?: InputMaybe<MeetJobCreateInput>;
};

export type MeetJobCreateInput = {
  credits?: InputMaybe<Scalars['Float']['input']>;
  job?: InputMaybe<JobConnectCreateInput>;
  slots?: InputMaybe<Scalars['Int']['input']>;
  timeslot?: InputMaybe<ConnectUniqueInput>;
};

export type MeetJobManyInput = {
  create?: InputMaybe<Array<InputMaybe<MeetJobCreateInput>>>;
  delete?: InputMaybe<Array<InputMaybe<UniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<MeetJobUpdateInput>>>;
};

export type MeetJobUpdateInput = {
  data?: InputMaybe<MeetJobCreateInput>;
  where?: InputMaybe<UniqueInput>;
};

export type MeetMatchInput = {
  matched: Scalars['ID']['input'];
  meetTitle?: InputMaybe<Scalars['String']['input']>;
  swimmerMeetId: Scalars['ID']['input'];
};

export type MeetOrderByInput = {
  createdAt?: InputMaybe<SortOrder>;
  startDate?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type MeetParticipant = {
  accountOwner: User;
  avatar: File;
  birthDate: Scalars['Date']['output'];
  eligibleEvents: Array<Scalars['String']['output']>;
  enrolled: Scalars['Boolean']['output'];
  firstName: Scalars['String']['output'];
  gender: Gender;
  id: Scalars['ID']['output'];
  ineligibleEvents: Array<Scalars['String']['output']>;
  lastName: Scalars['String']['output'];
  meetResults: Array<MeetResult>;
  usaSwimmingMemberId?: Maybe<Scalars['String']['output']>;
};

export type MeetParticipantPayload = {
  counts: MeetCountsPayload;
  participants: Array<MeetParticipant>;
};

export type MeetParticipantWhereInput = {
  eventId?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<StringFilter>;
  meetId: Scalars['ID']['input'];
};

export type MeetPresentation = {
  class: Class;
  createdAt: Scalars['Date']['output'];
  eventSelection: Scalars['Boolean']['output'];
  excluded: Array<User>;
  id: Scalars['ID']['output'];
  included: Array<User>;
  optIn: Scalars['Boolean']['output'];
  optInPerDay: Scalars['Boolean']['output'];
  optOut: Scalars['Boolean']['output'];
  updatedAt: Scalars['Date']['output'];
};

export type MeetPresentationCreateInput = {
  class?: InputMaybe<ConnectUniqueInput>;
  eventSelection?: InputMaybe<Scalars['Boolean']['input']>;
  excluded?: InputMaybe<UserManyInput>;
  optIn?: InputMaybe<Scalars['Boolean']['input']>;
  optInPerDay?: InputMaybe<Scalars['Boolean']['input']>;
  optOut?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MeetPresentationListRelationFilter = {
  none?: InputMaybe<MeetPresentationWhereInput>;
  some?: InputMaybe<MeetPresentationWhereInput>;
};

export type MeetPresentationManyInput = {
  create?: InputMaybe<Array<InputMaybe<MeetPresentationCreateInput>>>;
  delete?: InputMaybe<Array<InputMaybe<UniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<MeetPresentationUpdateInput>>>;
};

export type MeetPresentationUpdateInput = {
  data?: InputMaybe<MeetPresentationCreateInput>;
  where?: InputMaybe<UniqueInput>;
};

export type MeetPresentationWhereInput = {
  class?: InputMaybe<ClassWhereInput>;
  classId?: InputMaybe<StringFilter>;
  excluded?: InputMaybe<UserListRelationFilter>;
  id?: InputMaybe<Scalars['ID']['input']>;
  included?: InputMaybe<UserListRelationFilter>;
  meetId?: InputMaybe<Scalars['ID']['input']>;
};

export type MeetRelay = {
  bonus?: Maybe<Scalars['Boolean']['output']>;
  course?: Maybe<MeetCourseType>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  customTime?: Maybe<Scalars['Boolean']['output']>;
  exhibition?: Maybe<Scalars['Boolean']['output']>;
  heat?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  lane?: Maybe<Scalars['Int']['output']>;
  participant: MeetParticipant;
  stroke: Scalars['String']['output'];
  time: Scalars['Date']['output'];
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export const MeetRelayAction = {
  FindBestRelay: 'FindBestRelay',
  MoveSwimmer: 'MoveSwimmer'
} as const;

export type MeetRelayAction = typeof MeetRelayAction[keyof typeof MeetRelayAction];
export type MeetRelayCreateInput = {
  bonus?: InputMaybe<Scalars['Boolean']['input']>;
  course?: InputMaybe<MeetCourseType>;
  customTime?: InputMaybe<Scalars['Boolean']['input']>;
  exhibition?: InputMaybe<Scalars['Boolean']['input']>;
  heat?: InputMaybe<Scalars['Int']['input']>;
  lane?: InputMaybe<Scalars['Int']['input']>;
  time?: InputMaybe<Scalars['Date']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type MeetRelayData = {
  action: MeetRelayAction;
  meetEventId: Scalars['ID']['input'];
  participantId?: InputMaybe<Scalars['ID']['input']>;
  relayId?: InputMaybe<Scalars['ID']['input']>;
  relayOrder?: InputMaybe<Scalars['Json']['input']>;
  stroke?: InputMaybe<Scalars['String']['input']>;
};

export type MeetRelayManyInput = {
  create?: InputMaybe<Array<InputMaybe<MeetRelayCreateInput>>>;
  delete?: InputMaybe<Array<InputMaybe<UniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<MeetRelayUpdateInput>>>;
};

export type MeetRelayPayload = {
  relay: Array<MeetRelay>;
  totalTime: Scalars['Int']['output'];
};

export type MeetRelayResult = {
  id: Scalars['ID']['output'];
  order: Scalars['Int']['output'];
  stroke: Scalars['String']['output'];
  time: Scalars['Date']['output'];
  user: User;
  userAge?: Maybe<Scalars['Int']['output']>;
  userFirstName?: Maybe<Scalars['String']['output']>;
  userGender?: Maybe<Gender>;
  userLastName?: Maybe<Scalars['String']['output']>;
};

export type MeetRelayUpdateInput = {
  data?: InputMaybe<MeetRelayCreateInput>;
  where?: InputMaybe<UniqueInput>;
};

export type MeetResult = {
  course: MeetCourseType;
  createdAt?: Maybe<Scalars['Date']['output']>;
  designators: Array<Designator>;
  disqualified?: Maybe<Scalars['Boolean']['output']>;
  distance: Scalars['Int']['output'];
  exhibition?: Maybe<Scalars['Boolean']['output']>;
  finals?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  isNewAchievement?: Maybe<Scalars['Boolean']['output']>;
  maxAge?: Maybe<Scalars['Int']['output']>;
  meet?: Maybe<Meet>;
  meetStartDate?: Maybe<Scalars['Date']['output']>;
  meetTitle?: Maybe<Scalars['String']['output']>;
  minAge?: Maybe<Scalars['Int']['output']>;
  nextDesignators: Array<Designator>;
  notes?: Maybe<Scalars['String']['output']>;
  raw?: Maybe<Scalars['Json']['output']>;
  relayResults?: Maybe<Array<Maybe<MeetRelayResult>>>;
  relayTeam?: Maybe<Scalars['String']['output']>;
  source?: Maybe<MeetResultSourceType>;
  splits: Array<Scalars['Date']['output']>;
  stroke: Scalars['String']['output'];
  time: Scalars['Date']['output'];
  type: MeetEventType;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  user: User;
  userAge?: Maybe<Scalars['Int']['output']>;
  userFirstName?: Maybe<Scalars['String']['output']>;
  userGender?: Maybe<Gender>;
  userLastName?: Maybe<Scalars['String']['output']>;
};

export type MeetResultCreateInput = {
  course?: InputMaybe<MeetCourseType>;
  disqualified?: InputMaybe<Scalars['Boolean']['input']>;
  distance?: InputMaybe<Scalars['Int']['input']>;
  exhibition?: InputMaybe<Scalars['Boolean']['input']>;
  finals?: InputMaybe<Scalars['Boolean']['input']>;
  maxAge?: InputMaybe<Scalars['Int']['input']>;
  meet?: InputMaybe<ConnectUniqueInput>;
  meetStartDate?: InputMaybe<Scalars['Date']['input']>;
  meetTitle?: InputMaybe<Scalars['String']['input']>;
  minAge?: InputMaybe<Scalars['Int']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  relayTeam?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<MeetResultSourceType>;
  splits?: InputMaybe<DateManyInput>;
  stroke?: InputMaybe<Scalars['String']['input']>;
  time?: InputMaybe<Scalars['Date']['input']>;
  type?: InputMaybe<MeetEventType>;
  user?: InputMaybe<ConnectUniqueInput>;
  userAge?: InputMaybe<Scalars['Int']['input']>;
  userFirstName?: InputMaybe<Scalars['String']['input']>;
  userGender?: InputMaybe<Gender>;
  userLastName?: InputMaybe<Scalars['String']['input']>;
};

export type MeetResultEligibility = {
  eligibleResults: Array<MeetEventEligibilityResult>;
  user: User;
};

export type MeetResultImprovement = {
  diff?: Maybe<Scalars['Float']['output']>;
  new: MeetResult;
  old: MeetResult;
  percentage?: Maybe<Scalars['Float']['output']>;
};

export type MeetResultOrderByInput = {
  time?: InputMaybe<SortOrder>;
};

export const MeetResultSourceType = {
  Captyn: 'Captyn',
  Hytek: 'Hytek',
  Manual: 'Manual',
  USASwimming: 'USASwimming'
} as const;

export type MeetResultSourceType = typeof MeetResultSourceType[keyof typeof MeetResultSourceType];
export type MeetResultUpdateInput = {
  data?: InputMaybe<MeetResultCreateInput>;
  where?: InputMaybe<UniqueInput>;
};

export type MeetResultWhereInput = {
  course?: InputMaybe<MeetCourseFilter>;
  disqualified?: InputMaybe<Scalars['Boolean']['input']>;
  distance?: InputMaybe<Scalars['Int']['input']>;
  meetId?: InputMaybe<Scalars['ID']['input']>;
  meetStartDate?: InputMaybe<DateFilter>;
  organizationId: Scalars['ID']['input'];
  stroke?: InputMaybe<StringFilter>;
  type?: InputMaybe<MeetEventType>;
  userId?: InputMaybe<StringFilter>;
};

export type MeetSession = {
  createdAt?: Maybe<Scalars['Date']['output']>;
  date?: Maybe<Scalars['Date']['output']>;
  format?: Maybe<MeetSessionFormat>;
  id: Scalars['ID']['output'];
  maxCombined?: Maybe<Scalars['Int']['output']>;
  maxIndividual?: Maybe<Scalars['Int']['output']>;
  maxRelay?: Maybe<Scalars['Int']['output']>;
  meetEvents: Array<MeetEvent>;
  number?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type MeetSessionCreateInput = {
  date?: InputMaybe<Scalars['Date']['input']>;
  format?: InputMaybe<MeetSessionFormat>;
  maxCombined?: InputMaybe<Scalars['Int']['input']>;
  maxIndividual?: InputMaybe<Scalars['Int']['input']>;
  maxRelay?: InputMaybe<Scalars['Int']['input']>;
  meetEvents?: InputMaybe<MeetEventManyInput>;
  number?: InputMaybe<Scalars['Int']['input']>;
};

export const MeetSessionFormat = {
  Finals: 'Finals',
  Prelims: 'Prelims',
  TimedFinals: 'TimedFinals'
} as const;

export type MeetSessionFormat = typeof MeetSessionFormat[keyof typeof MeetSessionFormat];
export type MeetSessionManyInput = {
  create?: InputMaybe<Array<InputMaybe<MeetSessionCreateInput>>>;
  delete?: InputMaybe<Array<InputMaybe<UniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<MeetSessionUpdateInput>>>;
};

export type MeetSessionUpdateInput = {
  data?: InputMaybe<MeetSessionCreateInput>;
  where?: InputMaybe<UniqueInput>;
};

export const MeetStatus = {
  Active: 'Active',
  Archived: 'Archived',
  Upcoming: 'Upcoming'
} as const;

export type MeetStatus = typeof MeetStatus[keyof typeof MeetStatus];
export type MeetStatusManyInput = {
  equals?: InputMaybe<MeetStatus>;
  in?: InputMaybe<Array<InputMaybe<MeetStatus>>>;
  notIn?: InputMaybe<Array<InputMaybe<MeetStatus>>>;
};

export type MeetTimeslot = {
  endDate?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  jobs: Array<MeetJob>;
  meet: Meet;
  session?: Maybe<MeetSession>;
  sessionId?: Maybe<Scalars['ID']['output']>;
  startDate: Scalars['Date']['output'];
  title?: Maybe<Scalars['String']['output']>;
  volunteerEvent?: Maybe<VolunteerEvent>;
};

export type MeetTimeslotCreateInput = {
  endDate?: InputMaybe<Scalars['Date']['input']>;
  jobs?: InputMaybe<MeetJobManyInput>;
  session?: InputMaybe<ConnectUniqueInput>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type MeetTimeslotManyInput = {
  create?: InputMaybe<Array<InputMaybe<MeetTimeslotCreateInput>>>;
  delete?: InputMaybe<Array<InputMaybe<UniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<MeetTimeslotUpdateInput>>>;
};

export type MeetTimeslotUpdateInput = {
  data?: InputMaybe<MeetTimeslotCreateInput>;
  where?: InputMaybe<UniqueInput>;
};

export type MeetUpdatedPayload = {
  resultsLastUpdated?: Maybe<Scalars['Date']['output']>;
  status?: Maybe<MeetUpdatedStatus>;
};

export const MeetUpdatedStatus = {
  Complete: 'Complete',
  Processing: 'Processing'
} as const;

export type MeetUpdatedStatus = typeof MeetUpdatedStatus[keyof typeof MeetUpdatedStatus];
export type MeetVolunteer = {
  checkedIn: Scalars['Boolean']['output'];
  createdAt: Scalars['Date']['output'];
  events: Array<Event>;
  id: Scalars['ID']['output'];
  job: MeetJob;
  jobCredits: Array<JobCredit>;
  jobCreditsIssued: Scalars['Float']['output'];
  jobId: Scalars['String']['output'];
  name: Scalars['String']['output'];
  note: Scalars['String']['output'];
  timeslot: MeetTimeslot;
  timeslotId: Scalars['String']['output'];
  user: User;
  verified: Scalars['Boolean']['output'];
  volunteerEvent: VolunteerEvent;
};

export type MeetVolunteerCreateInput = {
  checkedIn?: InputMaybe<Scalars['Boolean']['input']>;
  job?: InputMaybe<ConnectUniqueInput>;
  jobCredits?: InputMaybe<JobCreditManyInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  timeslot?: InputMaybe<ConnectUniqueInput>;
  user?: InputMaybe<ConnectUniqueInput>;
  verified?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MeetVolunteerListRelationFilter = {
  every?: InputMaybe<MeetVolunteerWhereInput>;
  none?: InputMaybe<MeetVolunteerWhereInput>;
  some?: InputMaybe<MeetVolunteerWhereInput>;
};

export type MeetVolunteerManyInput = {
  create?: InputMaybe<Array<InputMaybe<MeetVolunteerCreateInput>>>;
  delete?: InputMaybe<Array<InputMaybe<UniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<MeetVolunteerUpdateInput>>>;
};

export type MeetVolunteerUpdateInput = {
  data?: InputMaybe<MeetVolunteerCreateInput>;
  where?: InputMaybe<UniqueInput>;
};

export type MeetVolunteerWhereInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  userId?: InputMaybe<StringFilter>;
};

export type MeetWhereInput = {
  OR?: InputMaybe<Array<MeetWhereInput>>;
  accounts?: InputMaybe<UserListRelationFilter>;
  hasStandards?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  meetPresentations?: InputMaybe<MeetPresentationListRelationFilter>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  publishDate?: InputMaybe<DateFilter>;
  publishOnWebsite?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<MeetStatusManyInput>;
  volunteerEvent?: InputMaybe<VolunteerEventWhereInput>;
};

export type MeetsCountsPayload = {
  accounts: Scalars['Int']['output'];
  chargedFees: Scalars['Int']['output'];
  pendingFees: Scalars['Int']['output'];
  swimmers: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  totalFees: Scalars['Int']['output'];
};

export type Membership = {
  accountOwner?: Maybe<User>;
  accountOwnerId?: Maybe<Scalars['String']['output']>;
  checkIns?: Maybe<Array<Maybe<CheckIn>>>;
  coupons?: Maybe<Array<Maybe<Coupon>>>;
  createdAt: Scalars['Date']['output'];
  createdBy?: Maybe<User>;
  createdById?: Maybe<Scalars['String']['output']>;
  customerRequest?: Maybe<CustomerRequest>;
  dateApproved?: Maybe<Scalars['Date']['output']>;
  disableAutoRecharge?: Maybe<Scalars['Boolean']['output']>;
  events: Array<Event>;
  finalDate?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  invoiceItems?: Maybe<Array<Maybe<InvoiceItem>>>;
  nextInvoiceDate?: Maybe<Scalars['Date']['output']>;
  offering?: Maybe<MembershipOffering>;
  offeringId?: Maybe<Scalars['String']['output']>;
  organization?: Maybe<Organization>;
  organizationId?: Maybe<Scalars['String']['output']>;
  roster: Array<User>;
  status: MembershipStatus;
  studentInfoRequestResponses: Array<StudentInfoRequestResponse>;
  updatedAt: Scalars['Date']['output'];
  visits: Scalars['Int']['output'];
};

export type MembershipCreateInput = {
  accountOwner?: InputMaybe<ConnectUniqueInput>;
  checkIns?: InputMaybe<CheckInManyInput>;
  coupons?: InputMaybe<ConnectManyInput>;
  createdBy?: InputMaybe<ConnectUniqueInput>;
  customerRequest?: InputMaybe<CustomerRequestNestedInput>;
  dateApproved?: InputMaybe<Scalars['Date']['input']>;
  disableAutoRecharge?: InputMaybe<Scalars['Boolean']['input']>;
  events?: InputMaybe<EventManyInput>;
  finalDate?: InputMaybe<Scalars['Date']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  offering?: InputMaybe<ConnectUniqueInput>;
  organization?: InputMaybe<ConnectUniqueInput>;
  roster?: InputMaybe<UserManyInput>;
  status?: InputMaybe<MembershipStatus>;
  studentInfoRequestResponses?: InputMaybe<StudentInfoRequestResponseManyInput>;
  visits?: InputMaybe<Scalars['Int']['input']>;
};

export type MembershipListRelationFilter = {
  every?: InputMaybe<MembershipWhereInput>;
  none?: InputMaybe<MembershipWhereInput>;
  some?: InputMaybe<MembershipWhereInput>;
};

export type MembershipManyInput = {
  create?: InputMaybe<Array<InputMaybe<MembershipCreateInput>>>;
  delete?: InputMaybe<Array<InputMaybe<UniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<MembershipUpdateInput>>>;
};

export type MembershipOffering = {
  addons: Array<Addon>;
  agreements: Array<Agreement>;
  allowCustomerCancellation?: Maybe<Scalars['Boolean']['output']>;
  allowSharing?: Maybe<Scalars['Boolean']['output']>;
  autoEnroll: Scalars['Boolean']['output'];
  billingCategory?: Maybe<BillingCategory>;
  billingCategoryId?: Maybe<Scalars['String']['output']>;
  capacity: CapacityStatus;
  charges: Array<Charge>;
  checkInAdjustments: Array<CheckInAdjustment>;
  checkInsPerMonth?: Maybe<Scalars['Int']['output']>;
  checkInsPerWeek?: Maybe<Scalars['Int']['output']>;
  classes: Array<Class>;
  communications: Array<Communication>;
  coupons: Array<Coupon>;
  createdAt: Scalars['Date']['output'];
  credits: Array<Credit>;
  department?: Maybe<Department>;
  departmentId?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  displayOpenSpots?: Maybe<Scalars['Boolean']['output']>;
  endDate?: Maybe<Scalars['Date']['output']>;
  endDays?: Maybe<Scalars['Int']['output']>;
  fees: Array<Fee>;
  freePresentation?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  integration: IntegrationType;
  maintainWaitlist: Scalars['Boolean']['output'];
  maxCheckIns?: Maybe<Scalars['Int']['output']>;
  maxEnrollment?: Maybe<Scalars['Int']['output']>;
  maxMembers?: Maybe<Scalars['Int']['output']>;
  memberships: Array<Membership>;
  organization?: Maybe<Organization>;
  organizationId?: Maybe<Scalars['String']['output']>;
  participantType?: Maybe<Scalars['String']['output']>;
  passType?: Maybe<Scalars['String']['output']>;
  paymentFrequency: Frequency;
  price?: Maybe<Scalars['Int']['output']>;
  priceAdjustments: Array<PriceAdjustment>;
  priceLevels: Array<PriceLevel>;
  pricePerCheckIn?: Maybe<Scalars['Int']['output']>;
  program?: Maybe<Program>;
  prorate: Scalars['Boolean']['output'];
  prorateStartEnd?: Maybe<Scalars['Boolean']['output']>;
  publishDate?: Maybe<Scalars['Date']['output']>;
  recurringDate?: Maybe<Scalars['Date']['output']>;
  registrationClose?: Maybe<Scalars['Date']['output']>;
  registrationOpen?: Maybe<Scalars['Date']['output']>;
  renewalType?: Maybe<RenewalType>;
  startDate?: Maybe<Scalars['Date']['output']>;
  status?: Maybe<OfferingStatus>;
  studentInfoRequests: Array<StudentInfoRequest>;
  tags: Array<Tag>;
  title: Scalars['String']['output'];
  type?: Maybe<Scalars['String']['output']>;
  unpublishDate?: Maybe<Scalars['Date']['output']>;
  updatedAt: Scalars['Date']['output'];
  waitlistCapacity?: Maybe<Scalars['Int']['output']>;
};


export type MembershipOfferingmembershipsArgs = {
  where?: InputMaybe<MembershipWhereInput>;
};

export type MembershipOfferingCountsPayload = {
  active: Scalars['Int']['output'];
  available: Scalars['Int']['output'];
  closed: Scalars['Int']['output'];
  pending: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  waitlist: Scalars['Int']['output'];
};

export type MembershipOfferingCreateInput = {
  addons?: InputMaybe<ConnectManyInput>;
  agreements?: InputMaybe<ConnectManyInput>;
  allowCustomerCancellation?: InputMaybe<Scalars['Boolean']['input']>;
  allowSharing?: InputMaybe<Scalars['Boolean']['input']>;
  autoEnroll?: InputMaybe<Scalars['Boolean']['input']>;
  billingCategory?: InputMaybe<BillingCategoryNestedInput>;
  capacity?: InputMaybe<CapacityStatus>;
  charges?: InputMaybe<ChargeManyInput>;
  checkInAdjustments?: InputMaybe<CheckInAdjustmentManyInput>;
  checkInsPerMonth?: InputMaybe<Scalars['Int']['input']>;
  checkInsPerWeek?: InputMaybe<Scalars['Int']['input']>;
  communications?: InputMaybe<CommunicationManyInput>;
  coupons?: InputMaybe<ConnectManyInput>;
  credits?: InputMaybe<CreditManyInput>;
  department?: InputMaybe<ConnectUniqueInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayOpenSpots?: InputMaybe<Scalars['Boolean']['input']>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  endDays?: InputMaybe<Scalars['Int']['input']>;
  fees?: InputMaybe<ConnectManyInput>;
  freePresentation?: InputMaybe<Scalars['String']['input']>;
  maintainWaitlist?: InputMaybe<Scalars['Boolean']['input']>;
  maxCheckIns?: InputMaybe<Scalars['Int']['input']>;
  maxEnrollment?: InputMaybe<Scalars['Int']['input']>;
  maxMembers?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<ConnectUniqueInput>;
  participantType?: InputMaybe<Scalars['String']['input']>;
  passType?: InputMaybe<Scalars['String']['input']>;
  paymentFrequency?: InputMaybe<Frequency>;
  price?: InputMaybe<Scalars['Int']['input']>;
  priceAdjustments?: InputMaybe<PriceAdjustmentManyInput>;
  priceLevels?: InputMaybe<PriceLevelManyInput>;
  pricePerCheckIn?: InputMaybe<Scalars['Int']['input']>;
  program?: InputMaybe<ProgramConnectCreateInput>;
  prorate?: InputMaybe<Scalars['Boolean']['input']>;
  prorateStartEnd?: InputMaybe<Scalars['Boolean']['input']>;
  publishDate?: InputMaybe<Scalars['Date']['input']>;
  recurringDate?: InputMaybe<Scalars['Date']['input']>;
  registrationClose?: InputMaybe<Scalars['Date']['input']>;
  registrationOpen?: InputMaybe<Scalars['Date']['input']>;
  renewalType?: InputMaybe<RenewalType>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
  status?: InputMaybe<OfferingStatus>;
  studentInfoRequests?: InputMaybe<ConnectManyInput>;
  tags?: InputMaybe<TagManyInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  unpublishDate?: InputMaybe<Scalars['Date']['input']>;
  waitlistCapacity?: InputMaybe<Scalars['Int']['input']>;
};

export type MembershipOfferingListRelationFilter = {
  every?: InputMaybe<MembershipOfferingWhereInput>;
  none?: InputMaybe<MembershipOfferingWhereInput>;
  some?: InputMaybe<MembershipOfferingWhereInput>;
};

export type MembershipOfferingStatsInput = {
  endDate?: InputMaybe<Scalars['Date']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  startDate?: InputMaybe<Scalars['Date']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type MembershipOfferingStatsPayload = {
  accountOwners?: Maybe<Scalars['Json']['output']>;
  availableCheckins?: Maybe<Scalars['Int']['output']>;
  billable?: Maybe<Scalars['Int']['output']>;
  coupons?: Maybe<Scalars['Int']['output']>;
  credits?: Maybe<Scalars['Int']['output']>;
  discounts?: Maybe<Scalars['Int']['output']>;
  due?: Maybe<Scalars['Int']['output']>;
  globalAgreements?: Maybe<Scalars['Int']['output']>;
  net?: Maybe<Scalars['Int']['output']>;
  paid?: Maybe<Scalars['Int']['output']>;
  refunds?: Maybe<Scalars['Int']['output']>;
};

export type MembershipOfferingWhereInput = {
  AND?: InputMaybe<Array<MembershipOfferingWhereInput>>;
  NOT?: InputMaybe<MembershipOfferingWhereInput>;
  OR?: InputMaybe<Array<MembershipOfferingWhereInput>>;
  classes?: InputMaybe<ClassListRelationFilter>;
  departmentId?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  integration?: InputMaybe<IntegrationTypeFilter>;
  locationId?: InputMaybe<StringFilter>;
  memberships?: InputMaybe<MembershipListRelationFilter>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  publishDate?: InputMaybe<DateFilter>;
  status?: InputMaybe<OfferingStatusFilter>;
  unpublishDate?: InputMaybe<DateFilter>;
};

export type MembershipOfferingsCountsPayload = {
  closed?: Maybe<Scalars['Int']['output']>;
  count?: Maybe<Scalars['Int']['output']>;
  members?: Maybe<Scalars['Int']['output']>;
  memberships?: Maybe<Scalars['Int']['output']>;
  pending?: Maybe<Scalars['Int']['output']>;
  usaSwimmingMembers?: Maybe<Scalars['Int']['output']>;
  waitlist?: Maybe<Scalars['Int']['output']>;
};

export const MembershipStatus = {
  Active: 'Active',
  Closed: 'Closed',
  Error: 'Error',
  Paused: 'Paused',
  Pending: 'Pending',
  Waitlist: 'Waitlist'
} as const;

export type MembershipStatus = typeof MembershipStatus[keyof typeof MembershipStatus];
export type MembershipStatusFilter = {
  equals?: InputMaybe<MembershipStatus>;
  in?: InputMaybe<Array<MembershipStatus>>;
  not?: InputMaybe<MembershipStatus>;
  notIn?: InputMaybe<Array<MembershipStatus>>;
};

export type MembershipUpdateInput = {
  data: MembershipCreateInput;
  where: UniqueInput;
};

export type MembershipWhereInput = {
  OR?: InputMaybe<Array<MembershipWhereInput>>;
  accountOwner?: InputMaybe<UserWhereInput>;
  accountOwnerId?: InputMaybe<Scalars['String']['input']>;
  customerRequest?: InputMaybe<CustomerRequestWhereInput>;
  id?: InputMaybe<StringFilter>;
  offering?: InputMaybe<MembershipOfferingWhereInput>;
  offeringId?: InputMaybe<StringFilter>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  roster?: InputMaybe<UserListRelationFilter>;
  status?: InputMaybe<MembershipStatusFilter>;
};

export type MembershipsCountsPayload = {
  closed?: Maybe<Scalars['Int']['output']>;
  count?: Maybe<Scalars['Int']['output']>;
  enrolled?: Maybe<Scalars['Int']['output']>;
  paused?: Maybe<Scalars['Int']['output']>;
  pending?: Maybe<Scalars['Int']['output']>;
  waitlist?: Maybe<Scalars['Int']['output']>;
};

export type Message = {
  attachments: Array<File>;
  by?: Maybe<User>;
  communication?: Maybe<Communication>;
  counts?: Maybe<MessageCount>;
  createdAt: Scalars['Date']['output'];
  from?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  message?: Maybe<Scalars['String']['output']>;
  recipients: Array<Recipient>;
  subject?: Maybe<Scalars['String']['output']>;
  type: NotificationType;
  updatedAt: Scalars['Date']['output'];
};

export type MessageCount = {
  delivered?: Maybe<Scalars['Int']['output']>;
  failed?: Maybe<Scalars['Int']['output']>;
  opened?: Maybe<Scalars['Int']['output']>;
  recipients?: Maybe<Scalars['Int']['output']>;
  summary?: Maybe<Scalars['String']['output']>;
  unsubscribed?: Maybe<Scalars['Int']['output']>;
};

export type MessageCreateInput = {
  message?: InputMaybe<Scalars['String']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<NotificationType>;
};

export type MessageInput = {
  create?: InputMaybe<MessageCreateInput>;
};

export type MessageWhereInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type MilestoneTemplate = {
  amount?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
};

export type MilestoneTemplateCreateInput = {
  amount?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type MilestoneTemplateManyInput = {
  create?: InputMaybe<Array<InputMaybe<MilestoneTemplateCreateInput>>>;
  delete?: InputMaybe<Array<InputMaybe<UniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<MilestoneTemplateUpdateInput>>>;
};

export type MilestoneTemplateUpdateInput = {
  data?: InputMaybe<MilestoneTemplateCreateInput>;
  where?: InputMaybe<UniqueInput>;
};

export type Mutation = {
  addBankAccount: Scalars['Boolean']['output'];
  addStripeExpressAccount: StripeAccountPayload;
  archiveMembershipOffering: MembershipOffering;
  bulkEditOfferings: BatchPayload;
  bulkRegister?: Maybe<UpdateManyGroupRegistrationsPayload>;
  chargeAttendance: Attendance;
  chargeMeet: Scalars['Boolean']['output'];
  checkout: Checkout;
  connectStripeAccount: ConnectStripeAccountPayload;
  createAddon: Addon;
  createAgreement: Agreement;
  createAttendance: Attendance;
  createBillingCategory: BillingCategory;
  createCharge: Charge;
  createChargeAmount: ChargeAmount;
  createClass: Class;
  createCommunication: Communication;
  createCoupon: Coupon;
  createCredit: Credit;
  createCustomerRequest: CustomerRequest;
  createCustomerServiceItem: CustomerServiceItem;
  createDepartment: Department;
  createDiscount: Discount;
  createEvaluation: Evaluation;
  createFee: Fee;
  createFile: File;
  createGroupRegistration: GroupRegistration;
  createHealthQuestion: HealthQuestion;
  createInvoice: Invoice;
  createInvoiceItem: InvoiceItem;
  createJob: Job;
  createLocation: Location;
  createMeet: Meet;
  createMeetResult: MeetResult;
  createMembership: Membership;
  createMembershipOffering: MembershipOffering;
  createNativeApp: NativeApp;
  createOffering: Offering;
  createOnboard: Onboard;
  createOrganization: Organization;
  createPayment: Payment;
  createPayout: Scalars['Boolean']['output'];
  createPriceAdjustment: PriceAdjustment;
  createPrivateSerie: PrivateSerie;
  createPrivateSerieAttendance: PrivateSerieAttendance;
  createProgram: Program;
  createRecurringCharge: RecurringCharge;
  createRecurringCredit: RecurringCredit;
  createReferral: Referral;
  createReferralTemplate: ReferralTemplate;
  createRefund: Refund;
  createStaffEvaluation: StaffEvaluation;
  createStudentAttendanceNote: StudentAttendanceNote;
  createStudentInfoRequest: StudentInfoRequest;
  createTag: Tag;
  createTimeStandard: TimeStandard;
  createToken: Token;
  createUser: User;
  createVolunteerEvent: VolunteerEvent;
  deleteAddon?: Maybe<Addon>;
  deleteAgreement?: Maybe<Agreement>;
  deleteAttendance?: Maybe<Attendance>;
  deleteBillingCategory?: Maybe<BillingCategory>;
  deleteCharge?: Maybe<Charge>;
  deleteChargeAmount?: Maybe<ChargeAmount>;
  deleteClass?: Maybe<Class>;
  deleteClasses: BatchPayload;
  deleteCommunication?: Maybe<Communication>;
  deleteCoupon?: Maybe<Coupon>;
  deleteCredit: Credit;
  deleteCustomerRequest?: Maybe<CustomerRequest>;
  deleteCustomerServiceItem?: Maybe<CustomerServiceItem>;
  deleteDepartment?: Maybe<Department>;
  deleteDiscount?: Maybe<Discount>;
  deleteEvaluation?: Maybe<Evaluation>;
  deleteFee: Fee;
  deleteFile?: Maybe<File>;
  deleteGroupRegistration?: Maybe<GroupRegistration>;
  deleteHealthQuestion?: Maybe<HealthQuestion>;
  deleteJob: Job;
  deleteLocation?: Maybe<Location>;
  deleteMeet: Meet;
  deleteMeetResult: MeetResult;
  deleteMembership?: Maybe<Membership>;
  deleteMembershipOffering?: Maybe<MembershipOffering>;
  deleteMembershipOfferings: BatchPayload;
  deleteOffering?: Maybe<Offering>;
  deleteOnboard?: Maybe<Onboard>;
  deleteOrganization?: Maybe<Organization>;
  deletePayment?: Maybe<Payment>;
  deletePriceAdjustment?: Maybe<PriceAdjustment>;
  deletePrivateSerie?: Maybe<PrivateSerie>;
  deletePrivateSerieAttendance?: Maybe<PrivateSerieAttendance>;
  deleteProgram?: Maybe<Program>;
  deleteRecurringCharge?: Maybe<RecurringCharge>;
  deleteRecurringCredit?: Maybe<RecurringCredit>;
  deleteReferral: Referral;
  deleteReferralTemplate: ReferralTemplate;
  deleteRefund?: Maybe<Refund>;
  deleteStaffEvaluation?: Maybe<StaffEvaluation>;
  deleteStripeExpressAccount: Scalars['Boolean']['output'];
  deleteStripeSource: DeleteStripeSourcePayload;
  deleteStudentAttendanceNote?: Maybe<StudentAttendanceNote>;
  deleteStudentInfoRequest?: Maybe<StudentInfoRequest>;
  deleteTag?: Maybe<Tag>;
  deleteTimeStandard: TimeStandard;
  deleteToken?: Maybe<Token>;
  deleteUser?: Maybe<User>;
  deleteVolunteerEvent: VolunteerEvent;
  disconnectStripeAccount: DisconnectStripeAccountPayload;
  downloadInvoice: Invoice;
  downloadPreviewInvoice: DownloadPreviewInvoicePayload;
  duplicateTimeStandard: TimeStandard;
  editBulkClass: BatchPayload;
  editBulkOrganization: BatchPayload;
  exportActivities?: Maybe<Scalars['String']['output']>;
  exportAddonUsage?: Maybe<Scalars['String']['output']>;
  exportBalanceAccounts?: Maybe<Scalars['String']['output']>;
  exportCaptynUsers?: Maybe<Scalars['String']['output']>;
  exportClasses?: Maybe<Scalars['String']['output']>;
  exportCouponUsage?: Maybe<Scalars['String']['output']>;
  exportCustomerServiceItems?: Maybe<Scalars['String']['output']>;
  exportDiscountUsage?: Maybe<Scalars['String']['output']>;
  exportGroupRegistrations?: Maybe<Scalars['String']['output']>;
  exportInvoiceItems: Scalars['String']['output'];
  exportInvoices?: Maybe<Scalars['String']['output']>;
  exportMeetEntries: Scalars['String']['output'];
  exportMeetEntriesReport: Scalars['String']['output'];
  exportMeetFees: Scalars['String']['output'];
  exportMeetFeesReport: Scalars['String']['output'];
  exportMeetResults: Scalars['String']['output'];
  exportMembershipOfferings?: Maybe<Scalars['String']['output']>;
  exportMemberships?: Maybe<Scalars['String']['output']>;
  exportOfferings?: Maybe<Scalars['String']['output']>;
  exportOrganizations?: Maybe<Scalars['String']['output']>;
  exportPayout?: Maybe<Scalars['String']['output']>;
  exportPayoutItems?: Maybe<Scalars['String']['output']>;
  exportPreviewInvoices?: Maybe<Scalars['String']['output']>;
  exportPrivateSeries?: Maybe<Scalars['String']['output']>;
  exportTimeStandard: Scalars['String']['output'];
  exportUsers?: Maybe<Scalars['String']['output']>;
  exportVolunteerEvents: Scalars['String']['output'];
  exportVolunteers: Scalars['String']['output'];
  getCode?: Maybe<Scalars['Boolean']['output']>;
  importData?: Maybe<Scalars['Json']['output']>;
  importMeetEvents: Meet;
  importMeetResults: ImportMeetResultsPayload;
  importTimeStandard: TimeStandard;
  kioskMode?: Maybe<Scalars['String']['output']>;
  login: AuthPayload;
  manageJobCredits: Scalars['Boolean']['output'];
  meetEntry: MeetDeclaration;
  meetRelay: Array<MeetDeclaration>;
  mergeAccount: User;
  mergeParticipant: User;
  paymentIntent: Scalars['String']['output'];
  renewUSASwimming?: Maybe<USASwimmingCountsPayload>;
  reportError: Scalars['Boolean']['output'];
  resetPassword: ResetPasswordPayload;
  retryPayment: RetryPaymentPayload;
  sendBulkEmail: SendEmailPayload;
  sendEmail: SendEmailPayload;
  sendEnrollmentSummary: EnrollmentSummaryPayload;
  sendPaymentFailed: SendEmailPayload;
  sendSms: SendSmsPayload;
  signupUser: AuthPayload;
  startServiceRun?: Maybe<Scalars['Boolean']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  switchProfile: AuthPayload;
  syncUsaSwimming: SyncUsaSwimmingPayload;
  terminalInterest: SendEmailPayload;
  terminalPayment: Payment;
  testDebit: Scalars['Boolean']['output'];
  topUpBalanceAccount?: Maybe<BalanceAccount>;
  updateAddon: Addon;
  updateAgreement: Agreement;
  updateAppSetting: AppSetting;
  updateAttendance: Attendance;
  updateBillingCategory: BillingCategory;
  updateCharge: Charge;
  updateChargeAmount: ChargeAmount;
  updateClass: Class;
  updateCommunication: Communication;
  updateCoupon: Coupon;
  updateCredit: Credit;
  updateCustomerRequest: CustomerRequest;
  updateCustomerServiceItem: CustomerServiceItem;
  updateDepartment: Department;
  updateDiscount: Discount;
  updateEvaluation: Evaluation;
  updateFee: Fee;
  updateFile: File;
  updateGroupRegistration: GroupRegistration;
  updateHealthQuestion: HealthQuestion;
  updateInvoice: Invoice;
  updateInvoiceItem: InvoiceItem;
  updateJob: Job;
  updateLocation: Location;
  updateManyGroupRegistrations?: Maybe<UpdateManyGroupRegistrationsPayload>;
  updateManyMemberships?: Maybe<UpdateManyMembershipsPayload>;
  updateManyUsers?: Maybe<Scalars['Int']['output']>;
  updateMeet: Meet;
  updateMeetDeclaration: MeetDeclaration;
  updateMeetEvent: MeetEvent;
  updateMeetResult: MeetResult;
  updateMembership: Membership;
  updateMembershipOffering: MembershipOffering;
  updateNativeApp: NativeApp;
  updateOffering: Offering;
  updateOnboard: Onboard;
  updateOrgTimeStandard: OrgTimeStandard;
  updateOrganization: Organization;
  updatePassword: AuthPayload;
  updatePayment: Payment;
  updatePriceAdjustment: PriceAdjustment;
  updatePrivateSerie: PrivateSerie;
  updatePrivateSerieAttendance: PrivateSerieAttendance;
  updateProgram: Program;
  updateRecurringCharge: RecurringCharge;
  updateRecurringCredit: RecurringCredit;
  updateReferral: Referral;
  updateReferralTemplate: ReferralTemplate;
  updateRefund: Refund;
  updateServiceRun?: Maybe<Scalars['Boolean']['output']>;
  updateStaffEvaluation: StaffEvaluation;
  updateStudentAttendanceNote: StudentAttendanceNote;
  updateStudentInfoRequest: StudentInfoRequest;
  updateTag: Tag;
  updateTimeStandard: TimeStandard;
  updateToken: Token;
  updateUser: User;
  updateVolunteerEvent: VolunteerEvent;
  upsertStripeCustomer: UpsertStripeCustomerPayload;
  validateStripePaymentMethod: Scalars['Boolean']['output'];
  viewAsUser: AuthPayload;
  volunteerCheckIn: Scalars['Boolean']['output'];
};


export type MutationaddBankAccountArgs = {
  legalEntityId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
  transferInstrumentId: Scalars['ID']['input'];
};


export type MutationaddStripeExpressAccountArgs = {
  organizationId: Scalars['ID']['input'];
};


export type MutationarchiveMembershipOfferingArgs = {
  id: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
};


export type MutationbulkEditOfferingsArgs = {
  data?: InputMaybe<BulkEditOfferingsInput>;
  where?: InputMaybe<DefaultWhereInput>;
};


export type MutationbulkRegisterArgs = {
  data: BulkRegisterInput;
};


export type MutationchargeAttendanceArgs = {
  attendanceId: Scalars['ID']['input'];
  userIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};


export type MutationchargeMeetArgs = {
  departmentId?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
  where: UniqueInput;
};


export type MutationcheckoutArgs = {
  data: CheckoutInput;
};


export type MutationconnectStripeAccountArgs = {
  data: ConnectStripeAccountInput;
};


export type MutationcreateAddonArgs = {
  data: AddonCreateInput;
};


export type MutationcreateAgreementArgs = {
  data: AgreementCreateInput;
};


export type MutationcreateAttendanceArgs = {
  data: AttendanceCreateInput;
};


export type MutationcreateBillingCategoryArgs = {
  data: BillingCategoryCreateInput;
};


export type MutationcreateChargeArgs = {
  data: ChargeCreateInput;
};


export type MutationcreateChargeAmountArgs = {
  data: ChargeAmountCreateInput;
};


export type MutationcreateClassArgs = {
  data: ClassCreateInput;
};


export type MutationcreateCommunicationArgs = {
  data: CommunicationCreateInput;
};


export type MutationcreateCouponArgs = {
  data: CouponCreateInput;
};


export type MutationcreateCreditArgs = {
  data: CreditCreateInput;
};


export type MutationcreateCustomerRequestArgs = {
  data: CustomerRequestCreateInput;
};


export type MutationcreateCustomerServiceItemArgs = {
  data: CustomerServiceItemCreateInput;
};


export type MutationcreateDepartmentArgs = {
  data: DepartmentCreateInput;
};


export type MutationcreateDiscountArgs = {
  data: DiscountCreateInput;
};


export type MutationcreateEvaluationArgs = {
  data: EvaluationCreateInput;
};


export type MutationcreateFeeArgs = {
  data: FeeCreateInput;
};


export type MutationcreateFileArgs = {
  data: FileCreateInput;
};


export type MutationcreateGroupRegistrationArgs = {
  data: GroupRegistrationCreateInput;
};


export type MutationcreateHealthQuestionArgs = {
  data: HealthQuestionCreateInput;
};


export type MutationcreateInvoiceArgs = {
  data: InvoiceCreateInput;
  email?: InputMaybe<SendEmailInput>;
  send?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationcreateInvoiceItemArgs = {
  data: InvoiceItemCreateInput;
};


export type MutationcreateJobArgs = {
  data: JobCreateInput;
};


export type MutationcreateLocationArgs = {
  data: LocationCreateInput;
};


export type MutationcreateMeetArgs = {
  data: MeetCreateInput;
};


export type MutationcreateMeetResultArgs = {
  data: MeetResultCreateInput;
};


export type MutationcreateMembershipArgs = {
  data: MembershipCreateInput;
};


export type MutationcreateMembershipOfferingArgs = {
  data: MembershipOfferingCreateInput;
};


export type MutationcreateNativeAppArgs = {
  data: NativeAppCreateInput;
};


export type MutationcreateOfferingArgs = {
  data: OfferingCreateInput;
};


export type MutationcreateOnboardArgs = {
  data: OnboardCreateInput;
};


export type MutationcreateOrganizationArgs = {
  data: OrganizationCreateInput;
};


export type MutationcreatePaymentArgs = {
  data: PaymentCreateInput;
};


export type MutationcreatePayoutArgs = {
  data: PayoutCreateInput;
};


export type MutationcreatePriceAdjustmentArgs = {
  data: PriceAdjustmentCreateInput;
};


export type MutationcreatePrivateSerieArgs = {
  data: PrivateSerieCreateInput;
};


export type MutationcreatePrivateSerieAttendanceArgs = {
  data: PrivateSerieAttendanceCreateInput;
};


export type MutationcreateProgramArgs = {
  data: ProgramCreateInput;
};


export type MutationcreateRecurringChargeArgs = {
  data: RecurringChargeCreateInput;
};


export type MutationcreateRecurringCreditArgs = {
  data: RecurringCreditCreateInput;
};


export type MutationcreateReferralArgs = {
  data: ReferralCreateInput;
};


export type MutationcreateReferralTemplateArgs = {
  data: ReferralTemplateCreateInput;
};


export type MutationcreateRefundArgs = {
  data: RefundCreateInput;
};


export type MutationcreateStaffEvaluationArgs = {
  data: StaffEvaluationCreateInput;
};


export type MutationcreateStudentAttendanceNoteArgs = {
  data: StudentAttendanceNoteCreateInput;
};


export type MutationcreateStudentInfoRequestArgs = {
  data: StudentInfoRequestCreateInput;
};


export type MutationcreateTagArgs = {
  data: TagCreateInput;
};


export type MutationcreateTimeStandardArgs = {
  data: TimeStandardCreateInput;
};


export type MutationcreateTokenArgs = {
  data: TokenCreateInput;
};


export type MutationcreateUserArgs = {
  data: UserCreateInput;
};


export type MutationcreateVolunteerEventArgs = {
  data: VolunteerEventCreateInput;
};


export type MutationdeleteAddonArgs = {
  where: UniqueInput;
};


export type MutationdeleteAgreementArgs = {
  where: UniqueInput;
};


export type MutationdeleteAttendanceArgs = {
  where: UniqueInput;
};


export type MutationdeleteBillingCategoryArgs = {
  where?: InputMaybe<UniqueInput>;
};


export type MutationdeleteChargeArgs = {
  where: UniqueInput;
};


export type MutationdeleteChargeAmountArgs = {
  where: UniqueInput;
};


export type MutationdeleteClassArgs = {
  where: UniqueInput;
};


export type MutationdeleteClassesArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<ClassWhereInput>;
};


export type MutationdeleteCommunicationArgs = {
  where: UniqueInput;
};


export type MutationdeleteCouponArgs = {
  where: UniqueInput;
};


export type MutationdeleteCreditArgs = {
  where: UniqueInput;
};


export type MutationdeleteCustomerRequestArgs = {
  where?: InputMaybe<UniqueInput>;
};


export type MutationdeleteCustomerServiceItemArgs = {
  where?: InputMaybe<UniqueInput>;
};


export type MutationdeleteDepartmentArgs = {
  where: UniqueInput;
};


export type MutationdeleteDiscountArgs = {
  where: UniqueInput;
};


export type MutationdeleteEvaluationArgs = {
  where: UniqueInput;
};


export type MutationdeleteFeeArgs = {
  where: UniqueInput;
};


export type MutationdeleteFileArgs = {
  where: UniqueInput;
};


export type MutationdeleteGroupRegistrationArgs = {
  where?: InputMaybe<UniqueInput>;
};


export type MutationdeleteHealthQuestionArgs = {
  where: UniqueInput;
};


export type MutationdeleteJobArgs = {
  where: UniqueInput;
};


export type MutationdeleteLocationArgs = {
  where: UniqueInput;
};


export type MutationdeleteMeetArgs = {
  where: UniqueInput;
};


export type MutationdeleteMeetResultArgs = {
  where: UniqueInput;
};


export type MutationdeleteMembershipArgs = {
  where: UniqueInput;
};


export type MutationdeleteMembershipOfferingArgs = {
  where?: InputMaybe<UniqueInput>;
};


export type MutationdeleteMembershipOfferingsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<MembershipOfferingWhereInput>;
};


export type MutationdeleteOfferingArgs = {
  where: UniqueInput;
};


export type MutationdeleteOnboardArgs = {
  where: UniqueInput;
};


export type MutationdeleteOrganizationArgs = {
  where: UniqueInput;
};


export type MutationdeletePaymentArgs = {
  where: UniqueInput;
};


export type MutationdeletePriceAdjustmentArgs = {
  where?: InputMaybe<UniqueInput>;
};


export type MutationdeletePrivateSerieArgs = {
  where: UniqueInput;
};


export type MutationdeletePrivateSerieAttendanceArgs = {
  where?: InputMaybe<UniqueInput>;
};


export type MutationdeleteProgramArgs = {
  where: UniqueInput;
};


export type MutationdeleteRecurringChargeArgs = {
  where: UniqueInput;
};


export type MutationdeleteRecurringCreditArgs = {
  where?: InputMaybe<UniqueInput>;
};


export type MutationdeleteReferralArgs = {
  where: UniqueInput;
};


export type MutationdeleteReferralTemplateArgs = {
  where: UniqueInput;
};


export type MutationdeleteRefundArgs = {
  where: UniqueInput;
};


export type MutationdeleteStaffEvaluationArgs = {
  where?: InputMaybe<UniqueInput>;
};


export type MutationdeleteStripeExpressAccountArgs = {
  organizationId: Scalars['ID']['input'];
  stripeExpressAccountId: Scalars['ID']['input'];
};


export type MutationdeleteStripeSourceArgs = {
  data: DeleteStripeSourceInput;
};


export type MutationdeleteStudentAttendanceNoteArgs = {
  where?: InputMaybe<UniqueInput>;
};


export type MutationdeleteStudentInfoRequestArgs = {
  where?: InputMaybe<UniqueInput>;
};


export type MutationdeleteTagArgs = {
  where: UniqueInput;
};


export type MutationdeleteTimeStandardArgs = {
  where: UniqueInput;
};


export type MutationdeleteTokenArgs = {
  where: UniqueInput;
};


export type MutationdeleteUserArgs = {
  where: UniqueInput;
};


export type MutationdeleteVolunteerEventArgs = {
  where: UniqueInput;
};


export type MutationdisconnectStripeAccountArgs = {
  data: DisconnectStripeAccountInput;
};


export type MutationdownloadInvoiceArgs = {
  id: Scalars['ID']['input'];
};


export type MutationdownloadPreviewInvoiceArgs = {
  id: Scalars['ID']['input'];
};


export type MutationduplicateTimeStandardArgs = {
  organizationId: Scalars['ID']['input'];
  timeStandardId: Scalars['ID']['input'];
};


export type MutationeditBulkClassArgs = {
  data: BulkClassCreateInput;
  filter?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<BulkClassWhereInput>;
};


export type MutationeditBulkOrganizationArgs = {
  data: BulkOrganizationCreateInput;
  filter?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<OrganizationWhereInput>;
};


export type MutationexportActivitiesArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  offeringId?: InputMaybe<Scalars['ID']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationexportAddonUsageArgs = {
  addonId?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
};


export type MutationexportBalanceAccountsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};


export type MutationexportCaptynUsersArgs = {
  where?: InputMaybe<CaptynUsersInput>;
};


export type MutationexportClassesArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  forDuplication?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ClassWhereInput>;
};


export type MutationexportCouponUsageArgs = {
  couponId?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
};


export type MutationexportCustomerServiceItemsArgs = {
  where?: InputMaybe<CustomerServiceItemWhereInput>;
};


export type MutationexportDiscountUsageArgs = {
  discountId?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
};


export type MutationexportGroupRegistrationsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<GroupRegistrationWhereInput>;
};


export type MutationexportInvoiceItemsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<InvoiceItemWhereInput>;
};


export type MutationexportInvoicesArgs = {
  where?: InputMaybe<ExportInvoicesInput>;
};


export type MutationexportMeetEntriesArgs = {
  where: UniqueInput;
};


export type MutationexportMeetEntriesReportArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  where: ExportMeetEntriesReportInput;
};


export type MutationexportMeetFeesArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  where: MeetWhereInput;
};


export type MutationexportMeetFeesReportArgs = {
  where: ExportMeetFeesReportInput;
};


export type MutationexportMeetResultsArgs = {
  byEvent?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
  pdf?: InputMaybe<Scalars['Boolean']['input']>;
  where: MeetResultWhereInput;
};


export type MutationexportMembershipOfferingsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<MembershipOfferingWhereInput>;
};


export type MutationexportMembershipsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<MembershipWhereInput>;
};


export type MutationexportOfferingsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<OrganizationWhereInput>;
};


export type MutationexportOrganizationsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<OrganizationWhereInput>;
};


export type MutationexportPayoutArgs = {
  where: FinancialReportInput;
};


export type MutationexportPayoutItemsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  itemized?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PayoutItemWhereInput>;
};


export type MutationexportPreviewInvoicesArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  includeCaptyn?: InputMaybe<Scalars['Boolean']['input']>;
  itemized?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationexportPrivateSeriesArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<PrivateSerieWhereInput>;
};


export type MutationexportTimeStandardArgs = {
  pdf?: InputMaybe<Scalars['Boolean']['input']>;
  timeStandardId: Scalars['ID']['input'];
};


export type MutationexportUsersArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<UserWhereInput>;
};


export type MutationexportVolunteerEventsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  where: VolunteerEventWhereInput;
};


export type MutationexportVolunteersArgs = {
  where: ExportVolunteersInput;
};


export type MutationgetCodeArgs = {
  asLink?: InputMaybe<Scalars['Boolean']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
  sms?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationimportDataArgs = {
  data: ImportDataInput;
};


export type MutationimportMeetEventsArgs = {
  file: Scalars['ID']['input'];
  organization: Scalars['ID']['input'];
  run: Scalars['Boolean']['input'];
};


export type MutationimportMeetResultsArgs = {
  data?: InputMaybe<ImportMeetResultsInput>;
};


export type MutationimportTimeStandardArgs = {
  file: Scalars['ID']['input'];
};


export type MutationkioskModeArgs = {
  organizationId: Scalars['ID']['input'];
};


export type MutationloginArgs = {
  data: LoginInput;
};


export type MutationmanageJobCreditsArgs = {
  data: ManageJobCreditsInput;
};


export type MutationmeetEntryArgs = {
  data: MeetEntryInput;
};


export type MutationmeetRelayArgs = {
  data: MeetRelayData;
  filter?: InputMaybe<Scalars['String']['input']>;
  where: UniqueInput;
};


export type MutationmergeAccountArgs = {
  changePrimary?: InputMaybe<Scalars['Boolean']['input']>;
  from: Scalars['ID']['input'];
  link?: InputMaybe<Scalars['Boolean']['input']>;
  sendEmail?: InputMaybe<Scalars['Boolean']['input']>;
  to: Scalars['ID']['input'];
};


export type MutationmergeParticipantArgs = {
  from: Scalars['ID']['input'];
  sendEmail?: InputMaybe<Scalars['Boolean']['input']>;
  to: Scalars['ID']['input'];
};


export type MutationpaymentIntentArgs = {
  amount?: InputMaybe<Scalars['Int']['input']>;
  setupIntentId?: InputMaybe<Scalars['ID']['input']>;
  userId: Scalars['ID']['input'];
};


export type MutationrenewUSASwimmingArgs = {
  id?: InputMaybe<StringFilter>;
  newMembers?: InputMaybe<Scalars['Json']['input']>;
};


export type MutationreportErrorArgs = {
  error?: InputMaybe<ReportErrorInput>;
};


export type MutationresetPasswordArgs = {
  data: ResetPasswordInput;
};


export type MutationretryPaymentArgs = {
  organizationId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationsendBulkEmailArgs = {
  data: SendEmailInput;
  filter?: InputMaybe<Scalars['String']['input']>;
};


export type MutationsendEmailArgs = {
  data: SendEmailInput;
};


export type MutationsendEnrollmentSummaryArgs = {
  dataOnly?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};


export type MutationsendPaymentFailedArgs = {
  userIds: Array<Scalars['ID']['input']>;
};


export type MutationsendSmsArgs = {
  data: SendSmsInput;
};


export type MutationsignupUserArgs = {
  data: SignupUserInput;
};


export type MutationswitchProfileArgs = {
  organizationId: Scalars['ID']['input'];
};


export type MutationsyncUsaSwimmingArgs = {
  customerServiceItemId?: InputMaybe<Scalars['ID']['input']>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  organizationId: Scalars['ID']['input'];
  reset?: InputMaybe<Scalars['Boolean']['input']>;
  sendEmail: Scalars['Boolean']['input'];
};


export type MutationterminalInterestArgs = {
  data: TerminalInterestInput;
};


export type MutationterminalPaymentArgs = {
  data: TerminalPaymentInput;
};


export type MutationtestDebitArgs = {
  balanceAccountId: Scalars['ID']['input'];
};


export type MutationtopUpBalanceAccountArgs = {
  amount: Scalars['Int']['input'];
  balanceAccountId: Scalars['ID']['input'];
};


export type MutationupdateAddonArgs = {
  data: AddonCreateInput;
  where: UniqueInput;
};


export type MutationupdateAgreementArgs = {
  data: AgreementCreateInput;
  where?: InputMaybe<UniqueInput>;
};


export type MutationupdateAppSettingArgs = {
  data: AppSettingCreateInput;
};


export type MutationupdateAttendanceArgs = {
  data: AttendanceCreateInput;
  where?: InputMaybe<UniqueInput>;
};


export type MutationupdateBillingCategoryArgs = {
  data: BillingCategoryCreateInput;
  where?: InputMaybe<UniqueInput>;
};


export type MutationupdateChargeArgs = {
  data: ChargeCreateInput;
  where?: InputMaybe<UniqueInput>;
};


export type MutationupdateChargeAmountArgs = {
  data: ChargeAmountUpdateInput;
  where?: InputMaybe<UniqueInput>;
};


export type MutationupdateClassArgs = {
  data: ClassCreateInput;
  where: UniqueInput;
};


export type MutationupdateCommunicationArgs = {
  data: CommunicationCreateInput;
  where?: InputMaybe<UniqueInput>;
};


export type MutationupdateCouponArgs = {
  data: CouponCreateInput;
  where?: InputMaybe<UniqueInput>;
};


export type MutationupdateCreditArgs = {
  data: CreditCreateInput;
  where?: InputMaybe<UniqueInput>;
};


export type MutationupdateCustomerRequestArgs = {
  data: CustomerRequestCreateInput;
  where?: InputMaybe<UniqueInput>;
};


export type MutationupdateCustomerServiceItemArgs = {
  data: CustomerServiceItemCreateInput;
  where?: InputMaybe<UniqueInput>;
};


export type MutationupdateDepartmentArgs = {
  data: DepartmentCreateInput;
  where?: InputMaybe<UniqueInput>;
};


export type MutationupdateDiscountArgs = {
  data: DiscountCreateInput;
  where?: InputMaybe<UniqueInput>;
};


export type MutationupdateEvaluationArgs = {
  data: EvaluationCreateInput;
  where?: InputMaybe<UniqueInput>;
};


export type MutationupdateFeeArgs = {
  data: FeeUpdateDataInput;
  where: UniqueInput;
};


export type MutationupdateFileArgs = {
  data: FileCreateInput;
  where: UniqueInput;
};


export type MutationupdateGroupRegistrationArgs = {
  data: GroupRegistrationCreateInput;
  where?: InputMaybe<UniqueInput>;
};


export type MutationupdateHealthQuestionArgs = {
  data: HealthQuestionCreateInput;
  where?: InputMaybe<UniqueInput>;
};


export type MutationupdateInvoiceArgs = {
  data: InvoiceCreateInput;
  where?: InputMaybe<UniqueInput>;
};


export type MutationupdateInvoiceItemArgs = {
  data: InvoiceItemCreateInput;
  where?: InputMaybe<UniqueInput>;
};


export type MutationupdateJobArgs = {
  data: JobCreateInput;
  where?: InputMaybe<UniqueInput>;
};


export type MutationupdateLocationArgs = {
  data: LocationCreateInput;
  where?: InputMaybe<UniqueInput>;
};


export type MutationupdateManyGroupRegistrationsArgs = {
  data?: InputMaybe<GroupRegistrationCreateInput>;
  filter?: InputMaybe<Scalars['String']['input']>;
  selected?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  where?: InputMaybe<GroupRegistrationWhereInput>;
};


export type MutationupdateManyMembershipsArgs = {
  data?: InputMaybe<MembershipCreateInput>;
  filter?: InputMaybe<Scalars['String']['input']>;
  selected?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  where?: InputMaybe<MembershipWhereInput>;
};


export type MutationupdateManyUsersArgs = {
  data: UserCreateInput;
  filter?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<UserWhereInput>;
};


export type MutationupdateMeetArgs = {
  data: MeetCreateInput;
  where?: InputMaybe<UniqueInput>;
};


export type MutationupdateMeetDeclarationArgs = {
  data: MeetDeclarationCreateInput;
  where: UniqueInput;
};


export type MutationupdateMeetEventArgs = {
  data: MeetEventCreateInput;
  where: UniqueInput;
};


export type MutationupdateMeetResultArgs = {
  data: MeetResultCreateInput;
  where: UniqueInput;
};


export type MutationupdateMembershipArgs = {
  data: MembershipCreateInput;
  where?: InputMaybe<UniqueInput>;
};


export type MutationupdateMembershipOfferingArgs = {
  data: MembershipOfferingCreateInput;
  where?: InputMaybe<UniqueInput>;
};


export type MutationupdateNativeAppArgs = {
  data: NativeAppCreateInput;
  where: UniqueInput;
};


export type MutationupdateOfferingArgs = {
  data: OfferingCreateInput;
  where?: InputMaybe<UniqueInput>;
};


export type MutationupdateOnboardArgs = {
  data: OnboardCreateInput;
  where?: InputMaybe<UniqueInput>;
};


export type MutationupdateOrgTimeStandardArgs = {
  data: OrgTimeStandardCreateInput;
  where: UniqueInput;
};


export type MutationupdateOrganizationArgs = {
  data: OrganizationCreateInput;
  where?: InputMaybe<UniqueInput>;
};


export type MutationupdatePasswordArgs = {
  data: UpdatePasswordInput;
};


export type MutationupdatePaymentArgs = {
  data: PaymentCreateInput;
  where?: InputMaybe<UniqueInput>;
};


export type MutationupdatePriceAdjustmentArgs = {
  data: PriceAdjustmentCreateInput;
  where?: InputMaybe<UniqueInput>;
};


export type MutationupdatePrivateSerieArgs = {
  data: PrivateSerieCreateInput;
  where?: InputMaybe<UniqueInput>;
};


export type MutationupdatePrivateSerieAttendanceArgs = {
  data: PrivateSerieAttendanceCreateInput;
  where?: InputMaybe<UniqueInput>;
};


export type MutationupdateProgramArgs = {
  data: ProgramCreateInput;
  where?: InputMaybe<UniqueInput>;
};


export type MutationupdateRecurringChargeArgs = {
  data: RecurringChargeCreateInput;
  where: UniqueInput;
};


export type MutationupdateRecurringCreditArgs = {
  data: RecurringCreditCreateInput;
  where?: InputMaybe<UniqueInput>;
};


export type MutationupdateReferralArgs = {
  data: ReferralCreateInput;
  where: UniqueInput;
};


export type MutationupdateReferralTemplateArgs = {
  data: ReferralTemplateCreateInput;
  where: UniqueInput;
};


export type MutationupdateRefundArgs = {
  data: RefundCreateInput;
  where?: InputMaybe<UniqueInput>;
};


export type MutationupdateServiceRunArgs = {
  data: ServiceRunUpdateInput;
  where: UniqueInput;
};


export type MutationupdateStaffEvaluationArgs = {
  data: StaffEvaluationCreateInput;
  where?: InputMaybe<UniqueInput>;
};


export type MutationupdateStudentAttendanceNoteArgs = {
  data: StudentAttendanceNoteCreateInput;
  where?: InputMaybe<UniqueInput>;
};


export type MutationupdateStudentInfoRequestArgs = {
  data: StudentInfoRequestCreateInput;
  where?: InputMaybe<UniqueInput>;
};


export type MutationupdateTagArgs = {
  data: TagCreateInput;
  where: UniqueInput;
};


export type MutationupdateTimeStandardArgs = {
  data: TimeStandardCreateInput;
  where: UniqueInput;
};


export type MutationupdateTokenArgs = {
  data: TokenCreateInput;
  where: UniqueInput;
};


export type MutationupdateUserArgs = {
  data: UserCreateInput;
  where: UniqueInput;
};


export type MutationupdateVolunteerEventArgs = {
  data: VolunteerEventCreateInput;
  where?: InputMaybe<UniqueInput>;
};


export type MutationupsertStripeCustomerArgs = {
  data: UpsertStripeCustomerInput;
};


export type MutationvalidateStripePaymentMethodArgs = {
  amounts: Array<Scalars['Int']['input']>;
  paymentMethod: Scalars['String']['input'];
};


export type MutationviewAsUserArgs = {
  userId: Scalars['ID']['input'];
};


export type MutationvolunteerCheckInArgs = {
  data?: InputMaybe<VolunteerCheckInInput>;
};

export type NativeApp = {
  addToInvoice?: Maybe<Scalars['Boolean']['output']>;
  amount?: Maybe<Scalars['Int']['output']>;
  appData?: Maybe<Scalars['Json']['output']>;
  billingMethod?: Maybe<BillingMethod>;
  createdAt: Scalars['Date']['output'];
  developerAccountAlert?: Maybe<Scalars['Boolean']['output']>;
  developerAccountSetup?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  logo?: Maybe<Scalars['String']['output']>;
  needsScreenshots?: Maybe<Scalars['Boolean']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  organization: Organization;
  screenshots: Array<Scalars['String']['output']>;
  setupFee?: Maybe<Scalars['Int']['output']>;
  status: NativeAppStatus;
  submittedAt?: Maybe<Scalars['Date']['output']>;
  type: NativeAppType;
  updatedAt: Scalars['Date']['output'];
  version: Scalars['String']['output'];
};

export type NativeAppCreateInput = {
  addToInvoice?: InputMaybe<Scalars['Boolean']['input']>;
  amount?: InputMaybe<Scalars['Int']['input']>;
  appData?: InputMaybe<Scalars['Json']['input']>;
  billingMethod?: InputMaybe<BillingMethod>;
  developerAccountAlert?: InputMaybe<Scalars['Boolean']['input']>;
  developerAccountSetup?: InputMaybe<Scalars['Boolean']['input']>;
  logo?: InputMaybe<Scalars['String']['input']>;
  needsScreenshots?: InputMaybe<Scalars['Boolean']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  organization?: InputMaybe<ConnectUniqueInput>;
  screenshots?: InputMaybe<Array<Scalars['String']['input']>>;
  setupFee?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<NativeAppStatus>;
  submittedAt?: InputMaybe<Scalars['Date']['input']>;
  type?: InputMaybe<NativeAppType>;
  version?: InputMaybe<Scalars['String']['input']>;
};

export type NativeAppManyInput = {
  create?: InputMaybe<Array<NativeAppCreateInput>>;
  update?: InputMaybe<Array<NativeAppUpdateInput>>;
};

export const NativeAppStatus = {
  AppStoreReview: 'AppStoreReview',
  CaptynReview: 'CaptynReview',
  Development: 'Development',
  NotEnabled: 'NotEnabled',
  Onboarding: 'Onboarding',
  Released: 'Released'
} as const;

export type NativeAppStatus = typeof NativeAppStatus[keyof typeof NativeAppStatus];
export const NativeAppType = {
  Android: 'Android',
  iOS: 'iOS'
} as const;

export type NativeAppType = typeof NativeAppType[keyof typeof NativeAppType];
export type NativeAppUpdateInput = {
  data?: InputMaybe<NativeAppCreateInput>;
  where?: InputMaybe<UniqueInput>;
};

export type NativeAppWhereInput = {
  organizationId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<NativeAppStatus>;
  type?: InputMaybe<NativeAppType>;
};

export const NotificationType = {
  Email: 'Email',
  Sms: 'Sms'
} as const;

export type NotificationType = typeof NotificationType[keyof typeof NotificationType];
export type Offering = {
  active?: Maybe<Scalars['Boolean']['output']>;
  additionalFeeAmount?: Maybe<Scalars['Int']['output']>;
  additionalFeeBillingCategory?: Maybe<BillingCategory>;
  additionalFeeBillingCategoryId?: Maybe<Scalars['String']['output']>;
  additionalFeeTitle?: Maybe<Scalars['String']['output']>;
  addons: Array<Addon>;
  agreements: Array<Agreement>;
  allowAdditionalStudents?: Maybe<Scalars['Boolean']['output']>;
  allowExtension?: Maybe<Scalars['Boolean']['output']>;
  allowNonMembers?: Maybe<Scalars['Boolean']['output']>;
  applyAnnualFee?: Maybe<Scalars['Boolean']['output']>;
  atAccountHome?: Maybe<Scalars['Boolean']['output']>;
  availableDays: Array<Day>;
  billingCategory?: Maybe<BillingCategory>;
  billingCategoryId?: Maybe<Scalars['String']['output']>;
  charges: Array<Charge>;
  classTimes: Array<ClassTime>;
  collectTaxes?: Maybe<Scalars['Boolean']['output']>;
  communications: Array<Communication>;
  coupons: Array<Coupon>;
  createdAt: Scalars['Date']['output'];
  credits: Array<Credit>;
  customerInfoRequests: Array<Scalars['String']['output']>;
  department?: Maybe<Department>;
  departmentId?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  discounts: Array<Discount>;
  duration?: Maybe<Scalars['Int']['output']>;
  endDate?: Maybe<Scalars['Date']['output']>;
  excludedDates: Array<Scalars['Date']['output']>;
  extensionDiscounts: Array<Discount>;
  extensionFreePresentation?: Maybe<Scalars['String']['output']>;
  extensionMaxAttendances?: Maybe<Scalars['Int']['output']>;
  extensionMinAttendances?: Maybe<Scalars['Int']['output']>;
  extensionPrice?: Maybe<Scalars['Int']['output']>;
  extensionPriceAdjustments: Array<PriceAdjustment>;
  fees: Array<Fee>;
  firstLessonStart?: Maybe<Scalars['Date']['output']>;
  firstLessonStartDays?: Maybe<Scalars['Int']['output']>;
  freePresentation?: Maybe<Scalars['String']['output']>;
  frequency?: Maybe<Frequency>;
  hideDefaultStaff?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  instructor?: Maybe<User>;
  instructorId?: Maybe<Scalars['String']['output']>;
  location?: Maybe<Location>;
  locationId?: Maybe<Scalars['String']['output']>;
  maxAge?: Maybe<Scalars['Int']['output']>;
  maxAgeType?: Maybe<AgeType>;
  maxInitial?: Maybe<Scalars['Int']['output']>;
  maxParticipants?: Maybe<Scalars['Int']['output']>;
  membershipOfferings: Array<MembershipOffering>;
  minAge?: Maybe<Scalars['Int']['output']>;
  minAgeType?: Maybe<AgeType>;
  minAttendances?: Maybe<Scalars['Int']['output']>;
  minParticipants?: Maybe<Scalars['Int']['output']>;
  multiClassDiscount?: Maybe<Scalars['Boolean']['output']>;
  multiStudentDiscount?: Maybe<Scalars['Boolean']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  organization?: Maybe<Organization>;
  organizationId?: Maybe<Scalars['String']['output']>;
  package?: Maybe<Scalars['Boolean']['output']>;
  participantType?: Maybe<Scalars['String']['output']>;
  pass?: Maybe<Scalars['Boolean']['output']>;
  paymentFrequency?: Maybe<PaymentFrequency>;
  price?: Maybe<Scalars['Int']['output']>;
  priceAdjustments: Array<PriceAdjustment>;
  priceForAdditionalStudents?: Maybe<Scalars['Int']['output']>;
  privateSeries: Array<PrivateSerie>;
  program?: Maybe<Program>;
  programId?: Maybe<Scalars['String']['output']>;
  prorateExcludedDates?: Maybe<Scalars['Boolean']['output']>;
  publishDate?: Maybe<Scalars['Date']['output']>;
  publishOnWebsite?: Maybe<Scalars['Boolean']['output']>;
  registrationClose?: Maybe<Scalars['Date']['output']>;
  registrationOpen?: Maybe<Scalars['Date']['output']>;
  requestStartDate?: Maybe<Scalars['Boolean']['output']>;
  restrictReschedule?: Maybe<Scalars['Int']['output']>;
  restrictRescheduleType?: Maybe<TimeType>;
  startDate?: Maybe<Scalars['Date']['output']>;
  status?: Maybe<OfferingStatus>;
  studentInfoRequests: Array<StudentInfoRequest>;
  tags: Array<Tag>;
  template: Scalars['Boolean']['output'];
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  unpublishDate?: Maybe<Scalars['Date']['output']>;
  updatedAt: Scalars['Date']['output'];
};

export type OfferingCreateInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  additionalFeeAmount?: InputMaybe<Scalars['Int']['input']>;
  additionalFeeBillingCategory?: InputMaybe<ConnectUniqueInput>;
  additionalFeeTitle?: InputMaybe<Scalars['String']['input']>;
  addons?: InputMaybe<ConnectManyInput>;
  agreements?: InputMaybe<ConnectManyInput>;
  allowAdditionalStudents?: InputMaybe<Scalars['Boolean']['input']>;
  allowExtension?: InputMaybe<Scalars['Boolean']['input']>;
  allowNonMembers?: InputMaybe<Scalars['Boolean']['input']>;
  applyAnnualFee?: InputMaybe<Scalars['Boolean']['input']>;
  atAccountHome?: InputMaybe<Scalars['Boolean']['input']>;
  availableDays?: InputMaybe<DayManyInput>;
  billingCategory?: InputMaybe<ConnectUniqueInput>;
  charges?: InputMaybe<ChargeManyInput>;
  classTimes?: InputMaybe<ClassTimeManyInput>;
  collectTaxes?: InputMaybe<Scalars['Boolean']['input']>;
  communications?: InputMaybe<CommunicationManyInput>;
  coupons?: InputMaybe<ConnectManyInput>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  credits?: InputMaybe<CreditManyInput>;
  customerInfoRequests?: InputMaybe<StringManyInput>;
  department?: InputMaybe<ConnectUniqueInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  discounts?: InputMaybe<DiscountManyInput>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  excludedDates?: InputMaybe<DateManyInput>;
  extensionDiscounts?: InputMaybe<DiscountManyInput>;
  extensionFreePresentation?: InputMaybe<Scalars['String']['input']>;
  extensionMaxAttendances?: InputMaybe<Scalars['Int']['input']>;
  extensionMinAttendances?: InputMaybe<Scalars['Int']['input']>;
  extensionPrice?: InputMaybe<Scalars['Int']['input']>;
  extensionPriceAdjustments?: InputMaybe<PriceAdjustmentManyInput>;
  fees?: InputMaybe<ConnectManyInput>;
  firstLessonStart?: InputMaybe<Scalars['Date']['input']>;
  firstLessonStartDays?: InputMaybe<Scalars['Int']['input']>;
  freePresentation?: InputMaybe<Scalars['String']['input']>;
  frequency?: InputMaybe<Frequency>;
  hideDefaultStaff?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  instructor?: InputMaybe<ConnectUniqueInput>;
  location?: InputMaybe<ConnectUniqueInput>;
  maxAge?: InputMaybe<Scalars['Int']['input']>;
  maxAgeType?: InputMaybe<AgeType>;
  maxInitial?: InputMaybe<Scalars['Int']['input']>;
  maxParticipants?: InputMaybe<Scalars['Int']['input']>;
  membershipOfferings?: InputMaybe<ConnectManyInput>;
  minAge?: InputMaybe<Scalars['Int']['input']>;
  minAgeType?: InputMaybe<AgeType>;
  minAttendances?: InputMaybe<Scalars['Int']['input']>;
  minParticipants?: InputMaybe<Scalars['Int']['input']>;
  multiClassDiscount?: InputMaybe<Scalars['Boolean']['input']>;
  multiStudentDiscount?: InputMaybe<Scalars['Boolean']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<ConnectUniqueInput>;
  package?: InputMaybe<Scalars['Boolean']['input']>;
  participantType?: InputMaybe<Scalars['String']['input']>;
  pass?: InputMaybe<Scalars['Boolean']['input']>;
  paymentFrequency?: InputMaybe<PaymentFrequency>;
  price?: InputMaybe<Scalars['Int']['input']>;
  priceAdjustments?: InputMaybe<PriceAdjustmentManyInput>;
  priceForAdditionalStudents?: InputMaybe<Scalars['Int']['input']>;
  program?: InputMaybe<ProgramConnectCreateInput>;
  prorateExcludedDates?: InputMaybe<Scalars['Boolean']['input']>;
  publishDate?: InputMaybe<Scalars['Date']['input']>;
  publishOnWebsite?: InputMaybe<Scalars['Boolean']['input']>;
  registrationClose?: InputMaybe<Scalars['Date']['input']>;
  registrationOpen?: InputMaybe<Scalars['Date']['input']>;
  requestStartDate?: InputMaybe<Scalars['Boolean']['input']>;
  restrictReschedule?: InputMaybe<Scalars['Int']['input']>;
  restrictRescheduleType?: InputMaybe<TimeType>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
  status?: InputMaybe<OfferingStatus>;
  studentInfoRequests?: InputMaybe<StudentInfoRequestManyInput>;
  tags?: InputMaybe<TagManyInput>;
  template?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  unpublishDate?: InputMaybe<Scalars['Date']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  zone?: InputMaybe<ConnectUniqueInput>;
};

export type OfferingManyInput = {
  delete?: InputMaybe<Array<InputMaybe<UniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<OfferingUpdateInput>>>;
};

export type OfferingNestedInput = {
  connect?: InputMaybe<UniqueInput>;
  create?: InputMaybe<OfferingCreateInput>;
  update?: InputMaybe<OfferingCreateInput>;
};

export type OfferingOrderByInput = {
  order?: InputMaybe<SortOrder>;
};

export const OfferingStatus = {
  Archived: 'Archived',
  InProgress: 'InProgress',
  Inactive: 'Inactive',
  Upcoming: 'Upcoming'
} as const;

export type OfferingStatus = typeof OfferingStatus[keyof typeof OfferingStatus];
export type OfferingStatusFilter = {
  equals?: InputMaybe<OfferingStatus>;
  in?: InputMaybe<Array<OfferingStatus>>;
  not?: InputMaybe<OfferingStatus>;
  notIn?: InputMaybe<Array<OfferingStatus>>;
};

export type OfferingUpdateInput = {
  data?: InputMaybe<OfferingCreateInput>;
  where?: InputMaybe<UniqueInput>;
};

export type OfferingWhereInput = {
  AND?: InputMaybe<Array<OfferingWhereInput>>;
  NOT?: InputMaybe<OfferingWhereInput>;
  OR?: InputMaybe<Array<OfferingWhereInput>>;
  departmentId?: InputMaybe<StringFilter>;
  frequency?: InputMaybe<FrequencyFilter>;
  id?: InputMaybe<StringFilter>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  paymentFrequency?: InputMaybe<PaymentFrequencyFilter>;
  publishDate?: InputMaybe<DateFilter>;
  status?: InputMaybe<OfferingStatusFilter>;
  template?: InputMaybe<Scalars['Boolean']['input']>;
  unpublishDate?: InputMaybe<DateFilter>;
};

export type Onboard = {
  createdAt: Scalars['Date']['output'];
  department?: Maybe<Department>;
  departmentId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  organization?: Maybe<Organization>;
  organizationId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<OnboardStatus>;
  type?: Maybe<OnboardType>;
  updatedAt: Scalars['Date']['output'];
  user?: Maybe<User>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type OnboardCreateInput = {
  department?: InputMaybe<ConnectUniqueInput>;
  organization?: InputMaybe<ConnectUniqueInput>;
  status?: InputMaybe<OnboardStatus>;
  type?: InputMaybe<OnboardType>;
  user?: InputMaybe<ConnectUniqueInput>;
};

export type OnboardManyInput = {
  create?: InputMaybe<Array<InputMaybe<OnboardCreateInput>>>;
  delete?: InputMaybe<Array<InputMaybe<UniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<OnboardUpdateInput>>>;
};

export const OnboardStatus = {
  Assigned: 'Assigned',
  Completed: 'Completed',
  Dismissed: 'Dismissed'
} as const;

export type OnboardStatus = typeof OnboardStatus[keyof typeof OnboardStatus];
export const OnboardType = {
  Department: 'Department',
  FinanceLanding: 'FinanceLanding',
  FinanceSettings: 'FinanceSettings',
  FirstUser: 'FirstUser',
  Offering: 'Offering',
  Organization: 'Organization'
} as const;

export type OnboardType = typeof OnboardType[keyof typeof OnboardType];
export type OnboardUpdateInput = {
  data?: InputMaybe<OnboardCreateInput>;
  where?: InputMaybe<UniqueInput>;
};

export type OnboardWhereInput = {
  AND?: InputMaybe<OnboardWhereInput>;
  NOT?: InputMaybe<OnboardWhereInput>;
  OR?: InputMaybe<Array<OnboardWhereInput>>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<OnboardType>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type OrgTimeStandard = {
  allowAccountOwners: Scalars['Boolean']['output'];
  courses: Array<Maybe<MeetCourseType>>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  index?: Maybe<Scalars['Int']['output']>;
  organization?: Maybe<Organization>;
  organizationId?: Maybe<Scalars['String']['output']>;
  timeStandard?: Maybe<TimeStandard>;
  title?: Maybe<Scalars['String']['output']>;
};

export type OrgTimeStandardCreateInput = {
  allowAccountOwners?: InputMaybe<Scalars['Boolean']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  index?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<ConnectUniqueInput>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type OrgTimeStandardManyInput = {
  create?: InputMaybe<Array<InputMaybe<OrgTimeStandardCreateInput>>>;
  delete?: InputMaybe<Array<InputMaybe<UniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<OrgTimeStandardUpdateInput>>>;
};

export type OrgTimeStandardUpdateInput = {
  data?: InputMaybe<OrgTimeStandardCreateInput>;
  where?: InputMaybe<UniqueInput>;
};

export type Organization = {
  accountManager?: Maybe<User>;
  accountManagerId?: Maybe<Scalars['String']['output']>;
  active?: Maybe<Scalars['Boolean']['output']>;
  activeAt?: Maybe<Scalars['Date']['output']>;
  addDepartmentsDuringOnboarding?: Maybe<Scalars['Boolean']['output']>;
  addons: Array<Addon>;
  address1?: Maybe<Scalars['String']['output']>;
  address2?: Maybe<Scalars['String']['output']>;
  agreements: Array<Agreement>;
  annualPrice?: Maybe<Scalars['Int']['output']>;
  attendances: Array<Attendance>;
  balanceAccounts: Array<BalanceAccount>;
  betaAccess: Array<BetaAccessType>;
  billingCategories: Array<BillingCategory>;
  captynPlan: CaptynPlanType;
  chargeAnnualStartDate?: Maybe<Scalars['Date']['output']>;
  chargeStartDate: Scalars['Date']['output'];
  charges: Array<Charge>;
  city?: Maybe<Scalars['String']['output']>;
  classes: Array<Class>;
  color?: Maybe<Scalars['String']['output']>;
  commissionSettings: Array<CommissionSetting>;
  communications: Array<Communication>;
  compare?: Maybe<HistoricalFinancialReportCounts>;
  contactName: Scalars['String']['output'];
  counts?: Maybe<OrganizationCountsPayload>;
  coupons: Array<Coupon>;
  createdAt: Scalars['Date']['output'];
  credits: Array<Credit>;
  current?: Maybe<HistoricalFinancialReportCounts>;
  departments: Array<Department>;
  description?: Maybe<Scalars['String']['output']>;
  discounts: Array<Discount>;
  disputeFee?: Maybe<Scalars['Int']['output']>;
  email: Scalars['String']['output'];
  emailSetting?: Maybe<EmailSetting>;
  events: Array<Event>;
  fees: Array<Fee>;
  gracePeriod: Scalars['Int']['output'];
  gracePeriodType: TimeType;
  id: Scalars['ID']['output'];
  imports: Array<File>;
  integrations: Array<IntegrationType>;
  invoices: Array<Invoice>;
  lastContact?: Maybe<Scalars['Date']['output']>;
  lastContactBy?: Maybe<User>;
  lastFailedPayment: Scalars['Date']['output'];
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  locations: Array<Location>;
  logo?: Maybe<File>;
  meetGenderTerminology?: Maybe<MeetGenderTerminology>;
  meetLSC?: Maybe<Scalars['String']['output']>;
  meetTeamAbbreviation?: Maybe<Scalars['String']['output']>;
  meetTeamFullName?: Maybe<Scalars['String']['output']>;
  meetTeamShortName?: Maybe<Scalars['String']['output']>;
  membershipOfferings: Array<MembershipOffering>;
  memberships: Array<Membership>;
  monthlyPrice?: Maybe<Scalars['Int']['output']>;
  nativeApps: Array<NativeApp>;
  needs: Array<Tag>;
  nextAnnualInvoice?: Maybe<Scalars['Date']['output']>;
  nextMonthlyInvoice?: Maybe<Scalars['Date']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  now: Scalars['Date']['output'];
  offerings: Array<Offering>;
  onboards: Array<Onboard>;
  owner: User;
  ownerId: Scalars['String']['output'];
  paymentDisplay: StripeType;
  paymentProcessing?: Maybe<PaymentProcessing>;
  paymentSettings: Array<PaymentSetting>;
  payouts?: Maybe<Scalars['Json']['output']>;
  phone: Scalars['String']['output'];
  pipedriveUrl?: Maybe<Scalars['String']['output']>;
  planContent?: Maybe<Scalars['String']['output']>;
  priceAdjustments: Array<PriceAdjustment>;
  profiles: Array<User>;
  programs: Array<Program>;
  projectedCaptynRevenue?: Maybe<Scalars['Int']['output']>;
  projectedFirstPaidRegistration?: Maybe<Scalars['Date']['output']>;
  projectedOperatingMonths?: Maybe<Scalars['Int']['output']>;
  projectedRegistrations?: Maybe<Scalars['Int']['output']>;
  projectedRevenue?: Maybe<Scalars['Int']['output']>;
  referralName?: Maybe<Scalars['String']['output']>;
  registrationRestriction?: Maybe<RegistrationRestriction>;
  requiredFields: Array<Scalars['String']['output']>;
  salesPerson?: Maybe<User>;
  salesPersonId?: Maybe<Scalars['String']['output']>;
  score: Scalars['Int']['output'];
  signupInformation?: Maybe<Scalars['Json']['output']>;
  socialMedia?: Maybe<SocialMedia>;
  solo?: Maybe<Scalars['Boolean']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  statementDescriptor?: Maybe<Scalars['String']['output']>;
  status: OrganizationStatus;
  storeUrl?: Maybe<Scalars['String']['output']>;
  stripe: StripeType;
  stripeAccountId?: Maybe<Scalars['String']['output']>;
  stripeAlert?: Maybe<Scalars['Boolean']['output']>;
  stripeExpressAccountId?: Maybe<Scalars['String']['output']>;
  stripeExpressAccounts: Array<StripeExpressAccount>;
  stripeExpressFee?: Maybe<Scalars['Float']['output']>;
  stripeFee?: Maybe<Scalars['Float']['output']>;
  stripeTransactionFee?: Maybe<Scalars['Float']['output']>;
  subdomain: Scalars['String']['output'];
  tags: Array<Tag>;
  taxRate?: Maybe<Scalars['Float']['output']>;
  terminology: Terminology;
  timezone: Scalars['String']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
  upgradeNativeApp?: Maybe<UpgradeNativeApp>;
  upgradeTerminal?: Maybe<UpgradeTerminal>;
  upgradeWebsite?: Maybe<UpgradeWebsite>;
  usaSwimmingClubId?: Maybe<Scalars['String']['output']>;
  usaSwimmingClubName?: Maybe<Scalars['String']['output']>;
  website?: Maybe<Scalars['String']['output']>;
  websiteIncluded?: Maybe<Scalars['Boolean']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};


export type OrganizationdepartmentsArgs = {
  orderBy?: InputMaybe<DepartmentOrderByInput>;
};

export type OrganizationCountsPayload = {
  accounts?: Maybe<Scalars['Int']['output']>;
  accountsAdmin?: Maybe<Scalars['Int']['output']>;
  accountsParticipants?: Maybe<Scalars['Int']['output']>;
  accountsStaff?: Maybe<Scalars['Int']['output']>;
  averageInvoice?: Maybe<Scalars['Int']['output']>;
  invoices?: Maybe<Scalars['Int']['output']>;
  registrations?: Maybe<Scalars['Int']['output']>;
  sms?: Maybe<Scalars['Int']['output']>;
  updated?: Maybe<Scalars['Date']['output']>;
};

export type OrganizationCreateInput = {
  accountManager?: InputMaybe<ConnectUniqueInput>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  activeAt?: InputMaybe<Scalars['Date']['input']>;
  addDepartmentsDuringOnboarding?: InputMaybe<Scalars['Boolean']['input']>;
  addons?: InputMaybe<AddonManyInput>;
  address1?: InputMaybe<Scalars['String']['input']>;
  address2?: InputMaybe<Scalars['String']['input']>;
  agreements?: InputMaybe<AgreementManyInput>;
  annualPrice?: InputMaybe<Scalars['Int']['input']>;
  balanceAccounts?: InputMaybe<BalanceAccountManyInput>;
  betaAccess?: InputMaybe<BetaAccessTypeManyInput>;
  billingCategories?: InputMaybe<BillingCategoryManyInput>;
  captynPlan?: InputMaybe<CaptynPlanType>;
  chargeAnnualStartDate?: InputMaybe<Scalars['Date']['input']>;
  chargeStartDate?: InputMaybe<Scalars['Date']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  classes?: InputMaybe<ClassManyInput>;
  color?: InputMaybe<Scalars['String']['input']>;
  commissionSettings?: InputMaybe<CommissionSettingManyInput>;
  communications?: InputMaybe<CommunicationManyInput>;
  contactName?: InputMaybe<Scalars['String']['input']>;
  credits?: InputMaybe<CreditManyInput>;
  departments?: InputMaybe<DepartmentManyInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  disputeFee?: InputMaybe<Scalars['Int']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  evaluations?: InputMaybe<EvaluationManyInput>;
  events?: InputMaybe<EventManyInput>;
  fees?: InputMaybe<FeeManyInput>;
  gracePeriod?: InputMaybe<Scalars['Int']['input']>;
  gracePeriodType?: InputMaybe<TimeType>;
  groupRegistrations?: InputMaybe<GroupRegistrationManyInput>;
  healthQuestions?: InputMaybe<HealthQuestionManyInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  integrations?: InputMaybe<IntegrationTypeManyInput>;
  invoices?: InputMaybe<InvoiceManyInput>;
  lastContact?: InputMaybe<Scalars['Date']['input']>;
  lastContactBy?: InputMaybe<ConnectUniqueInput>;
  lat?: InputMaybe<Scalars['Float']['input']>;
  lng?: InputMaybe<Scalars['Float']['input']>;
  locations?: InputMaybe<LocationManyInput>;
  logo?: InputMaybe<ConnectUniqueInput>;
  meetGenderTerminology?: InputMaybe<MeetGenderTerminology>;
  meetLSC?: InputMaybe<Scalars['String']['input']>;
  meetTeamAbbreviation?: InputMaybe<Scalars['String']['input']>;
  meetTeamFullName?: InputMaybe<Scalars['String']['input']>;
  meetTeamShortName?: InputMaybe<Scalars['String']['input']>;
  memberships?: InputMaybe<MembershipManyInput>;
  monthlyPrice?: InputMaybe<Scalars['Int']['input']>;
  nativeApps?: InputMaybe<NativeAppManyInput>;
  needs?: InputMaybe<TagManyInput>;
  note?: InputMaybe<Scalars['String']['input']>;
  offerings?: InputMaybe<OfferingManyInput>;
  onboards?: InputMaybe<OnboardManyInput>;
  owner?: InputMaybe<ConnectUniqueInput>;
  paymentDisplay?: InputMaybe<StripeType>;
  paymentProcessing?: InputMaybe<PaymentProcessingUpdateInput>;
  payments?: InputMaybe<PaymentManyInput>;
  payouts?: InputMaybe<Scalars['Json']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pipedriveUrl?: InputMaybe<Scalars['String']['input']>;
  planContent?: InputMaybe<Scalars['String']['input']>;
  priceAdjustments?: InputMaybe<PriceAdjustmentManyInput>;
  privateSeries?: InputMaybe<PrivateSerieManyInput>;
  profiles?: InputMaybe<UserManyInput>;
  programs?: InputMaybe<ProgramManyInput>;
  projectedCaptynRevenue?: InputMaybe<Scalars['Int']['input']>;
  projectedFirstPaidRegistration?: InputMaybe<Scalars['Date']['input']>;
  projectedOperatingMonths?: InputMaybe<Scalars['Int']['input']>;
  projectedRegistrations?: InputMaybe<Scalars['Int']['input']>;
  projectedRevenue?: InputMaybe<Scalars['Int']['input']>;
  projectedRevenuePerRegistration?: InputMaybe<Scalars['Int']['input']>;
  referralName?: InputMaybe<Scalars['String']['input']>;
  refunds?: InputMaybe<RefundManyInput>;
  registrationRestriction?: InputMaybe<RegistrationRestrictionInput>;
  requiredFields?: InputMaybe<StringManyInput>;
  salesPerson?: InputMaybe<ConnectUniqueInput>;
  signupInformation?: InputMaybe<Scalars['Json']['input']>;
  socialMedia?: InputMaybe<SocialMediaUpdateInput>;
  solo?: InputMaybe<Scalars['Boolean']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  statementDescriptor?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<OrganizationStatus>;
  storeUrl?: InputMaybe<Scalars['String']['input']>;
  stripe?: InputMaybe<StripeType>;
  stripeAccountId?: InputMaybe<Scalars['String']['input']>;
  stripeExpressAccountId?: InputMaybe<Scalars['String']['input']>;
  stripeExpressAccounts?: InputMaybe<StripeExpressAccountManyInput>;
  stripeExpressFee?: InputMaybe<Scalars['Float']['input']>;
  stripeFee?: InputMaybe<Scalars['Float']['input']>;
  stripeTransactionFee?: InputMaybe<Scalars['Float']['input']>;
  studentInfoRequests?: InputMaybe<StudentInfoRequestManyInput>;
  subdomain?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<TagManyInput>;
  taxRate?: InputMaybe<Scalars['Float']['input']>;
  terminology?: InputMaybe<TerminologyUpdateInput>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  upgradeNativeApp?: InputMaybe<UpgradeNativeAppUpdateInput>;
  upgradeTerminal?: InputMaybe<UpgradeTerminalUpdateInput>;
  upgradeWebsite?: InputMaybe<UpgradeWebsiteUpdateInput>;
  usaSwimmingClubId?: InputMaybe<Scalars['String']['input']>;
  usaSwimmingImport?: InputMaybe<Scalars['Json']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
  websiteIncluded?: InputMaybe<Scalars['Boolean']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationListRelationFilter = {
  some?: InputMaybe<OrganizationWhereInput>;
};

export type OrganizationOrderByInput = {
  status?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
};

export const OrganizationStatus = {
  AbandonedOnboarding: 'AbandonedOnboarding',
  Active: 'Active',
  Created: 'Created',
  Demo: 'Demo',
  Inactive: 'Inactive',
  Onboarding: 'Onboarding',
  Pending: 'Pending',
  Suspended: 'Suspended'
} as const;

export type OrganizationStatus = typeof OrganizationStatus[keyof typeof OrganizationStatus];
export type OrganizationStatusFilter = {
  equals?: InputMaybe<OrganizationStatus>;
  not?: InputMaybe<OrganizationStatus>;
};

export type OrganizationSubscription = {
  id?: Maybe<Scalars['ID']['output']>;
};

export type OrganizationUniqueInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<OrganizationStatusFilter>;
  subdomain?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationUpdateInput = {
  data?: InputMaybe<OrganizationCreateInput>;
  where?: InputMaybe<UniqueInput>;
};

export type OrganizationWhereInput = {
  id?: InputMaybe<StringFilter>;
  integrations?: InputMaybe<IntegrationsTypeFilter>;
  subdomain?: InputMaybe<StringFilter>;
};

export type OrganizationsCountsPayload = {
  accounts?: Maybe<Scalars['Int']['output']>;
  accountsAdmin?: Maybe<Scalars['Int']['output']>;
  accountsParticipants?: Maybe<Scalars['Int']['output']>;
  accountsStaff?: Maybe<Scalars['Int']['output']>;
  averageScore?: Maybe<Scalars['Int']['output']>;
  balanceAccountAlerts?: Maybe<Scalars['Int']['output']>;
  balanceAccounts?: Maybe<Scalars['Int']['output']>;
  commissions?: Maybe<Array<Maybe<CommissionCount>>>;
  count?: Maybe<Scalars['Int']['output']>;
  organizationsActive?: Maybe<Scalars['Int']['output']>;
  organizationsInactive?: Maybe<Scalars['Int']['output']>;
  organizationsOnboarding?: Maybe<Scalars['Int']['output']>;
  organizationsPending?: Maybe<Scalars['Int']['output']>;
  projections?: Maybe<Scalars['Int']['output']>;
  projectionsCaptyn?: Maybe<Scalars['Int']['output']>;
  refunded?: Maybe<Scalars['Int']['output']>;
  registrations?: Maybe<Scalars['Int']['output']>;
  revenue?: Maybe<Scalars['Int']['output']>;
  revenueCaptyn?: Maybe<Scalars['Int']['output']>;
  revenueCaptynCharges?: Maybe<Scalars['Int']['output']>;
  revenueCaptynNet?: Maybe<Scalars['Int']['output']>;
  sms?: Maybe<Scalars['Int']['output']>;
};

export type Payment = {
  amount: Scalars['Int']['output'];
  checkNumber?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Date']['output'];
  createdBy?: Maybe<User>;
  createdById?: Maybe<Scalars['String']['output']>;
  customerServiceItems: Array<CustomerServiceItem>;
  description?: Maybe<Scalars['String']['output']>;
  fees: Scalars['Json']['output'];
  id: Scalars['ID']['output'];
  interchange: Scalars['Int']['output'];
  invoiceItemPayments: Array<InvoiceItemPayment>;
  markup: Scalars['Int']['output'];
  organization?: Maybe<Organization>;
  organizationId?: Maybe<Scalars['String']['output']>;
  receipt: Array<File>;
  scheme: Scalars['Int']['output'];
  stripe: StripeType;
  stripeChargeId?: Maybe<Scalars['String']['output']>;
  stripeFee: Scalars['Float']['output'];
  stripeFeeAmount: Scalars['Int']['output'];
  stripeToken?: Maybe<Scalars['Json']['output']>;
  transactionFee: Scalars['Int']['output'];
  transfers: Array<Transfer>;
  type: PaymentType;
  updatedAt: Scalars['Date']['output'];
  user?: Maybe<User>;
  userId?: Maybe<Scalars['String']['output']>;
};


export type PaymentcustomerServiceItemsArgs = {
  where?: InputMaybe<CustomerServiceItemWhereInput>;
};


export type PaymentinvoiceItemPaymentsArgs = {
  where?: InputMaybe<PaymentWhereInput>;
};

export type PaymentCreateInput = {
  amount: Scalars['Int']['input'];
  checkNumber?: InputMaybe<Scalars['String']['input']>;
  createdBy?: InputMaybe<ConnectUniqueInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  invoiceItemPayments?: InputMaybe<InvoiceItemPaymentManyInput>;
  organization?: InputMaybe<ConnectUniqueInput>;
  stripeChargeId?: InputMaybe<Scalars['String']['input']>;
  stripeFee?: InputMaybe<Scalars['Float']['input']>;
  stripeToken?: InputMaybe<Scalars['Json']['input']>;
  type?: InputMaybe<PaymentType>;
  user?: InputMaybe<ConnectUniqueInput>;
};

export const PaymentFrequency = {
  Manual: 'Manual',
  Upfront: 'Upfront'
} as const;

export type PaymentFrequency = typeof PaymentFrequency[keyof typeof PaymentFrequency];
export type PaymentFrequencyFilter = {
  equals?: InputMaybe<PaymentFrequency>;
  in?: InputMaybe<Array<PaymentFrequency>>;
  not?: InputMaybe<PaymentFrequency>;
  notIn?: InputMaybe<Array<PaymentFrequency>>;
};

export type PaymentManyInput = {
  create?: InputMaybe<Array<InputMaybe<PaymentCreateInput>>>;
  update?: InputMaybe<Array<InputMaybe<PaymentUpdateInput>>>;
};

export type PaymentProcessing = {
  achCredit?: Maybe<Scalars['Float']['output']>;
  achCreditBillingCategory?: Maybe<BillingCategory>;
  achFee?: Maybe<Scalars['Float']['output']>;
  achTransactionFee?: Maybe<Scalars['Float']['output']>;
  additionalCreditTransactionFee?: Maybe<Scalars['Float']['output']>;
  allowOrgManageSettlementDelay: Scalars['Boolean']['output'];
  creditFee?: Maybe<Scalars['Float']['output']>;
  creditTransactionFee?: Maybe<Scalars['Float']['output']>;
  disputeFee?: Maybe<Scalars['Float']['output']>;
  enableAch: Scalars['Boolean']['output'];
  enableRefundCushion: Scalars['Boolean']['output'];
  enableRefundFee?: Maybe<Scalars['Boolean']['output']>;
  enableRefundFunding: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  lastSettlementDelayChange?: Maybe<Scalars['Date']['output']>;
  lastSettlementDelayChangeBy?: Maybe<User>;
  maxAchFee?: Maybe<Scalars['Float']['output']>;
  minSettlementDelayChange: Scalars['Int']['output'];
  minSettlementDelayChangeType: TimeType;
  refundCushion?: Maybe<Scalars['Float']['output']>;
  refundCushionMax: Scalars['Int']['output'];
  refundCushionMin: Scalars['Int']['output'];
  refundCushionWindowDays: Scalars['Int']['output'];
  refundFee?: Maybe<Scalars['Float']['output']>;
  refundFundingMin?: Maybe<Scalars['Int']['output']>;
  refundTransactionFee?: Maybe<Scalars['Float']['output']>;
  settlementDelay?: Maybe<Scalars['Int']['output']>;
};

export type PaymentProcessingInput = {
  achCredit?: InputMaybe<Scalars['Float']['input']>;
  achCreditBillingCategory?: InputMaybe<ConnectUniqueInput>;
  achFee?: InputMaybe<Scalars['Float']['input']>;
  achTransactionFee?: InputMaybe<Scalars['Float']['input']>;
  additionalCreditTransactionFee?: InputMaybe<Scalars['Float']['input']>;
  allowOrgManageSettlementDelay?: InputMaybe<Scalars['Boolean']['input']>;
  creditFee?: InputMaybe<Scalars['Float']['input']>;
  creditTransactionFee?: InputMaybe<Scalars['Float']['input']>;
  disputeFee?: InputMaybe<Scalars['Float']['input']>;
  enableAch?: InputMaybe<Scalars['Boolean']['input']>;
  enableRefundCushion?: InputMaybe<Scalars['Boolean']['input']>;
  enableRefundFee?: InputMaybe<Scalars['Boolean']['input']>;
  enableRefundFunding?: InputMaybe<Scalars['Boolean']['input']>;
  lastSettlementDelayChange?: InputMaybe<Scalars['Date']['input']>;
  lastSettlementDelayChangeBy?: InputMaybe<ConnectUniqueInput>;
  maxAchFee?: InputMaybe<Scalars['Float']['input']>;
  minSettlementDelayChange?: InputMaybe<Scalars['Int']['input']>;
  refundCushion?: InputMaybe<Scalars['Float']['input']>;
  refundCushionMax?: InputMaybe<Scalars['Int']['input']>;
  refundCushionMin?: InputMaybe<Scalars['Int']['input']>;
  refundCushionWindowDays?: InputMaybe<Scalars['Int']['input']>;
  refundFee?: InputMaybe<Scalars['Float']['input']>;
  refundFundingMin?: InputMaybe<Scalars['Int']['input']>;
  refundTransactionFee?: InputMaybe<Scalars['Float']['input']>;
  settlementDelay?: InputMaybe<Scalars['Int']['input']>;
};

export type PaymentProcessingUpdateInput = {
  create?: InputMaybe<PaymentProcessingInput>;
  update?: InputMaybe<PaymentProcessingInput>;
};

export type PaymentSessionInput = {
  accountHolderId?: InputMaybe<Scalars['String']['input']>;
  legalEntityId?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<PaymentSessionType>;
};

export type PaymentSessionPayload = {
  applePay?: Maybe<ApplePayConfiguration>;
  googlePay?: Maybe<GooglePayConfiguration>;
  id: Scalars['String']['output'];
  sessionData: Scalars['String']['output'];
};

export const PaymentSessionType = {
  Checkout: 'Checkout',
  Dispute: 'Dispute',
  Legal: 'Legal'
} as const;

export type PaymentSessionType = typeof PaymentSessionType[keyof typeof PaymentSessionType];
export type PaymentSetting = {
  id: Scalars['ID']['output'];
  legalEntityId?: Maybe<Scalars['String']['output']>;
};

export const PaymentType = {
  Bank: 'Bank',
  Card: 'Card',
  Cash: 'Cash',
  Check: 'Check',
  Error: 'Error'
} as const;

export type PaymentType = typeof PaymentType[keyof typeof PaymentType];
export type PaymentUpdateInput = {
  data?: InputMaybe<PaymentCreateInput>;
  where?: InputMaybe<UniqueInput>;
};

export type PaymentWhereInput = {
  amount?: InputMaybe<IntFilter>;
  id?: InputMaybe<Scalars['ID']['input']>;
  stripeChargeId?: InputMaybe<Scalars['String']['input']>;
};

export type Payout = {
  amount: Scalars['Int']['output'];
  by?: Maybe<User>;
  created: Scalars['Date']['output'];
  date?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  stripe: StripeType;
  stripeAccountId?: Maybe<Scalars['String']['output']>;
};

export type PayoutCreateInput = {
  amount: Scalars['Int']['input'];
  by?: InputMaybe<ConnectUniqueInput>;
  date?: InputMaybe<Scalars['Date']['input']>;
  fee: Scalars['Int']['input'];
  organizationId: Scalars['ID']['input'];
};

export type PayoutItem = {
  id: Scalars['ID']['output'];
  payment?: Maybe<Payment>;
  refund?: Maybe<Refund>;
};

export type PayoutItemWhereInput = {
  amount?: InputMaybe<IntFilter>;
  appSweepId?: InputMaybe<Scalars['String']['input']>;
  balanceAccountId?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
  sweepId?: InputMaybe<Scalars['String']['input']>;
};

export type PayoutItemsCountPayload = {
  compare: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type PayoutManyInput = {
  create?: InputMaybe<Array<InputMaybe<PayoutCreateInput>>>;
  delete?: InputMaybe<Array<InputMaybe<UniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<PayoutUpdateInput>>>;
};

export type PayoutUpdateInput = {
  data?: InputMaybe<PayoutCreateInput>;
  where?: InputMaybe<UniqueInput>;
};

export type PendingCancel = {
  finalDate: Scalars['Date']['output'];
  userId: Scalars['String']['output'];
};

export const PermissionType = {
  AccessAdvancedSetting: 'AccessAdvancedSetting',
  AssignInstructor: 'AssignInstructor',
  CancelClass: 'CancelClass',
  CancelRegistration: 'CancelRegistration',
  ChangePermission: 'ChangePermission',
  EditRoster: 'EditRoster',
  ExportData: 'ExportData',
  ManageDepartment: 'ManageDepartment',
  MoveRegistration: 'MoveRegistration',
  ViewRoster: 'ViewRoster'
} as const;

export type PermissionType = typeof PermissionType[keyof typeof PermissionType];
export type PermissionTypeManyInput = {
  set: Array<PermissionType>;
};

export type PreviewInvoice = {
  balance?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  invoice?: Maybe<Scalars['Json']['output']>;
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type PriceAdjustment = {
  class?: Maybe<Class>;
  classId?: Maybe<Scalars['String']['output']>;
  classMembershipCheckInPrice?: Maybe<Class>;
  classMembershipCheckInPriceId?: Maybe<Scalars['String']['output']>;
  classMembershipPrice?: Maybe<Class>;
  classMembershipPriceId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Date']['output'];
  date?: Maybe<Scalars['Date']['output']>;
  fee?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  membershipOffering?: Maybe<MembershipOffering>;
  membershipOfferingId?: Maybe<Scalars['String']['output']>;
  min?: Maybe<Scalars['Int']['output']>;
  offering?: Maybe<Offering>;
  offeringExtension?: Maybe<Offering>;
  offeringExtensionId?: Maybe<Scalars['String']['output']>;
  offeringId?: Maybe<Scalars['String']['output']>;
  organization?: Maybe<Organization>;
  organizationId?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['Date']['output'];
};

export type PriceAdjustmentCreateInput = {
  class?: InputMaybe<ConnectUniqueInput>;
  date?: InputMaybe<Scalars['Date']['input']>;
  fee?: InputMaybe<Scalars['Float']['input']>;
  membershipOffering?: InputMaybe<ConnectUniqueInput>;
  min?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<ConnectUniqueInput>;
  price?: InputMaybe<Scalars['Int']['input']>;
};

export type PriceAdjustmentManyInput = {
  create?: InputMaybe<Array<InputMaybe<PriceAdjustmentCreateInput>>>;
  delete?: InputMaybe<Array<InputMaybe<UniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<PriceAdjustmentUpdateInput>>>;
};

export type PriceAdjustmentUpdateInput = {
  data?: InputMaybe<PriceAdjustmentCreateInput>;
  where?: InputMaybe<UniqueInput>;
};

export type PriceLevel = {
  createdAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  membershipOffering?: Maybe<MembershipOffering>;
  membershipOfferingId?: Maybe<Scalars['String']['output']>;
  number: Scalars['Int']['output'];
  price: Scalars['Int']['output'];
  updatedAt: Scalars['Date']['output'];
};

export type PriceLevelCreateInput = {
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  number: Scalars['Int']['input'];
  price: Scalars['Int']['input'];
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type PriceLevelManyInput = {
  create?: InputMaybe<Array<InputMaybe<PriceLevelCreateInput>>>;
  delete?: InputMaybe<Array<InputMaybe<UniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<PriceLevelUpdateInput>>>;
};

export type PriceLevelUpdateInput = {
  data?: InputMaybe<PriceLevelCreateInput>;
  where?: InputMaybe<UniqueInput>;
};

export type PrivateSerie = {
  accountEmail?: Maybe<Scalars['String']['output']>;
  accountNotificationType?: Maybe<NotificationType>;
  accountOwner: User;
  accountOwnerId?: Maybe<Scalars['String']['output']>;
  accountPhone?: Maybe<Scalars['String']['output']>;
  attendances: Array<PrivateSerieAttendance>;
  availableDays: Array<Day>;
  createdAt: Scalars['Date']['output'];
  createdBy?: Maybe<User>;
  createdById?: Maybe<Scalars['String']['output']>;
  customerInfoRequestResponses: Array<CustomerInfoRequestResponse>;
  events: Array<Event>;
  firstLessonEnd?: Maybe<Scalars['Date']['output']>;
  firstLessonStart?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  initialNumberOfLessons?: Maybe<Scalars['Int']['output']>;
  instructor?: Maybe<User>;
  instructorId?: Maybe<Scalars['String']['output']>;
  instructorsToNotify: Array<User>;
  invoiceItems: Array<InvoiceItem>;
  monthlyLessonsRemaining?: Maybe<Scalars['Int']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  numberOfLessons?: Maybe<Scalars['Int']['output']>;
  offering?: Maybe<Offering>;
  offeringId?: Maybe<Scalars['String']['output']>;
  organization?: Maybe<Organization>;
  organizationId?: Maybe<Scalars['String']['output']>;
  previousSerie?: Maybe<PrivateSerie>;
  previousSerieId?: Maybe<Scalars['String']['output']>;
  roster: Array<User>;
  scheduledThrough?: Maybe<Scalars['Date']['output']>;
  specialRequests?: Maybe<Scalars['String']['output']>;
  status: PrivateSerieStatus;
  studentInfoRequestResponses: Array<StudentInfoRequestResponse>;
  updatedAt: Scalars['Date']['output'];
};


export type PrivateSerieeventsArgs = {
  orderBy?: InputMaybe<EventOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DefaultWhereInput>;
};

export type PrivateSerieAttendance = {
  atAccountHome: Scalars['Boolean']['output'];
  automated: Scalars['Boolean']['output'];
  completedBy?: Maybe<User>;
  completedById?: Maybe<Scalars['String']['output']>;
  completedOn?: Maybe<Scalars['Date']['output']>;
  createdAt: Scalars['Date']['output'];
  date: Scalars['Date']['output'];
  duration?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  instructor?: Maybe<User>;
  instructorId?: Maybe<Scalars['String']['output']>;
  invoiceItems: Array<InvoiceItem>;
  location: Location;
  locationId?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  number?: Maybe<Scalars['Int']['output']>;
  organization?: Maybe<Organization>;
  organizationId?: Maybe<Scalars['String']['output']>;
  privateSerie?: Maybe<PrivateSerie>;
  privateSerieId?: Maybe<Scalars['String']['output']>;
  scheduledBy?: Maybe<User>;
  scheduledById?: Maybe<Scalars['String']['output']>;
  scheduledOn?: Maybe<Scalars['Date']['output']>;
  status: PrivateSerieAttendanceStatus;
  studentsAdded: Array<User>;
  studentsAttended: Array<User>;
  time: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
  verifiedBy?: Maybe<User>;
  verifiedById?: Maybe<Scalars['String']['output']>;
  verifiedOn?: Maybe<Scalars['Date']['output']>;
  zone?: Maybe<Zone>;
  zoneId?: Maybe<Scalars['String']['output']>;
};

export type PrivateSerieAttendanceCreateInput = {
  atAccountHome?: InputMaybe<Scalars['Boolean']['input']>;
  automated?: InputMaybe<Scalars['Boolean']['input']>;
  completedBy?: InputMaybe<ConnectUniqueInput>;
  completedOn?: InputMaybe<Scalars['Date']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  instructor?: InputMaybe<ConnectUniqueInput>;
  location?: InputMaybe<LocationNestedInput>;
  note?: InputMaybe<Scalars['String']['input']>;
  number?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<ConnectUniqueInput>;
  privateSerie?: InputMaybe<PrivateSerieUpdateConnectInput>;
  scheduledBy?: InputMaybe<ConnectUniqueInput>;
  scheduledOn?: InputMaybe<Scalars['Date']['input']>;
  status?: InputMaybe<PrivateSerieAttendanceStatus>;
  studentsAdded?: InputMaybe<ConnectManyInput>;
  studentsAttended?: InputMaybe<ConnectManyInput>;
  time?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  verifiedBy?: InputMaybe<ConnectUniqueInput>;
  verifiedOn?: InputMaybe<Scalars['Date']['input']>;
  zone?: InputMaybe<ConnectUniqueInput>;
};

export type PrivateSerieAttendanceManyInput = {
  connect?: InputMaybe<Array<InputMaybe<UniqueInput>>>;
  create?: InputMaybe<Array<InputMaybe<PrivateSerieAttendanceCreateInput>>>;
  delete?: InputMaybe<Array<InputMaybe<UniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<PrivateSerieAttendanceUpdateInput>>>;
};

export type PrivateSerieAttendanceOrderByInput = {
  date?: InputMaybe<SortOrder>;
};

export const PrivateSerieAttendanceStatus = {
  Canceled: 'Canceled',
  Completed: 'Completed',
  Pending: 'Pending',
  Reschedule: 'Reschedule',
  Scheduled: 'Scheduled',
  Verified: 'Verified'
} as const;

export type PrivateSerieAttendanceStatus = typeof PrivateSerieAttendanceStatus[keyof typeof PrivateSerieAttendanceStatus];
export type PrivateSerieAttendanceStatusFilter = {
  equals?: InputMaybe<PrivateSerieAttendanceStatus>;
  in?: InputMaybe<Array<PrivateSerieAttendanceStatus>>;
  not?: InputMaybe<PrivateSerieAttendanceStatus>;
  notIn?: InputMaybe<Array<PrivateSerieAttendanceStatus>>;
};

export type PrivateSerieAttendanceUpdateInput = {
  data?: InputMaybe<PrivateSerieAttendanceCreateInput>;
  where?: InputMaybe<UniqueInput>;
};

export type PrivateSerieAttendanceWhereInput = {
  AND?: InputMaybe<PrivateSerieAttendanceWhereInput>;
  NOT?: InputMaybe<PrivateSerieAttendanceWhereInput>;
  OR?: InputMaybe<Array<PrivateSerieAttendanceWhereInput>>;
  date?: InputMaybe<DateFilter>;
  id?: InputMaybe<StringFilter>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  privateSerie?: InputMaybe<PrivateSerieWhereInput>;
  status?: InputMaybe<PrivateSerieAttendanceStatusFilter>;
};

export type PrivateSerieAttendancesCountsPayload = {
  completed?: Maybe<Scalars['Int']['output']>;
  count?: Maybe<Scalars['Int']['output']>;
  instructors: Array<FilterItem>;
  month?: Maybe<Scalars['Json']['output']>;
  scheduled?: Maybe<Scalars['Int']['output']>;
  staff?: Maybe<Scalars['Json']['output']>;
  today?: Maybe<Scalars['Json']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
  unscheduled?: Maybe<Scalars['Int']['output']>;
  verified?: Maybe<Scalars['Int']['output']>;
  week?: Maybe<Scalars['Json']['output']>;
};

export type PrivateSerieCreateInput = {
  accountEmail?: InputMaybe<Scalars['String']['input']>;
  accountNotificationType?: InputMaybe<NotificationType>;
  accountOwner?: InputMaybe<ConnectUniqueInput>;
  accountPhone?: InputMaybe<Scalars['String']['input']>;
  attendances?: InputMaybe<PrivateSerieAttendanceManyInput>;
  availableDays?: InputMaybe<DayManyInput>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  createdBy?: InputMaybe<ConnectUniqueInput>;
  customerInfoRequestResponses?: InputMaybe<CustomerInfoRequestResponseManyInput>;
  events?: InputMaybe<EventManyInput>;
  firstLessonEnd?: InputMaybe<Scalars['Date']['input']>;
  firstLessonStart?: InputMaybe<Scalars['Date']['input']>;
  initialNumberOfLessons?: InputMaybe<Scalars['Int']['input']>;
  instructor?: InputMaybe<ConnectUniqueInput>;
  instructorsToNotify?: InputMaybe<ConnectManyInput>;
  monthlyLessonsRemaining?: InputMaybe<Scalars['Int']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  numberOfLessons?: InputMaybe<Scalars['Int']['input']>;
  offering?: InputMaybe<OfferingNestedInput>;
  organization?: InputMaybe<ConnectUniqueInput>;
  previousSerie?: InputMaybe<ConnectUniqueInput>;
  roster?: InputMaybe<UserManyInput>;
  scheduledThrough?: InputMaybe<Scalars['Date']['input']>;
  specialRequests?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<PrivateSerieStatus>;
  studentInfoRequestResponses?: InputMaybe<StudentInfoRequestResponseManyInput>;
};

export type PrivateSerieManyInput = {
  update?: InputMaybe<Array<InputMaybe<PrivateSerieUpdateInput>>>;
};

export const PrivateSerieStatus = {
  Abandoned: 'Abandoned',
  Archived: 'Archived',
  Canceled: 'Canceled',
  Completed: 'Completed',
  Error: 'Error',
  InProgress: 'InProgress',
  Pending: 'Pending',
  Posted: 'Posted',
  Transferred: 'Transferred'
} as const;

export type PrivateSerieStatus = typeof PrivateSerieStatus[keyof typeof PrivateSerieStatus];
export type PrivateSerieStatusFilter = {
  equals?: InputMaybe<PrivateSerieStatus>;
  in?: InputMaybe<Array<PrivateSerieStatus>>;
  not?: InputMaybe<PrivateSerieStatus>;
  notIn?: InputMaybe<Array<PrivateSerieStatus>>;
};

export type PrivateSerieUpdateConnectInput = {
  connect?: InputMaybe<UniqueInput>;
  update?: InputMaybe<PrivateSerieCreateInput>;
};

export type PrivateSerieUpdateInput = {
  data?: InputMaybe<PrivateSerieCreateInput>;
  where?: InputMaybe<UniqueInput>;
};

export type PrivateSerieWhereInput = {
  AND?: InputMaybe<PrivateSerieWhereInput>;
  NOT?: InputMaybe<PrivateSerieWhereInput>;
  OR?: InputMaybe<Array<PrivateSerieWhereInput>>;
  accountOwner?: InputMaybe<UserWhereInput>;
  accountOwnerId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<StringFilter>;
  instructorId?: InputMaybe<Scalars['String']['input']>;
  instructorsToNotify?: InputMaybe<UserListRelationFilter>;
  offering?: InputMaybe<OfferingWhereInput>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  roster?: InputMaybe<UserListRelationFilter>;
  status?: InputMaybe<PrivateSerieStatusFilter>;
};

export type PrivateSeriesForUserPayload = {
  count?: Maybe<Scalars['Int']['output']>;
  privateSeries: Array<PrivateSerie>;
};

export type Program = {
  active: Scalars['Boolean']['output'];
  billingCategory?: Maybe<BillingCategory>;
  billingCategoryId?: Maybe<Scalars['String']['output']>;
  classes: Array<Class>;
  createdAt: Scalars['Date']['output'];
  customNotes: Array<Scalars['String']['output']>;
  department?: Maybe<Department>;
  departmentId?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  evaluationReminderFrequency?: Maybe<Scalars['Int']['output']>;
  hideInFilters?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  images: Array<File>;
  integration: IntegrationType;
  membershipOfferings: Array<MembershipOffering>;
  offerings: Array<Offering>;
  order?: Maybe<Scalars['Int']['output']>;
  organization?: Maybe<Organization>;
  organizationId?: Maybe<Scalars['String']['output']>;
  skills: Array<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
};

export type ProgramConnectCreateInput = {
  connect?: InputMaybe<UniqueInput>;
  create?: InputMaybe<ProgramCreateInput>;
};

export type ProgramCreateInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  billingCategory?: InputMaybe<BillingCategoryNestedInput>;
  customNotes?: InputMaybe<StringManyInput>;
  department?: InputMaybe<ConnectUniqueInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  evaluationReminderFrequency?: InputMaybe<Scalars['Int']['input']>;
  hideInFilters?: InputMaybe<Scalars['Boolean']['input']>;
  images?: InputMaybe<ConnectManyInput>;
  order?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<ConnectUniqueInput>;
  skills?: InputMaybe<StringManyInput>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ProgramManyInput = {
  create?: InputMaybe<Array<InputMaybe<ProgramCreateInput>>>;
  update?: InputMaybe<Array<InputMaybe<ProgramUpdateInput>>>;
};

export type ProgramOrderByInput = {
  order?: InputMaybe<SortOrder>;
};

export type ProgramUpdateInput = {
  data?: InputMaybe<ProgramCreateInput>;
  where?: InputMaybe<UniqueInput>;
};

export type ProgramWhereInput = {
  AND?: InputMaybe<ProgramWhereInput>;
  NOT?: InputMaybe<ProgramWhereInput>;
  OR?: InputMaybe<Array<ProgramWhereInput>>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  classes?: InputMaybe<ClassListRelationFilter>;
  departmentId?: InputMaybe<StringFilter>;
  hideInFilters?: InputMaybe<Scalars['Boolean']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
};

export type Query = {
  activities?: Maybe<ActivitiesPayload>;
  addon?: Maybe<Addon>;
  addons?: Maybe<Array<Addon>>;
  agreement?: Maybe<Agreement>;
  agreements?: Maybe<Array<Agreement>>;
  appSetting?: Maybe<AppSetting>;
  attendance?: Maybe<Attendance>;
  attendances: Array<Maybe<Attendance>>;
  attendancesCounts?: Maybe<AttendancesCountsPayload>;
  auditEvents: Array<AuditEvent>;
  balanceAccounts: Array<BalanceAccount>;
  billingCategories?: Maybe<Array<BillingCategory>>;
  billingCategory?: Maybe<BillingCategory>;
  bulkClass: BulkClass;
  bulkOrganization: BulkOrganization;
  captynUsers: Array<User>;
  captynUsersCounts?: Maybe<CaptynUsersCountsPayload>;
  charge?: Maybe<Charge>;
  chargeAmount?: Maybe<ChargeAmount>;
  chargeAmounts?: Maybe<Array<ChargeAmount>>;
  charges?: Maybe<Array<Charge>>;
  checkCoupon?: Maybe<Coupon>;
  checkResetPasswordToken: Scalars['Boolean']['output'];
  class?: Maybe<Class>;
  classStats?: Maybe<ClassStatsPayload>;
  classes: Array<Class>;
  classesCounts?: Maybe<FilteredClassesCountsPayload>;
  communication?: Maybe<Communication>;
  communications: Array<Communication>;
  coupon?: Maybe<Coupon>;
  coupons?: Maybe<Array<Coupon>>;
  credit?: Maybe<Credit>;
  credits?: Maybe<Array<Credit>>;
  customerRequest?: Maybe<CustomerRequest>;
  customerRequests?: Maybe<Array<CustomerRequest>>;
  customerServiceItem?: Maybe<CustomerServiceItem>;
  customerServiceItems?: Maybe<Array<CustomerServiceItem>>;
  department?: Maybe<Department>;
  departments?: Maybe<Array<Department>>;
  discount?: Maybe<Discount>;
  discounts?: Maybe<Array<Discount>>;
  enrollmentFilters?: Maybe<EnrollmentFiltersPayload>;
  evaluation?: Maybe<Evaluation>;
  evaluations?: Maybe<Array<Evaluation>>;
  events?: Maybe<Array<Event>>;
  eventsCounts?: Maybe<EventsCountsPayload>;
  fees?: Maybe<Array<Fee>>;
  file?: Maybe<File>;
  files?: Maybe<Array<File>>;
  financialReport?: Maybe<FinancialReportPayload>;
  findFilters?: Maybe<FindFiltersPayload>;
  groupRegistration?: Maybe<GroupRegistration>;
  groupRegistrations: Array<GroupRegistration>;
  groupRegistrationsCounts?: Maybe<GroupRegistrationsCountsPayload>;
  healthQuestion?: Maybe<HealthQuestion>;
  healthQuestions?: Maybe<Array<HealthQuestion>>;
  historicalFinancialReport?: Maybe<Array<Maybe<HistoricalFinancialReportCounts>>>;
  invoice?: Maybe<Invoice>;
  invoiceCharts?: Maybe<InvoiceChartsPayload>;
  invoiceItem?: Maybe<InvoiceItem>;
  invoiceItems?: Maybe<Array<InvoiceItem>>;
  invoices: Array<Invoice>;
  invoicesCounts?: Maybe<FilteredInvoicesCountsPayload>;
  jobCredits: Array<JobCredit>;
  jobs: Array<Job>;
  location?: Maybe<Location>;
  locations?: Maybe<Array<Location>>;
  me: AuthPayload;
  meet: Meet;
  meetCharges?: Maybe<Scalars['Json']['output']>;
  meetDeclarations: Array<MeetDeclaration>;
  meetParticipants: MeetParticipantPayload;
  meetPresentations: Array<MeetPresentation>;
  meetResults: Array<MeetResult>;
  meetResultsEligibility: Array<MeetResultEligibility>;
  meetResultsImprovement: Array<MeetResultImprovement>;
  meetResultsMeets: Array<Meet>;
  meets: Array<Meet>;
  meetsCounts?: Maybe<MeetsCountsPayload>;
  membership?: Maybe<Membership>;
  membershipOffering?: Maybe<MembershipOffering>;
  membershipOfferingCounts?: Maybe<MembershipOfferingCountsPayload>;
  membershipOfferingStats?: Maybe<MembershipOfferingStatsPayload>;
  membershipOfferings: Array<Maybe<MembershipOffering>>;
  membershipOfferingsCounts?: Maybe<MembershipOfferingsCountsPayload>;
  memberships?: Maybe<Array<Membership>>;
  membershipsCounts?: Maybe<MembershipsCountsPayload>;
  message: Message;
  messages: Array<Message>;
  nativeApp?: Maybe<NativeApp>;
  nativeApps: Array<Maybe<NativeApp>>;
  nextAttendance?: Maybe<Attendance>;
  offering?: Maybe<Offering>;
  offerings: Array<Offering>;
  offeringsCounts?: Maybe<FilteredOfferingsCountsPayload>;
  onboard?: Maybe<Onboard>;
  onboards?: Maybe<Array<Onboard>>;
  orgTimeStandards: Array<OrgTimeStandard>;
  organization: Organization;
  organizations?: Maybe<Array<Organization>>;
  organizationsCounts?: Maybe<OrganizationsCountsPayload>;
  payment?: Maybe<Payment>;
  paymentSession: PaymentSessionPayload;
  payments?: Maybe<Array<Payment>>;
  payoutItems: Array<PayoutItem>;
  payoutItemsCount: PayoutItemsCountPayload;
  payouts: Array<Payout>;
  priceAdjustment?: Maybe<PriceAdjustment>;
  priceAdjustments?: Maybe<Array<PriceAdjustment>>;
  privateSerie?: Maybe<PrivateSerie>;
  privateSerieAttendance: PrivateSerieAttendance;
  privateSerieAttendances: Array<PrivateSerieAttendance>;
  privateSerieAttendancesCounts?: Maybe<PrivateSerieAttendancesCountsPayload>;
  privateSeries: Array<PrivateSerie>;
  privateSeriesCounts?: Maybe<FilteredPrivateSeriesCountsPayload>;
  program?: Maybe<Program>;
  programs?: Maybe<Array<Program>>;
  recipients: Array<Recipient>;
  recurringCharge?: Maybe<RecurringCharge>;
  recurringCharges?: Maybe<Array<RecurringCharge>>;
  recurringCredit?: Maybe<RecurringCredit>;
  recurringCredits?: Maybe<Array<RecurringCredit>>;
  referral: Referral;
  referralTemplate: ReferralTemplate;
  referralTemplates: Array<ReferralTemplate>;
  referralsCounts: ReferralsCountsPayload;
  refunds?: Maybe<Array<Refund>>;
  revenueOverTime?: Maybe<Scalars['Json']['output']>;
  salesStats?: Maybe<Scalars['Json']['output']>;
  scheduledCommunications: Array<ScheduledCommunication>;
  searchOrganizations: Array<SearchOrganization>;
  serviceRuns: Array<ServiceRun>;
  staffEvaluation?: Maybe<StaffEvaluation>;
  staffEvaluations?: Maybe<Array<StaffEvaluation>>;
  status?: Maybe<Scalars['String']['output']>;
  stripeAccount: StripeAccountPayload;
  stripeAccounts: Array<StripeAccountPayload>;
  stripeCustomer: Scalars['Json']['output'];
  studentAttendanceNote?: Maybe<StudentAttendanceNote>;
  studentAttendanceNotes?: Maybe<Array<StudentAttendanceNote>>;
  studentInfoRequest?: Maybe<StudentInfoRequest>;
  studentInfoRequests?: Maybe<Array<StudentInfoRequest>>;
  tag?: Maybe<Tag>;
  tags?: Maybe<Array<Tag>>;
  timeStandard: TimeStandard;
  timeStandards: Array<TimeStandard>;
  token?: Maybe<Token>;
  tokens?: Maybe<Array<Token>>;
  unreadItems?: Maybe<UnreadItemsPayload>;
  upgrades: Array<Upgrade>;
  usaSwimming?: Maybe<Scalars['Json']['output']>;
  usaSwimmingCounts?: Maybe<USASwimmingCountsPayload>;
  usaSwimmingMembers: Array<User>;
  user?: Maybe<User>;
  userBillingSummary: UserBillingSummaryPayload;
  userEmail: UserEmailPayload;
  userReferralTemplate: UserReferralTemplate;
  users: Array<User>;
  usersCounts?: Maybe<FilteredUsersCountsPayload>;
  volunteerEvent: VolunteerEvent;
  volunteerEvents: Array<VolunteerEvent>;
  volunteerEventsCounts: VolunteerEventCountsPayload;
};


export type QueryactivitiesArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  offeringId?: InputMaybe<Scalars['ID']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryaddonArgs = {
  where: UniqueInput;
};


export type QueryaddonsArgs = {
  orderBy?: InputMaybe<AddonOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AddonWhereInput>;
};


export type QueryagreementArgs = {
  where: UniqueInput;
};


export type QueryagreementsArgs = {
  orderBy?: InputMaybe<AgreementOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DefaultWhereInput>;
};


export type QueryattendanceArgs = {
  where: UniqueInput;
};


export type QueryattendancesArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<AttendanceOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AttendanceWhereInput>;
};


export type QueryattendancesCountsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<AttendanceWhereInput>;
};


export type QueryauditEventsArgs = {
  includeData?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AuditEventWhereInput>;
};


export type QuerybalanceAccountsArgs = {
  balanceAccount?: InputMaybe<Scalars['ID']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
};


export type QuerybillingCategoriesArgs = {
  orderBy?: InputMaybe<BillingCategoryOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<BillingCategoryWhereInput>;
};


export type QuerybillingCategoryArgs = {
  where: UniqueInput;
};


export type QuerybulkClassArgs = {
  checkField?: InputMaybe<Scalars['String']['input']>;
  checkValue?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<BulkClassWhereInput>;
};


export type QuerybulkOrganizationArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};


export type QuerycaptynUsersArgs = {
  orderBy?: InputMaybe<UserOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CaptynUsersInput>;
};


export type QuerycaptynUsersCountsArgs = {
  where?: InputMaybe<CaptynUsersInput>;
};


export type QuerychargeArgs = {
  where: UniqueInput;
};


export type QuerychargeAmountArgs = {
  where: UniqueInput;
};


export type QuerychargeAmountsArgs = {
  orderBy?: InputMaybe<DefaultOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DefaultWhereInput>;
};


export type QuerychargesArgs = {
  orderBy?: InputMaybe<DefaultOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ChargeWhereInput>;
};


export type QuerycheckCouponArgs = {
  code: Scalars['String']['input'];
  groupOfferingIds: Array<Scalars['String']['input']>;
  membershipOfferingIds: Array<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
  privateOfferingIds: Array<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type QuerycheckResetPasswordTokenArgs = {
  token?: InputMaybe<Scalars['String']['input']>;
};


export type QueryclassArgs = {
  where: UniqueInput;
};


export type QueryclassStatsArgs = {
  where?: InputMaybe<ClassStatsInput>;
};


export type QueryclassesArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<ClassOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ClassWhereInput>;
};


export type QueryclassesCountsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<ClassWhereInput>;
};


export type QuerycommunicationArgs = {
  where: UniqueInput;
};


export type QuerycommunicationsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<DefaultOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CommunicationWhereInput>;
};


export type QuerycouponArgs = {
  where: UniqueInput;
};


export type QuerycouponsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<DefaultOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CouponWhereInput>;
};


export type QuerycreditArgs = {
  where: UniqueInput;
};


export type QuerycreditsArgs = {
  orderBy?: InputMaybe<DefaultOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DefaultWhereInput>;
};


export type QuerycustomerRequestArgs = {
  where: UniqueInput;
};


export type QuerycustomerRequestsArgs = {
  orderBy?: InputMaybe<DefaultOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DefaultWhereInput>;
};


export type QuerycustomerServiceItemArgs = {
  where?: InputMaybe<UniqueInput>;
};


export type QuerycustomerServiceItemsArgs = {
  orderBy?: InputMaybe<DefaultOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CustomerServiceItemWhereInput>;
};


export type QuerydepartmentArgs = {
  where: UniqueInput;
};


export type QuerydepartmentsArgs = {
  orderBy?: InputMaybe<DepartmentOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DefaultWhereInput>;
};


export type QuerydiscountArgs = {
  where: UniqueInput;
};


export type QuerydiscountsArgs = {
  orderBy?: InputMaybe<DefaultOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DiscountWhereInput>;
};


export type QueryenrollmentFiltersArgs = {
  offeringId?: InputMaybe<Scalars['ID']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryevaluationArgs = {
  where: UniqueInput;
};


export type QueryevaluationsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<DefaultOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<EvaluationWhereInput>;
};


export type QueryeventsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<DefaultOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<EventWhereInput>;
};


export type QueryeventsCountsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<EventWhereInput>;
};


export type QueryfeesArgs = {
  orderBy?: InputMaybe<FeeOrderByInput>;
  where?: InputMaybe<DefaultWhereInput>;
};


export type QueryfileArgs = {
  where: UniqueInput;
};


export type QueryfilesArgs = {
  orderBy?: InputMaybe<DefaultOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DefaultWhereInput>;
};


export type QueryfinancialReportArgs = {
  where: FinancialReportInput;
};


export type QueryfindFiltersArgs = {
  explore?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
  groupWhere?: InputMaybe<ClassWhereInput>;
  membershipWhere?: InputMaybe<MembershipOfferingWhereInput>;
  privateWhere?: InputMaybe<OfferingWhereInput>;
};


export type QuerygroupRegistrationArgs = {
  where: UniqueInput;
};


export type QuerygroupRegistrationsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<DefaultOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GroupRegistrationWhereInput>;
};


export type QuerygroupRegistrationsCountsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<GroupRegistrationWhereInput>;
};


export type QueryhealthQuestionArgs = {
  where: UniqueInput;
};


export type QueryhealthQuestionsArgs = {
  orderBy?: InputMaybe<HealthQuestionOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DefaultWhereInput>;
};


export type QueryhistoricalFinancialReportArgs = {
  aggregate?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
  includeCaptyn?: InputMaybe<Scalars['Boolean']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  range?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryinvoiceArgs = {
  where: UniqueInput;
};


export type QueryinvoiceChartsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  invoiceItemWhere?: InputMaybe<InvoiceItemWhereInput>;
  invoiceWhere?: InputMaybe<InvoiceWhereInput>;
  itemized?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryinvoiceItemArgs = {
  where: UniqueInput;
};


export type QueryinvoiceItemsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<DefaultOrderByInput>;
  reports?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  skipCount?: InputMaybe<Scalars['Boolean']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<InvoiceItemWhereInput>;
};


export type QueryinvoicesArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<InvoiceOrderByInput>;
  reports?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<InvoiceWhereInput>;
};


export type QueryinvoicesCountsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<InvoiceWhereInput>;
};


export type QueryjobCreditsArgs = {
  orderBy?: InputMaybe<DefaultOrderByInput>;
  where?: InputMaybe<JobCreditWhereInput>;
};


export type QueryjobsArgs = {
  orderBy?: InputMaybe<JobOrderByInput>;
  where: JobWhereInput;
};


export type QuerylocationArgs = {
  where: UniqueInput;
};


export type QuerylocationsArgs = {
  orderBy?: InputMaybe<LocationOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<LocationWhereInput>;
};


export type QuerymeArgs = {
  where?: InputMaybe<MeInput>;
};


export type QuerymeetArgs = {
  dbTest?: InputMaybe<Scalars['String']['input']>;
  where: UniqueInput;
};


export type QuerymeetChargesArgs = {
  departmentId?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
  where: UniqueInput;
};


export type QuerymeetDeclarationsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<MeetOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where: MeetDeclarationWhereInput;
};


export type QuerymeetParticipantsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where: MeetParticipantWhereInput;
};


export type QuerymeetPresentationsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  where: UniqueInput;
};


export type QuerymeetResultsArgs = {
  dbTest?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<MeetResultOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MeetResultWhereInput>;
};


export type QuerymeetResultsEligibilityArgs = {
  ageUpDate?: InputMaybe<Scalars['Date']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<MeetResultOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  timesSince?: InputMaybe<Scalars['Date']['input']>;
  where?: InputMaybe<MeetResultWhereInput>;
};


export type QuerymeetResultsImprovementArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<MeetResultOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MeetResultWhereInput>;
};


export type QuerymeetsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<MeetOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MeetWhereInput>;
};


export type QuerymeetsCountsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<MeetWhereInput>;
};


export type QuerymembershipArgs = {
  where: UniqueInput;
};


export type QuerymembershipOfferingArgs = {
  where?: InputMaybe<UniqueInput>;
};


export type QuerymembershipOfferingCountsArgs = {
  id: Scalars['ID']['input'];
};


export type QuerymembershipOfferingStatsArgs = {
  where?: InputMaybe<MembershipOfferingStatsInput>;
};


export type QuerymembershipOfferingsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<DefaultOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MembershipOfferingWhereInput>;
};


export type QuerymembershipOfferingsCountsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<MembershipOfferingWhereInput>;
};


export type QuerymembershipsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<DefaultOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MembershipWhereInput>;
};


export type QuerymembershipsCountsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<MembershipWhereInput>;
};


export type QuerymessageArgs = {
  where: MessageWhereInput;
};


export type QuerymessagesArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where: MessageWhereInput;
};


export type QuerynativeAppArgs = {
  where: UniqueInput;
};


export type QuerynativeAppsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<DefaultOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<NativeAppWhereInput>;
};


export type QuerynextAttendanceArgs = {
  date?: InputMaybe<Scalars['Date']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  studentIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};


export type QueryofferingArgs = {
  where: UniqueInput;
};


export type QueryofferingsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<OfferingOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<OfferingWhereInput>;
};


export type QueryofferingsCountsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<OfferingWhereInput>;
};


export type QueryonboardArgs = {
  where: UniqueInput;
};


export type QueryonboardsArgs = {
  orderBy?: InputMaybe<DefaultOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<OnboardWhereInput>;
};


export type QueryorgTimeStandardsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  where: MeetWhereInput;
};


export type QueryorganizationArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  where: OrganizationUniqueInput;
};


export type QueryorganizationsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<LocationInput>;
  orderBy?: InputMaybe<OrganizationOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<OrganizationWhereInput>;
};


export type QueryorganizationsCountsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<OrganizationWhereInput>;
};


export type QuerypaymentArgs = {
  where: PaymentWhereInput;
};


export type QuerypaymentSessionArgs = {
  data: PaymentSessionInput;
};


export type QuerypaymentsArgs = {
  orderBy?: InputMaybe<DefaultOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DefaultWhereInput>;
};


export type QuerypayoutItemsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PayoutItemWhereInput>;
};


export type QuerypayoutItemsCountArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<PayoutItemWhereInput>;
};


export type QuerypayoutsArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FinancialReportInput>;
};


export type QuerypriceAdjustmentArgs = {
  where: UniqueInput;
};


export type QuerypriceAdjustmentsArgs = {
  orderBy?: InputMaybe<DefaultOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DefaultWhereInput>;
};


export type QueryprivateSerieArgs = {
  where: UniqueInput;
};


export type QueryprivateSerieAttendanceArgs = {
  where: UniqueInput;
};


export type QueryprivateSerieAttendancesArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<PrivateSerieAttendanceOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PrivateSerieAttendanceWhereInput>;
};


export type QueryprivateSerieAttendancesCountsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<PrivateSerieAttendanceWhereInput>;
};


export type QueryprivateSeriesArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<DefaultOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PrivateSerieWhereInput>;
};


export type QueryprivateSeriesCountsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<PrivateSerieWhereInput>;
};


export type QueryprogramArgs = {
  where: UniqueInput;
};


export type QueryprogramsArgs = {
  orderBy?: InputMaybe<ProgramOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProgramWhereInput>;
};


export type QueryrecipientsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where: RecipientWhereInput;
};


export type QueryrecurringChargeArgs = {
  where: UniqueInput;
};


export type QueryrecurringChargesArgs = {
  orderBy?: InputMaybe<DefaultOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RecurringChargeWhereInput>;
};


export type QueryrecurringCreditArgs = {
  where: UniqueInput;
};


export type QueryrecurringCreditsArgs = {
  orderBy?: InputMaybe<DefaultOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RecurringCreditWhereInput>;
};


export type QueryreferralArgs = {
  where: UniqueInput;
};


export type QueryreferralTemplateArgs = {
  where: UniqueInput;
};


export type QueryreferralTemplatesArgs = {
  orderBy?: InputMaybe<DefaultOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DefaultWhereInput>;
};


export type QueryrefundsArgs = {
  orderBy?: InputMaybe<DefaultOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DefaultWhereInput>;
};


export type QueryrevenueOverTimeArgs = {
  organization?: InputMaybe<Scalars['ID']['input']>;
};


export type QuerysalesStatsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};


export type QueryscheduledCommunicationsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledCommunicationWhereInput>;
};


export type QuerysearchOrganizationsArgs = {
  location?: InputMaybe<LocationInput>;
  where: SearchOrganizationWhereInput;
};


export type QueryserviceRunsArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ServiceRunWhereInput>;
};


export type QuerystaffEvaluationArgs = {
  where: UniqueInput;
};


export type QuerystaffEvaluationsArgs = {
  orderBy?: InputMaybe<DefaultOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DefaultWhereInput>;
};


export type QuerystripeAccountArgs = {
  organizationId: Scalars['ID']['input'];
  standard?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QuerystripeAccountsArgs = {
  organizationId: Scalars['ID']['input'];
  payouts?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QuerystripeCustomerArgs = {
  stripeCustomerId: Scalars['ID']['input'];
};


export type QuerystudentAttendanceNoteArgs = {
  where?: InputMaybe<UniqueInput>;
};


export type QuerystudentAttendanceNotesArgs = {
  orderBy?: InputMaybe<DefaultOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<StudentAttendanceNoteWhereInput>;
};


export type QuerystudentInfoRequestArgs = {
  where?: InputMaybe<UniqueInput>;
};


export type QuerystudentInfoRequestsArgs = {
  orderBy?: InputMaybe<StudentInfoRequestOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<StudentInfoRequestWhereInput>;
};


export type QuerytagArgs = {
  where: UniqueInput;
};


export type QuerytagsArgs = {
  orderBy?: InputMaybe<TagOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TagWhereInput>;
};


export type QuerytimeStandardArgs = {
  where: UniqueInput;
};


export type QuerytimeStandardsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  where: TimeStandardWhereInput;
};


export type QuerytokenArgs = {
  where: UniqueInput;
};


export type QuerytokensArgs = {
  orderBy?: InputMaybe<DefaultOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TokenWhereInput>;
};


export type QueryunreadItemsArgs = {
  departments?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  organization?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryupgradesArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};


export type QueryusaSwimmingArgs = {
  organizationId: Scalars['ID']['input'];
};


export type QueryusaSwimmingCountsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<StringFilter>;
};


export type QueryusaSwimmingMembersArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<DefaultOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MembershipWhereInput>;
};


export type QueryuserArgs = {
  where: UserUniqueInput;
};


export type QueryuserBillingSummaryArgs = {
  id: Scalars['ID']['input'];
};


export type QueryuserEmailArgs = {
  email: Scalars['String']['input'];
  organizationId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryuserReferralTemplateArgs = {
  where: UserReferralTemplateWhereInput;
};


export type QueryusersArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<UserOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  skipCount?: InputMaybe<Scalars['Boolean']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<UserWhereInput>;
};


export type QueryusersCountsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<UserWhereInput>;
};


export type QueryvolunteerEventArgs = {
  where: UniqueInput;
};


export type QueryvolunteerEventsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<DefaultOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where: VolunteerEventWhereInput;
};


export type QueryvolunteerEventsCountsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  where: VolunteerEventWhereInput;
};

export const QueryMode = {
  default: 'default',
  insensitive: 'insensitive'
} as const;

export type QueryMode = typeof QueryMode[keyof typeof QueryMode];
export const RateType = {
  Flat: 'Flat',
  Variable: 'Variable'
} as const;

export type RateType = typeof RateType[keyof typeof RateType];
export type Recipient = {
  email: Scalars['String']['output'];
  error: Scalars['String']['output'];
  id: Scalars['String']['output'];
  phone: Scalars['String']['output'];
  secondary: Scalars['Boolean']['output'];
  status: RecipientStatus;
  user: User;
};

export const RecipientStatus = {
  Delivered: 'Delivered',
  Failed: 'Failed',
  Opened: 'Opened',
  Pending: 'Pending',
  Unsubscribed: 'Unsubscribed'
} as const;

export type RecipientStatus = typeof RecipientStatus[keyof typeof RecipientStatus];
export const RecipientType = {
  Approved: 'Approved',
  Attended: 'Attended',
  Canceled: 'Canceled',
  CheckedIn: 'CheckedIn',
  Completed: 'Completed',
  Declined: 'Declined',
  DropIn: 'DropIn',
  Moved: 'Moved',
  Pending: 'Pending',
  Staff: 'Staff',
  Waitlist: 'Waitlist'
} as const;

export type RecipientType = typeof RecipientType[keyof typeof RecipientType];
export type RecipientTypeManyInput = {
  set: Array<RecipientType>;
};

export type RecipientWhereInput = {
  id?: InputMaybe<StringFilter>;
  messageId?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type RecurringCharge = {
  amount: Scalars['Int']['output'];
  billingCategory?: Maybe<BillingCategory>;
  billingCategoryId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Date']['output'];
  createdBy?: Maybe<User>;
  createdById?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  finalDate?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  invoiceItems: Array<InvoiceItem>;
  organization?: Maybe<Organization>;
  organizationId?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Date']['output'];
  user?: Maybe<User>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type RecurringChargeCreateInput = {
  amount?: InputMaybe<Scalars['Int']['input']>;
  billingCategory?: InputMaybe<ConnectUniqueInput>;
  createdBy?: InputMaybe<ConnectUniqueInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  finalDate?: InputMaybe<Scalars['Date']['input']>;
  organization?: InputMaybe<ConnectUniqueInput>;
  user?: InputMaybe<ConnectUniqueInput>;
};

export type RecurringChargeManyInput = {
  create?: InputMaybe<Array<InputMaybe<RecurringChargeCreateInput>>>;
};

export type RecurringChargeWhereInput = {
  AND?: InputMaybe<RecurringChargeWhereInput>;
  NOT?: InputMaybe<RecurringChargeWhereInput>;
  OR?: InputMaybe<Array<RecurringChargeWhereInput>>;
  finalDate?: InputMaybe<DateFilter>;
  user?: InputMaybe<UserWhereInput>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type RecurringCredit = {
  amount: Scalars['Int']['output'];
  billingCategory?: Maybe<BillingCategory>;
  billingCategoryId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Date']['output'];
  createdBy?: Maybe<User>;
  createdById?: Maybe<Scalars['String']['output']>;
  credit: Array<Credit>;
  description?: Maybe<Scalars['String']['output']>;
  finalDate?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  organization?: Maybe<Organization>;
  organizationId?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Date']['output'];
  user?: Maybe<User>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type RecurringCreditCreateInput = {
  amount?: InputMaybe<Scalars['Int']['input']>;
  billingCategory?: InputMaybe<ConnectUniqueInput>;
  createdBy?: InputMaybe<ConnectUniqueInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  finalDate?: InputMaybe<Scalars['Date']['input']>;
  organization?: InputMaybe<ConnectUniqueInput>;
  user?: InputMaybe<ConnectUniqueInput>;
};

export type RecurringCreditManyInput = {
  create?: InputMaybe<Array<InputMaybe<RecurringCreditCreateInput>>>;
};

export type RecurringCreditWhereInput = {
  AND?: InputMaybe<RecurringCreditWhereInput>;
  NOT?: InputMaybe<RecurringCreditWhereInput>;
  OR?: InputMaybe<Array<RecurringCreditWhereInput>>;
  finalDate?: InputMaybe<DateFilter>;
  user?: InputMaybe<UserWhereInput>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type Referral = {
  email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  milestoneProgress?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  payouts?: Maybe<Array<Maybe<Payout>>>;
  referralTemplate?: Maybe<ReferralTemplate>;
  user?: Maybe<User>;
};

export type ReferralCreateInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<MessageInput>;
  milestoneProgress?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  payouts?: InputMaybe<PayoutManyInput>;
};

export type ReferralTemplate = {
  createdAt: Scalars['Date']['output'];
  description: Scalars['String']['output'];
  firstReferralDeadline: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  learnMore: Scalars['String']['output'];
  milestones: Array<MilestoneTemplate>;
  payouts?: Maybe<Array<Payout>>;
  stopShowing: Scalars['Date']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
};

export type ReferralTemplateCreateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  firstReferralDeadline?: InputMaybe<Scalars['Date']['input']>;
  learnMore?: InputMaybe<Scalars['String']['input']>;
  milestones?: InputMaybe<MilestoneTemplateManyInput>;
  stopShowing?: InputMaybe<Scalars['Date']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ReferralTemplateWhereInput = {
  firstReferralDeadline?: InputMaybe<DateFilter>;
  stopShowing?: InputMaybe<DateFilter>;
};

export type ReferralsCountsPayload = {
  referrals: Scalars['Int']['output'];
  users: Scalars['Int']['output'];
};

export type Refund = {
  amount: Scalars['Int']['output'];
  createdAt: Scalars['Date']['output'];
  createdBy?: Maybe<User>;
  createdById?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  invoiceItem?: Maybe<InvoiceItem>;
  invoiceItemId?: Maybe<Scalars['String']['output']>;
  organization?: Maybe<Organization>;
  organizationId?: Maybe<Scalars['String']['output']>;
  stripeRefundId?: Maybe<Scalars['String']['output']>;
  type: PaymentType;
  updatedAt: Scalars['Date']['output'];
  user?: Maybe<User>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type RefundCreateInput = {
  amount: Scalars['Int']['input'];
  createdBy?: InputMaybe<ConnectUniqueInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  invoiceItem?: InputMaybe<ConnectUniqueInput>;
  organization?: InputMaybe<ConnectUniqueInput>;
  stripeRefundId?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<PaymentType>;
  user?: InputMaybe<ConnectUniqueInput>;
};

export type RefundManyInput = {
  update?: InputMaybe<Array<InputMaybe<RefundUpdateInput>>>;
};

export type RefundUpdateInput = {
  data?: InputMaybe<RefundCreateInput>;
  where?: InputMaybe<UniqueInput>;
};

export type RegistrationAdjustment = {
  createdAt: Scalars['Date']['output'];
  id: Scalars['String']['output'];
  membershipOffering: MembershipOffering;
  membershipOfferingId: Scalars['String']['output'];
  registrationClose?: Maybe<Scalars['Date']['output']>;
  registrationOpen: Scalars['Date']['output'];
  updatedAt: Scalars['Date']['output'];
};

export type RegistrationAdjustmentCreateInput = {
  default?: InputMaybe<Scalars['Boolean']['input']>;
  membershipOfferingId?: InputMaybe<Scalars['String']['input']>;
  registrationClose?: InputMaybe<Scalars['Date']['input']>;
  registrationOpen?: InputMaybe<Scalars['Date']['input']>;
};

export type RegistrationAdjustmentManyInput = {
  create?: InputMaybe<Array<InputMaybe<RegistrationAdjustmentCreateInput>>>;
  delete?: InputMaybe<Array<InputMaybe<UniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<RegistrationAdjustmentUpdateInput>>>;
};

export type RegistrationAdjustmentUpdateInput = {
  data?: InputMaybe<RegistrationAdjustmentCreateInput>;
  where?: InputMaybe<UniqueInput>;
};

export type RegistrationRestriction = {
  id?: Maybe<Scalars['ID']['output']>;
  trainingGroupsPerParticipant?: Maybe<Scalars['Int']['output']>;
  waitlistPerAccount?: Maybe<Scalars['Int']['output']>;
  waitlistPerParticipant?: Maybe<Scalars['Int']['output']>;
};

export type RegistrationRestrictionCreateInput = {
  trainingGroupsPerParticipant?: InputMaybe<Scalars['Int']['input']>;
  waitlistPerAccount?: InputMaybe<Scalars['Int']['input']>;
  waitlistPerParticipant?: InputMaybe<Scalars['Int']['input']>;
};

export type RegistrationRestrictionInput = {
  create?: InputMaybe<RegistrationRestrictionCreateInput>;
  update?: InputMaybe<RegistrationRestrictionUpdateInput>;
};

export type RegistrationRestrictionUpdateInput = {
  data?: InputMaybe<RegistrationRestrictionCreateInput>;
  where?: InputMaybe<UniqueInput>;
};

export const RenewalType = {
  Auto: 'Auto',
  Manual: 'Manual',
  None: 'None'
} as const;

export type RenewalType = typeof RenewalType[keyof typeof RenewalType];
export type ReportErrorInput = {
  error?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type ResetPasswordInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
  token?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type ResetPasswordPayload = {
  success: Scalars['Boolean']['output'];
};

export type RetryPaymentPayload = {
  paymentSuccessful?: Maybe<Scalars['Boolean']['output']>;
};

export const RosterSorting = {
  CheckIn: 'CheckIn',
  FirstLast: 'FirstLast',
  LastFirst: 'LastFirst'
} as const;

export type RosterSorting = typeof RosterSorting[keyof typeof RosterSorting];
export type ScheduledCommunication = {
  date: Scalars['Date']['output'];
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  removed?: Maybe<Scalars['Boolean']['output']>;
  user?: Maybe<User>;
};

export type ScheduledCommunicationCreateInput = {
  date?: InputMaybe<Scalars['Date']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  removed?: InputMaybe<Scalars['Boolean']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type ScheduledCommunicationManyInput = {
  create?: InputMaybe<Array<InputMaybe<ScheduledCommunicationCreateInput>>>;
  delete?: InputMaybe<Array<InputMaybe<UniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<ScheduledCommunicationUpdateInput>>>;
};

export type ScheduledCommunicationUpdateInput = {
  data?: InputMaybe<ScheduledCommunicationCreateInput>;
  where?: InputMaybe<UniqueInput>;
};

export type ScheduledCommunicationWhereInput = {
  communicationId?: InputMaybe<Scalars['String']['input']>;
  removed?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SearchOrganization = {
  address?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Date']['output'];
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  integrations: Array<IntegrationType>;
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  organization?: Maybe<Organization>;
  phone?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
  website?: Maybe<Scalars['String']['output']>;
};

export type SearchOrganizationWhereInput = {
  integrations?: InputMaybe<IntegrationsTypeFilter>;
};

export type SendEmailInput = {
  additionalEmails?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  files?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  filter?: InputMaybe<Scalars['String']['input']>;
  html?: InputMaybe<Scalars['String']['input']>;
  marketing?: InputMaybe<Scalars['Boolean']['input']>;
  move?: InputMaybe<Scalars['Json']['input']>;
  offeringId?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
  registrations?: InputMaybe<Scalars['Json']['input']>;
  replyTo?: InputMaybe<Scalars['String']['input']>;
  resend?: InputMaybe<Scalars['Boolean']['input']>;
  sendToOrganization?: InputMaybe<Scalars['Boolean']['input']>;
  smsText?: InputMaybe<Scalars['String']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
  template?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<EmailType>;
  users: Array<Scalars['ID']['input']>;
};

export type SendEmailPayload = {
  success: Scalars['Boolean']['output'];
};

export type SendSmsInput = {
  additionalPhones?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  body: Scalars['String']['input'];
  marketing?: InputMaybe<Scalars['Boolean']['input']>;
  organizationId: Scalars['String']['input'];
  users: Array<Scalars['ID']['input']>;
};

export type SendSmsPayload = {
  success: Scalars['Boolean']['output'];
};

export const SendTime = {
  AfterEnd: 'AfterEnd',
  AfterRegistration: 'AfterRegistration',
  AfterStart: 'AfterStart',
  BeforeEnd: 'BeforeEnd',
  BeforeInstance: 'BeforeInstance',
  BeforeStart: 'BeforeStart',
  CheckIn: 'CheckIn',
  Registration: 'Registration'
} as const;

export type SendTime = typeof SendTime[keyof typeof SendTime];
export const SendType = {
  Custom: 'Custom',
  Manual: 'Manual',
  Scheduled: 'Scheduled'
} as const;

export type SendType = typeof SendType[keyof typeof SendType];
export type ServiceRun = {
  createdAt: Scalars['Date']['output'];
  currentTask?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  invoicesCreated: Scalars['Int']['output'];
  paymentsProcessed: Scalars['Int']['output'];
  status?: Maybe<ServiceRunStatus>;
  type?: Maybe<ServiceRunType>;
  updatedAt: Scalars['Date']['output'];
};

export const ServiceRunStatus = {
  Complete: 'Complete',
  Error: 'Error',
  Running: 'Running'
} as const;

export type ServiceRunStatus = typeof ServiceRunStatus[keyof typeof ServiceRunStatus];
export const ServiceRunType = {
  Invoice: 'Invoice',
  Maintenance: 'Maintenance'
} as const;

export type ServiceRunType = typeof ServiceRunType[keyof typeof ServiceRunType];
export type ServiceRunUpdateInput = {
  status: ServiceRunStatus;
};

export type ServiceRunUpdatedPayload = {
  createdAt: Scalars['Date']['output'];
  currentTask?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  invoicesCreated: Scalars['Int']['output'];
  paymentsProcessed: Scalars['Int']['output'];
  status?: Maybe<ServiceRunStatus>;
  type?: Maybe<ServiceRunType>;
  updatedAt: Scalars['Date']['output'];
};

export type ServiceRunWhereInput = {
  type?: InputMaybe<ServiceRunType>;
};

export type Setting = {
  createdAt: Scalars['Date']['output'];
  department?: Maybe<Department>;
  departmentId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  type: SettingType;
  updatedAt: Scalars['Date']['output'];
  user?: Maybe<User>;
  userId?: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
};

export type SettingCreateInput = {
  department?: InputMaybe<ConnectUniqueInput>;
  type?: InputMaybe<SettingType>;
  value: Scalars['String']['input'];
};

export type SettingListRelationFilter = {
  every?: InputMaybe<SettingWhereInput>;
  none?: InputMaybe<SettingWhereInput>;
  some?: InputMaybe<SettingWhereInput>;
};

export type SettingManyInput = {
  create?: InputMaybe<Array<InputMaybe<SettingCreateInput>>>;
  delete?: InputMaybe<Array<InputMaybe<UniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<SettingUpdateInput>>>;
};

export const SettingType = {
  AdyenAlert: 'AdyenAlert',
  NotificationAccount: 'NotificationAccount',
  NotificationCustomerCancellation: 'NotificationCustomerCancellation',
  NotificationLessonTransferOrAssignment: 'NotificationLessonTransferOrAssignment',
  NotificationLessonsAdded: 'NotificationLessonsAdded',
  NotificationMarketing: 'NotificationMarketing',
  NotificationNewLesson: 'NotificationNewLesson',
  NotificationPrivateSeriePosted: 'NotificationPrivateSeriePosted',
  NotificationReminders: 'NotificationReminders',
  OrganizationUpdates: 'OrganizationUpdates',
  SecondaryContactEmail: 'SecondaryContactEmail',
  SecondaryContactPhone: 'SecondaryContactPhone'
} as const;

export type SettingType = typeof SettingType[keyof typeof SettingType];
export type SettingUpdateInput = {
  data?: InputMaybe<SettingCreateInput>;
  where?: InputMaybe<UniqueInput>;
};

export type SettingWhereInput = {
  AND?: InputMaybe<Array<SettingWhereInput>>;
  NOT?: InputMaybe<SettingWhereInput>;
  OR?: InputMaybe<Array<SettingWhereInput>>;
  type?: InputMaybe<SettingType>;
  value?: InputMaybe<StringFilter>;
};

export type SignupUserInput = {
  address1?: InputMaybe<Scalars['String']['input']>;
  address2?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  level?: InputMaybe<Level>;
  marketing?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  password: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type SocialMedia = {
  facebook?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  instagram?: Maybe<Scalars['String']['output']>;
  linkedIn?: Maybe<Scalars['String']['output']>;
  tikTok?: Maybe<Scalars['String']['output']>;
  twitter?: Maybe<Scalars['String']['output']>;
};

export type SocialMediaInput = {
  facebook?: InputMaybe<Scalars['String']['input']>;
  instagram?: InputMaybe<Scalars['String']['input']>;
  linkedIn?: InputMaybe<Scalars['String']['input']>;
  tikTok?: InputMaybe<Scalars['String']['input']>;
  twitter?: InputMaybe<Scalars['String']['input']>;
};

export type SocialMediaUpdateInput = {
  create?: InputMaybe<SocialMediaInput>;
  update?: InputMaybe<SocialMediaInput>;
};

export const SortOrder = {
  asc: 'asc',
  desc: 'desc'
} as const;

export type SortOrder = typeof SortOrder[keyof typeof SortOrder];
export type StaffEvaluation = {
  admin?: Maybe<User>;
  adminId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Date']['output'];
  date: Scalars['Date']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  updatedAt: Scalars['Date']['output'];
  user?: Maybe<User>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type StaffEvaluationCreateInput = {
  admin?: InputMaybe<ConnectUniqueInput>;
  date: Scalars['Date']['input'];
  description: Scalars['String']['input'];
  user?: InputMaybe<ConnectUniqueInput>;
};

export type StaffEvaluationWhereInput = {
  AND?: InputMaybe<StaffEvaluationWhereInput>;
  NOT?: InputMaybe<StaffEvaluationWhereInput>;
  OR?: InputMaybe<Array<StaffEvaluationWhereInput>>;
  adminId?: InputMaybe<StringFilter>;
  userId?: InputMaybe<StringFilter>;
};

export type StringFilter = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  mode?: InputMaybe<QueryMode>;
  not?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type StringManyInput = {
  set: Array<Scalars['String']['input']>;
};

export type StripeAccountPayload = {
  balance?: Maybe<StripeBalance>;
  bankAccount?: Maybe<StripeBankAccount>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  legalEntity?: Maybe<LegalEntity>;
  link: Scalars['String']['output'];
  pendingConnection?: Maybe<Scalars['Boolean']['output']>;
  refundsAuthorized?: Maybe<Scalars['Boolean']['output']>;
  refundsAuthorizedAt?: Maybe<Scalars['Date']['output']>;
  refundsAuthorizedBy?: Maybe<User>;
  stripeAccountId?: Maybe<Scalars['String']['output']>;
  testDebit?: Maybe<Scalars['Boolean']['output']>;
  testDebitAt?: Maybe<Scalars['Date']['output']>;
  testDebitWhitelistedAt?: Maybe<Scalars['Date']['output']>;
  testDebitWhitelistedBy?: Maybe<User>;
  verified: Scalars['Boolean']['output'];
};

export type StripeAccountWhereInput = {
  departmentId?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
  stripeAccountId?: InputMaybe<Scalars['String']['input']>;
};

export type StripeBalance = {
  available: Scalars['Int']['output'];
  instantAvailable: Scalars['Int']['output'];
  refundCushion: Scalars['Int']['output'];
};

export type StripeBankAccount = {
  bankName?: Maybe<Scalars['String']['output']>;
  last4?: Maybe<Scalars['String']['output']>;
  routingNumber?: Maybe<Scalars['String']['output']>;
};

export type StripeExpressAccount = {
  default?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  stripeExpressAccountId?: Maybe<Scalars['String']['output']>;
};

export type StripeExpressAccountCreateInput = {
  default?: InputMaybe<Scalars['Boolean']['input']>;
};

export type StripeExpressAccountManyInput = {
  update?: InputMaybe<Array<StripeExpressAccountUpdateInput>>;
};

export type StripeExpressAccountUpdateInput = {
  data?: InputMaybe<StripeExpressAccountCreateInput>;
  where?: InputMaybe<UniqueInput>;
};

export const StripeType = {
  Adyen: 'Adyen',
  Express: 'Express',
  Standard: 'Standard'
} as const;

export type StripeType = typeof StripeType[keyof typeof StripeType];
export type StripeWebhook = {
  createdAt: Scalars['Date']['output'];
  data?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  updatedAt: Scalars['Date']['output'];
};

export type StripeWebhookCreateInput = {
  data?: InputMaybe<Scalars['String']['input']>;
};

export type StudentAttendanceNote = {
  attendance?: Maybe<Attendance>;
  attendanceId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  note: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
  user: User;
  userId?: Maybe<Scalars['String']['output']>;
};

export type StudentAttendanceNoteCreateInput = {
  attendance?: InputMaybe<ConnectUniqueInput>;
  note: Scalars['String']['input'];
  user?: InputMaybe<ConnectUniqueInput>;
};

export type StudentAttendanceNoteManyInput = {
  create?: InputMaybe<Array<InputMaybe<StudentAttendanceNoteCreateInput>>>;
  delete?: InputMaybe<Array<InputMaybe<UniqueInput>>>;
};

export type StudentAttendanceNoteWhereInput = {
  AND?: InputMaybe<StudentAttendanceNoteWhereInput>;
  NOT?: InputMaybe<StudentAttendanceNoteWhereInput>;
  OR?: InputMaybe<Array<StudentAttendanceNoteWhereInput>>;
  attendanceId?: InputMaybe<Scalars['ID']['input']>;
  user?: InputMaybe<UserWhereInput>;
  userId?: InputMaybe<StringFilter>;
};

export type StudentInfoRequest = {
  answers: Array<Scalars['String']['output']>;
  availableForAllOfferings?: Maybe<Scalars['Boolean']['output']>;
  createdAt: Scalars['Date']['output'];
  department?: Maybe<Department>;
  departmentId?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  enabledByDefault?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  noQuestion?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  organization?: Maybe<Organization>;
  organizationId?: Maybe<Scalars['String']['output']>;
  required?: Maybe<Scalars['Boolean']['output']>;
  singleResponse?: Maybe<Scalars['Boolean']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  studentInfoRequestResponses: Array<StudentInfoRequestResponse>;
  type?: Maybe<InfoRequestType>;
  updatedAt: Scalars['Date']['output'];
  yesQuestion?: Maybe<Scalars['String']['output']>;
};


export type StudentInfoRequeststudentInfoRequestResponsesArgs = {
  where?: InputMaybe<StudentInfoRequestResponseWhereInput>;
};

export type StudentInfoRequestCreateInput = {
  answers?: InputMaybe<StringManyInput>;
  availableForAllOfferings?: InputMaybe<Scalars['Boolean']['input']>;
  classes?: InputMaybe<ConnectManyInput>;
  department?: InputMaybe<ConnectUniqueInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  enabledByDefault?: InputMaybe<Scalars['Boolean']['input']>;
  membershipOfferings?: InputMaybe<ConnectManyInput>;
  noQuestion?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<ConnectUniqueInput>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  singleResponse?: InputMaybe<Scalars['Boolean']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<InfoRequestType>;
  yesQuestion?: InputMaybe<Scalars['String']['input']>;
};

export type StudentInfoRequestManyInput = {
  connect?: InputMaybe<Array<InputMaybe<UniqueInput>>>;
  create?: InputMaybe<Array<InputMaybe<StudentInfoRequestCreateInput>>>;
  delete?: InputMaybe<Array<InputMaybe<UniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<UniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<StudentInfoRequestUpdateInput>>>;
};

export type StudentInfoRequestOrderByInput = {
  order?: InputMaybe<SortOrder>;
};

export type StudentInfoRequestResponse = {
  additionalResponse?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Date']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  privateSerie?: Maybe<PrivateSerie>;
  privateSerieId?: Maybe<Scalars['String']['output']>;
  registration?: Maybe<GroupRegistration>;
  registrationId?: Maybe<Scalars['String']['output']>;
  student?: Maybe<User>;
  studentId?: Maybe<Scalars['String']['output']>;
  studentInfoRequest?: Maybe<StudentInfoRequest>;
  studentInfoRequestId?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Date']['output'];
};

export type StudentInfoRequestResponseCreateInput = {
  additionalResponse?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  student: ConnectUniqueInput;
  studentInfoRequest?: InputMaybe<ConnectUniqueInput>;
};

export type StudentInfoRequestResponseManyInput = {
  create?: InputMaybe<Array<InputMaybe<StudentInfoRequestResponseCreateInput>>>;
  every?: InputMaybe<StudentInfoRequestResponseWhereInput>;
  none?: InputMaybe<StudentInfoRequestResponseWhereInput>;
  some?: InputMaybe<StudentInfoRequestResponseWhereInput>;
  update?: InputMaybe<Array<InputMaybe<StudentInfoRequestResponseUpdateInput>>>;
};

export type StudentInfoRequestResponseUpdateInput = {
  data?: InputMaybe<StudentInfoRequestResponseCreateInput>;
  where?: InputMaybe<UniqueInput>;
};

export type StudentInfoRequestResponseWhereInput = {
  registrationId?: InputMaybe<StringFilter>;
  studentInfoRequest?: InputMaybe<StudentInfoRequestWhereInput>;
};

export type StudentInfoRequestUpdateInput = {
  data?: InputMaybe<StudentInfoRequestCreateInput>;
  where?: InputMaybe<UniqueInput>;
};

export type StudentInfoRequestWhereInput = {
  AND?: InputMaybe<StudentInfoRequestWhereInput>;
  NOT?: InputMaybe<StudentInfoRequestWhereInput>;
  OR?: InputMaybe<Array<StudentInfoRequestWhereInput>>;
  availableForAllOfferings?: InputMaybe<Scalars['Boolean']['input']>;
  classes?: InputMaybe<ClassListRelationFilter>;
  departmentId?: InputMaybe<StringFilter>;
  membershipOfferings?: InputMaybe<MembershipOfferingListRelationFilter>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  studentInfoRequestResponses?: InputMaybe<StudentInfoRequestResponseManyInput>;
};

export type Subscription = {
  attendanceUpdated?: Maybe<AttendanceUpdatedPayload>;
  invoiceCreated?: Maybe<Scalars['Boolean']['output']>;
  meetUpdated?: Maybe<MeetUpdatedPayload>;
  serviceRunUpdated: ServiceRunUpdatedPayload;
  unreadItemsUpdated?: Maybe<UnreadItemsUpdatedPayload>;
  versionUpdated?: Maybe<Scalars['Boolean']['output']>;
};


export type SubscriptionattendanceUpdatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  organization?: InputMaybe<Scalars['ID']['input']>;
};


export type SubscriptioninvoiceCreatedArgs = {
  organization: Scalars['ID']['input'];
};


export type SubscriptionmeetUpdatedArgs = {
  meet: Scalars['ID']['input'];
  organization: Scalars['ID']['input'];
};


export type SubscriptionunreadItemsUpdatedArgs = {
  departments?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  organization?: InputMaybe<Scalars['ID']['input']>;
};

export type SyncUsaSwimmingPayload = {
  offeringId: Scalars['String']['output'];
};

export type Tag = {
  classes?: Maybe<Array<Maybe<Class>>>;
  createdAt: Scalars['Date']['output'];
  department?: Maybe<Department>;
  departmentId?: Maybe<Scalars['String']['output']>;
  hideInFilters: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  need?: Maybe<Scalars['Boolean']['output']>;
  offerings?: Maybe<Array<Maybe<Offering>>>;
  order: Scalars['Int']['output'];
  organization?: Maybe<Scalars['Boolean']['output']>;
  organizationNeeds?: Maybe<Array<Maybe<Organization>>>;
  organizationTags?: Maybe<Array<Maybe<Organization>>>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
};

export type TagCreateInput = {
  classes?: InputMaybe<ConnectManyInput>;
  department?: InputMaybe<ConnectUniqueInput>;
  hideInFilters?: InputMaybe<Scalars['Boolean']['input']>;
  need?: InputMaybe<Scalars['Boolean']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type TagManyInput = {
  connect?: InputMaybe<Array<InputMaybe<UniqueInput>>>;
  create?: InputMaybe<Array<InputMaybe<TagCreateInput>>>;
  set?: InputMaybe<Array<InputMaybe<UniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<TagUpdateInput>>>;
};

export type TagOrderByInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  order?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type TagUpdateInput = {
  data?: InputMaybe<TagCreateInput>;
  where?: InputMaybe<UniqueInput>;
};

export type TagWhereInput = {
  AND?: InputMaybe<TagWhereInput>;
  NOT?: InputMaybe<TagWhereInput>;
  OR?: InputMaybe<Array<TagWhereInput>>;
  createdAt?: InputMaybe<DateFilter>;
  department?: InputMaybe<UniqueInput>;
  departmentId?: InputMaybe<StringFilter>;
  hideInFilters?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<StringFilter>;
  need?: InputMaybe<Scalars['Boolean']['input']>;
  order?: InputMaybe<IntFilter>;
  organization?: InputMaybe<Scalars['Boolean']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateFilter>;
};

export type TerminalInterestInput = {
  comments?: InputMaybe<Scalars['String']['input']>;
  notInterested?: InputMaybe<Scalars['Boolean']['input']>;
  notInterestedOther?: InputMaybe<Scalars['String']['input']>;
  notInterestedReason?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  numberOfTerminals?: InputMaybe<Scalars['String']['input']>;
  numberOfTerminalsOther?: InputMaybe<Scalars['String']['input']>;
  usage?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  usageOther?: InputMaybe<Scalars['String']['input']>;
  when?: InputMaybe<Scalars['String']['input']>;
  whenEventCapacity?: InputMaybe<Scalars['String']['input']>;
  whenEventDate?: InputMaybe<Scalars['Date']['input']>;
  whenEventName?: InputMaybe<Scalars['String']['input']>;
};

export type TerminalPaymentInput = {
  amount: Scalars['Int']['input'];
  description: Scalars['String']['input'];
  terminalId: Scalars['String']['input'];
};

export type Terminology = {
  administrator: Scalars['String']['output'];
  customer: Scalars['String']['output'];
  evaluation: Scalars['String']['output'];
  private: Scalars['String']['output'];
  staff: Scalars['String']['output'];
};

export type TerminologyInput = {
  administrator?: InputMaybe<Scalars['String']['input']>;
  customer?: InputMaybe<Scalars['String']['input']>;
  evaluation?: InputMaybe<Scalars['String']['input']>;
  private?: InputMaybe<Scalars['String']['input']>;
  staff?: InputMaybe<Scalars['String']['input']>;
};

export type TerminologyUpdateInput = {
  create?: InputMaybe<TerminologyInput>;
  update?: InputMaybe<TerminologyInput>;
};

export type TimeStandard = {
  allowSharing: Scalars['Boolean']['output'];
  createdAt?: Maybe<Scalars['Date']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  designators?: Maybe<Array<Maybe<Designator>>>;
  designatorsList?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  endDate?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  identifier?: Maybe<Scalars['String']['output']>;
  limitLSC?: Maybe<Scalars['String']['output']>;
  organization: Organization;
  organizations: Array<OrgTimeStandard>;
  startDate?: Maybe<Scalars['Date']['output']>;
  status: TimeStandardStatus;
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['Date']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type TimeStandardCreateInput = {
  allowSharing?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  designators?: InputMaybe<DesignatorManyInput>;
  designatorsList?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  identifier?: InputMaybe<Scalars['String']['input']>;
  limitLSC?: InputMaybe<Scalars['String']['input']>;
  organization?: InputMaybe<ConnectUniqueInput>;
  organizations?: InputMaybe<OrgTimeStandardManyInput>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
  status?: InputMaybe<TimeStandardStatus>;
  title?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export const TimeStandardStatus = {
  Active: 'Active',
  Inactive: 'Inactive',
  Pending: 'Pending'
} as const;

export type TimeStandardStatus = typeof TimeStandardStatus[keyof typeof TimeStandardStatus];
export type TimeStandardWhereInput = {
  allowSharing?: InputMaybe<Scalars['Boolean']['input']>;
  limitLSC?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<StringFilter>;
  status?: InputMaybe<TimeStandardStatus>;
};

export const TimeType = {
  Day: 'Day',
  Hour: 'Hour',
  Minute: 'Minute'
} as const;

export type TimeType = typeof TimeType[keyof typeof TimeType];
export type Token = {
  amount?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['Date']['output'];
  credit?: Maybe<Scalars['Boolean']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  issuedBy?: Maybe<User>;
  issuedById?: Maybe<Scalars['String']['output']>;
  organization?: Maybe<Organization>;
  organizationId?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Date']['output'];
  user?: Maybe<User>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type TokenCreateInput = {
  amount?: InputMaybe<Scalars['Int']['input']>;
  credit?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  issuedBy?: InputMaybe<ConnectUniqueInput>;
  organization?: InputMaybe<ConnectUniqueInput>;
  user?: InputMaybe<ConnectUniqueInput>;
};

export type TokenManyInput = {
  create?: InputMaybe<Array<InputMaybe<TokenCreateInput>>>;
};

export type TokenWhereInput = {
  AND?: InputMaybe<TokenWhereInput>;
  NOT?: InputMaybe<TokenWhereInput>;
  OR?: InputMaybe<Array<TokenWhereInput>>;
  issuedById?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type Transfer = {
  amount: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
};

export type USASwimmingCountsPayload = {
  enrolled: Scalars['Int']['output'];
  errors: Array<Scalars['String']['output']>;
  membershipTypes?: Maybe<Scalars['Json']['output']>;
  missing: Scalars['Int']['output'];
  none: Scalars['Int']['output'];
  pending: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  users: Array<User>;
  waitlist: Scalars['Int']['output'];
};

export type UniqueInput = {
  id?: InputMaybe<Scalars['String']['input']>;
};

export type UnreadItemsInput = {
  departments?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  organization?: InputMaybe<Scalars['ID']['input']>;
};

export type UnreadItemsPayload = {
  allClasses?: Maybe<Scalars['Int']['output']>;
  allMembershipOfferings?: Maybe<Scalars['Int']['output']>;
  allOfferings?: Maybe<Scalars['Int']['output']>;
  customerServiceItems?: Maybe<Scalars['Int']['output']>;
  enrolledParticipants?: Maybe<Scalars['Int']['output']>;
  inProgressClasses?: Maybe<Scalars['Int']['output']>;
  inProgressMeets?: Maybe<Scalars['Int']['output']>;
  inProgressMembershipOfferings?: Maybe<Scalars['Int']['output']>;
  inProgressPrivateSeries?: Maybe<Scalars['Int']['output']>;
  now?: Maybe<Scalars['Date']['output']>;
  passOfferings?: Maybe<Scalars['Int']['output']>;
  pendingGroupRegistrations?: Maybe<Scalars['Int']['output']>;
  pendingInvoiceItems?: Maybe<Scalars['Int']['output']>;
  pendingMemberships?: Maybe<Scalars['Int']['output']>;
  pendingPrivateSeries?: Maybe<Scalars['Int']['output']>;
  postedPrivateSeries?: Maybe<Scalars['Int']['output']>;
  upcomingClasses?: Maybe<Scalars['Int']['output']>;
  upcomingMeets?: Maybe<Scalars['Int']['output']>;
  waitlistAvailableClasses?: Maybe<Scalars['Int']['output']>;
};

export type UnreadItemsUpdatedPayload = {
  allClasses?: Maybe<Scalars['Int']['output']>;
  allMembershipOfferings?: Maybe<Scalars['Int']['output']>;
  allOfferings?: Maybe<Scalars['Int']['output']>;
  customerServiceItems?: Maybe<Scalars['Int']['output']>;
  enrolledParticipants?: Maybe<Scalars['Int']['output']>;
  inProgressClasses?: Maybe<Scalars['Int']['output']>;
  inProgressMeets?: Maybe<Scalars['Int']['output']>;
  inProgressMembershipOfferings?: Maybe<Scalars['Int']['output']>;
  inProgressPrivateSeries?: Maybe<Scalars['Int']['output']>;
  now?: Maybe<Scalars['Date']['output']>;
  passOfferings?: Maybe<Scalars['Int']['output']>;
  pendingGroupRegistrations?: Maybe<Scalars['Int']['output']>;
  pendingInvoiceItems?: Maybe<Scalars['Int']['output']>;
  pendingMemberships?: Maybe<Scalars['Int']['output']>;
  pendingPrivateSeries?: Maybe<Scalars['Int']['output']>;
  postedPrivateSeries?: Maybe<Scalars['Int']['output']>;
  upcomingClasses?: Maybe<Scalars['Int']['output']>;
  upcomingMeets?: Maybe<Scalars['Int']['output']>;
  waitlistAvailableClasses?: Maybe<Scalars['Int']['output']>;
};

export type UpdateManyGroupRegistrationsPayload = {
  count?: Maybe<Scalars['Int']['output']>;
};

export type UpdateManyMembershipsPayload = {
  count?: Maybe<Scalars['Int']['output']>;
};

export type UpdatePasswordInput = {
  newPassword: Scalars['String']['input'];
  organizationId?: InputMaybe<Scalars['String']['input']>;
  resetPasswordToken: Scalars['String']['input'];
};

export type Upgrade = {
  alert?: Maybe<Scalars['Boolean']['output']>;
  frequency?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  organization?: Maybe<Organization>;
  price?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  type?: Maybe<UpgradeType>;
  url?: Maybe<Scalars['String']['output']>;
  viewable?: Maybe<Scalars['Boolean']['output']>;
};

export type UpgradeNativeApp = {
  bundleDiscount?: Maybe<Scalars['Float']['output']>;
  createdAt: Scalars['Date']['output'];
  details?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  offerBundle?: Maybe<Scalars['Boolean']['output']>;
  offerTypes: Array<NativeAppType>;
  organization: Organization;
  organizationId: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
};

export type UpgradeNativeAppInput = {
  bundleDiscount?: InputMaybe<Scalars['Float']['input']>;
  details?: InputMaybe<Scalars['String']['input']>;
  offerBundle?: InputMaybe<Scalars['Boolean']['input']>;
  offerTypes?: InputMaybe<Array<NativeAppType>>;
};

export type UpgradeNativeAppUpdateInput = {
  create?: InputMaybe<UpgradeNativeAppInput>;
  update?: InputMaybe<UpgradeNativeAppInput>;
};

export type UpgradeTerminal = {
  dismissedAdminBanner?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  dismissedMenuBanner?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  showAdminBanner?: Maybe<Scalars['Boolean']['output']>;
  showMenuBanner?: Maybe<Scalars['Boolean']['output']>;
};

export type UpgradeTerminalInput = {
  dismissedAdminBanner?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dismissedMenuBanner?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  showAdminBanner?: InputMaybe<Scalars['Boolean']['input']>;
  showMenuBanner?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpgradeTerminalUpdateInput = {
  create?: InputMaybe<UpgradeTerminalInput>;
  update?: InputMaybe<UpgradeTerminalInput>;
};

export const UpgradeType = {
  ACH: 'ACH',
  AndroidApp: 'AndroidApp',
  CCProcessing: 'CCProcessing',
  CaptynPlan: 'CaptynPlan',
  SettlementDelay: 'SettlementDelay',
  Website: 'Website',
  iOSApp: 'iOSApp'
} as const;

export type UpgradeType = typeof UpgradeType[keyof typeof UpgradeType];
export type UpgradeWebsite = {
  addToInvoice?: Maybe<Scalars['Boolean']['output']>;
  amount?: Maybe<Scalars['Int']['output']>;
  billingMethod?: Maybe<BillingMethod>;
  createdAt: Scalars['Date']['output'];
  details?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  organization: Organization;
  organizationId: Scalars['String']['output'];
  setupFee?: Maybe<Scalars['Int']['output']>;
  status: UpgradeWebsiteStatus;
  updatedAt: Scalars['Date']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type UpgradeWebsiteInput = {
  addToInvoice?: InputMaybe<Scalars['Boolean']['input']>;
  amount?: InputMaybe<Scalars['Int']['input']>;
  billingMethod?: InputMaybe<BillingMethod>;
  details?: InputMaybe<Scalars['String']['input']>;
  setupFee?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<UpgradeWebsiteStatus>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export const UpgradeWebsiteStatus = {
  Available: 'Available',
  Launched: 'Launched',
  Setup: 'Setup'
} as const;

export type UpgradeWebsiteStatus = typeof UpgradeWebsiteStatus[keyof typeof UpgradeWebsiteStatus];
export type UpgradeWebsiteUpdateInput = {
  create?: InputMaybe<UpgradeWebsiteInput>;
  update?: InputMaybe<UpgradeWebsiteInput>;
};

export type UpsertStripeCustomerInput = {
  adyenToken?: InputMaybe<AdyenToken>;
  organizationId: Scalars['ID']['input'];
  stripeToken?: InputMaybe<Scalars['Json']['input']>;
  userId: Scalars['ID']['input'];
};

export type UpsertStripeCustomerPayload = {
  adyenToken?: Maybe<Scalars['Json']['output']>;
  id: Scalars['ID']['output'];
  stripeCustomerId?: Maybe<Scalars['String']['output']>;
  stripeToken?: Maybe<Scalars['Json']['output']>;
};

export type User = {
  accountOwner: User;
  active?: Maybe<Scalars['Boolean']['output']>;
  address1?: Maybe<Scalars['String']['output']>;
  address2?: Maybe<Scalars['String']['output']>;
  adyenToken: Scalars['Json']['output'];
  allowAssignment?: Maybe<Scalars['Boolean']['output']>;
  allowMarketing?: Maybe<Scalars['Boolean']['output']>;
  attendancesAsAttended?: Maybe<Array<Attendance>>;
  avatar: File;
  balance: Scalars['Int']['output'];
  bio?: Maybe<Scalars['String']['output']>;
  birthDate: Scalars['Date']['output'];
  cart?: Maybe<Scalars['Json']['output']>;
  charges?: Maybe<Array<Charge>>;
  city?: Maybe<Scalars['String']['output']>;
  classes?: Maybe<Array<Class>>;
  createdAt: Scalars['Date']['output'];
  credits: Array<Credit>;
  customNotes?: Maybe<Array<Scalars['String']['output']>>;
  customerRequests?: Maybe<Array<CustomerRequest>>;
  customerServiceItems?: Maybe<Array<CustomerServiceItem>>;
  departments?: Maybe<Array<Department>>;
  email: Scalars['String']['output'];
  emergencyContactName?: Maybe<Scalars['String']['output']>;
  emergencyContactPhone?: Maybe<Scalars['String']['output']>;
  evaluations?: Maybe<Array<Evaluation>>;
  events?: Maybe<Array<Event>>;
  eventsUser?: Maybe<Array<Event>>;
  firstName: Scalars['String']['output'];
  fullName: Scalars['String']['output'];
  futureInvoiceBalance: Scalars['Int']['output'];
  gender: Gender;
  groupRegistrations: Array<GroupRegistration>;
  healthConcerns?: Maybe<Scalars['String']['output']>;
  healthQuestionResponses: Array<HealthQuestionResponse>;
  hideInFilters?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  invoices?: Maybe<Array<Invoice>>;
  jobCreditBalance: Scalars['Float']['output'];
  jobCredits: Array<JobCredit>;
  lastAccess?: Maybe<Scalars['Date']['output']>;
  lastName: Scalars['String']['output'];
  level: Level;
  linkedAccounts: Array<User>;
  memberSince?: Maybe<Scalars['Date']['output']>;
  memberships?: Maybe<Array<Maybe<Membership>>>;
  membershipsRoster?: Maybe<Array<Maybe<Membership>>>;
  note: Scalars['String']['output'];
  onboards?: Maybe<Array<Maybe<Onboard>>>;
  organization?: Maybe<Organization>;
  organizationOwner?: Maybe<Organization>;
  organizations?: Maybe<Array<Organization>>;
  payments?: Maybe<Array<Payment>>;
  permissions?: Maybe<Array<PermissionType>>;
  phone: Scalars['String']['output'];
  primaryAccount?: Maybe<User>;
  privateSerieAccountOwner?: Maybe<Array<PrivateSerie>>;
  privateSerieInstructor?: Maybe<Array<PrivateSerie>>;
  privateSeries?: Maybe<Array<PrivateSerie>>;
  profile?: Maybe<User>;
  profiles?: Maybe<Array<User>>;
  pushNotificationToken?: Maybe<Scalars['String']['output']>;
  recurringCharges?: Maybe<Array<RecurringCharge>>;
  recurringCredits?: Maybe<Array<RecurringCredit>>;
  referralTemplate?: Maybe<UserReferralTemplate>;
  referrals?: Maybe<Array<Referral>>;
  refunds?: Maybe<Array<Refund>>;
  savedFilters?: Maybe<Scalars['Json']['output']>;
  secondaryId?: Maybe<Scalars['String']['output']>;
  settings?: Maybe<Array<Setting>>;
  staffEvaluations?: Maybe<Array<StaffEvaluation>>;
  state?: Maybe<Scalars['String']['output']>;
  stripeCustomerId: Scalars['String']['output'];
  stripeToken: Scalars['Json']['output'];
  studentGroupRegistrations?: Maybe<Array<GroupRegistration>>;
  students?: Maybe<Array<User>>;
  tokens?: Maybe<Array<Token>>;
  updatedAt: Scalars['Date']['output'];
  usaSwimmingMember?: Maybe<Scalars['Json']['output']>;
  usaSwimmingMemberId?: Maybe<Scalars['String']['output']>;
  userAgreements?: Maybe<Array<UserAgreement>>;
  waitlists?: Maybe<Array<Class>>;
  zip?: Maybe<Scalars['String']['output']>;
};


export type UsercustomerServiceItemsArgs = {
  where?: InputMaybe<CustomerServiceItemWhereInput>;
};


export type UserdepartmentsArgs = {
  orderBy?: InputMaybe<DepartmentOrderByInput>;
};


export type UsereventsArgs = {
  where?: InputMaybe<EventWhereInput>;
};


export type UsereventsUserArgs = {
  where?: InputMaybe<EventWhereInput>;
};


export type UsergroupRegistrationsArgs = {
  where?: InputMaybe<GroupRegistrationWhereInput>;
};


export type UserinvoicesArgs = {
  where?: InputMaybe<InvoiceWhereInput>;
};


export type UsermembershipsArgs = {
  where?: InputMaybe<MembershipWhereInput>;
};


export type UsermembershipsRosterArgs = {
  where?: InputMaybe<MembershipWhereInput>;
};


export type UsersettingsArgs = {
  where?: InputMaybe<SettingWhereInput>;
};


export type UserstudentGroupRegistrationsArgs = {
  where?: InputMaybe<GroupRegistrationWhereInput>;
};

export type UserAgreement = {
  agreement?: Maybe<Agreement>;
  agreementId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  updatedAt: Scalars['Date']['output'];
  user?: Maybe<User>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type UserAgreementCreateInput = {
  agreement?: InputMaybe<ConnectUniqueInput>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type UserAgreementManyInput = {
  create?: InputMaybe<Array<InputMaybe<UserAgreementCreateInput>>>;
  update?: InputMaybe<Array<InputMaybe<UserAgreementUpdateInput>>>;
};

export type UserAgreementUpdateInput = {
  data: UserAgreementCreateInput;
  where: UniqueInput;
};

export type UserBillingSummaryPayload = {
  balance?: Maybe<Scalars['Int']['output']>;
  futureInvoice?: Maybe<Scalars['Json']['output']>;
  invoicedThisMonth?: Maybe<Scalars['Boolean']['output']>;
  totalBillable?: Maybe<Scalars['Int']['output']>;
  totalCoupons?: Maybe<Scalars['Int']['output']>;
  totalCredits?: Maybe<Scalars['Int']['output']>;
  totalDiscounts?: Maybe<Scalars['Int']['output']>;
  totalPaid?: Maybe<Scalars['Int']['output']>;
  totalRefunded?: Maybe<Scalars['Int']['output']>;
};

export type UserCreateInput = {
  accountOwner?: InputMaybe<ConnectUniqueInput>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  address1?: InputMaybe<Scalars['String']['input']>;
  address2?: InputMaybe<Scalars['String']['input']>;
  adyenToken?: InputMaybe<Scalars['Json']['input']>;
  allowAssignment?: InputMaybe<Scalars['Boolean']['input']>;
  allowMarketing?: InputMaybe<Scalars['Boolean']['input']>;
  avatar?: InputMaybe<ConnectUniqueInput>;
  bio?: InputMaybe<Scalars['String']['input']>;
  birthDate?: InputMaybe<Scalars['Date']['input']>;
  cart?: InputMaybe<Scalars['Json']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  credits?: InputMaybe<CreditManyInput>;
  customNotes?: InputMaybe<StringManyInput>;
  departments?: InputMaybe<DepartmentManyInput>;
  email?: InputMaybe<Scalars['String']['input']>;
  emergencyContactName?: InputMaybe<Scalars['String']['input']>;
  emergencyContactPhone?: InputMaybe<Scalars['String']['input']>;
  events?: InputMaybe<EventManyInput>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Gender>;
  healthConcerns?: InputMaybe<Scalars['String']['input']>;
  healthQuestionResponses?: InputMaybe<HealthQuestionResponseManyInput>;
  hideInFilters?: InputMaybe<Scalars['Boolean']['input']>;
  jobCreditBalance?: InputMaybe<Scalars['Float']['input']>;
  jobCredits?: InputMaybe<JobCreditManyInput>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  level?: InputMaybe<Level>;
  memberSince?: InputMaybe<Scalars['Date']['input']>;
  membershipsRoster?: InputMaybe<MembershipManyInput>;
  note?: InputMaybe<Scalars['String']['input']>;
  onboards?: InputMaybe<OnboardManyInput>;
  organization?: InputMaybe<ConnectUniqueInput>;
  password?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<PermissionTypeManyInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  primaryAccount?: InputMaybe<ConnectUniqueInput>;
  privateSeries?: InputMaybe<PrivateSerieManyInput>;
  profile?: InputMaybe<UserNestedInput>;
  profiles?: InputMaybe<UserManyInput>;
  pushNotificationToken?: InputMaybe<Scalars['String']['input']>;
  recurringCharges?: InputMaybe<RecurringChargeManyInput>;
  recurringCredits?: InputMaybe<RecurringCreditManyInput>;
  referralTemplate?: InputMaybe<UserReferralInput>;
  savedFilters?: InputMaybe<Scalars['Json']['input']>;
  secondaryId?: InputMaybe<Scalars['String']['input']>;
  settings?: InputMaybe<SettingManyInput>;
  state?: InputMaybe<Scalars['String']['input']>;
  stripeCustomerId?: InputMaybe<Scalars['String']['input']>;
  stripeToken?: InputMaybe<Scalars['Json']['input']>;
  studentGroupRegistrations?: InputMaybe<GroupRegistrationManyInput>;
  students?: InputMaybe<UserManyInput>;
  tokens?: InputMaybe<TokenManyInput>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  usaSwimmingMember?: InputMaybe<Scalars['Json']['input']>;
  usaSwimmingMemberId?: InputMaybe<Scalars['String']['input']>;
  userAgreements?: InputMaybe<UserAgreementManyInput>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type UserEmailPayload = {
  email: Scalars['String']['output'];
  hasPassword: Scalars['Boolean']['output'];
  hasPhone: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  multiFactor: Scalars['Boolean']['output'];
};

export type UserEnrollmentCountsPayload = {
  active?: Maybe<Scalars['Int']['output']>;
  canceled?: Maybe<Scalars['Int']['output']>;
  completed?: Maybe<Scalars['Int']['output']>;
  declined?: Maybe<Scalars['Int']['output']>;
  inactive?: Maybe<Scalars['Int']['output']>;
  moved?: Maybe<Scalars['Int']['output']>;
  paused?: Maybe<Scalars['Int']['output']>;
  pending?: Maybe<Scalars['Int']['output']>;
  pendingCancel?: Maybe<Scalars['Int']['output']>;
  posted?: Maybe<Scalars['Int']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
  waitlist?: Maybe<Scalars['Int']['output']>;
};

export type UserEnrollmentsPayload = {
  count?: Maybe<Scalars['Int']['output']>;
  enrollments?: Maybe<Scalars['Json']['output']>;
};

export type UserFinancialAmount = {
  accounts?: Maybe<Scalars['Int']['output']>;
  amount?: Maybe<Scalars['Int']['output']>;
  date?: Maybe<Scalars['Date']['output']>;
};

export type UserFinancialSummaryPayload = {
  activeCoupons?: Maybe<UserFinancialAmount>;
  balance?: Maybe<UserFinancialAmount>;
  cardExpiring?: Maybe<Scalars['Int']['output']>;
  cart?: Maybe<UserFinancialAmount>;
  creditBalance?: Maybe<UserFinancialAmount>;
  expiredCard?: Maybe<UserFinancialAmount>;
  futureInvoiceBalance?: Maybe<UserFinancialAmount>;
  jobCredits?: Maybe<UserFinancialAmount>;
  monthlyCharges?: Maybe<UserFinancialAmount>;
  monthlyCredits?: Maybe<UserFinancialAmount>;
  noCard?: Maybe<UserFinancialAmount>;
  tokens?: Maybe<UserFinancialAmount>;
};

export type UserListRelationFilter = {
  every?: InputMaybe<UserWhereInput>;
  none?: InputMaybe<UserWhereInput>;
  some?: InputMaybe<UserWhereInput>;
};

export type UserManyInput = {
  connect?: InputMaybe<Array<InputMaybe<UniqueInput>>>;
  create?: InputMaybe<Array<InputMaybe<UserCreateInput>>>;
  delete?: InputMaybe<Array<InputMaybe<UniqueInput>>>;
  disconnect?: InputMaybe<Array<InputMaybe<UniqueInput>>>;
  set?: InputMaybe<Array<InputMaybe<UniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<UserUpdateInput>>>;
};

export type UserNestedInput = {
  update?: InputMaybe<UserCreateInput>;
};

export type UserOrderByInput = {
  createdAt?: InputMaybe<SortOrder>;
  firstName?: InputMaybe<SortOrder>;
  lastName?: InputMaybe<SortOrder>;
};

export type UserReferralCreateInput = {
  referralTemplateId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<UserReferralStatus>;
};

export type UserReferralInput = {
  create?: InputMaybe<UserReferralCreateInput>;
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  update?: InputMaybe<UserReferralCreateInput>;
  upsert?: InputMaybe<UserReferralUpsertInput>;
};

export const UserReferralStatus = {
  Active: 'Active',
  Dismissed: 'Dismissed'
} as const;

export type UserReferralStatus = typeof UserReferralStatus[keyof typeof UserReferralStatus];
export type UserReferralTemplate = {
  referralTemplate?: Maybe<ReferralTemplate>;
  status?: Maybe<UserReferralStatus>;
};

export type UserReferralTemplateWhereInput = {
  referralTemplate?: InputMaybe<ReferralTemplateWhereInput>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type UserReferralUpdateInput = {
  data?: InputMaybe<UserReferralCreateInput>;
  where?: InputMaybe<UniqueInput>;
};

export type UserReferralUpsertInput = {
  create?: InputMaybe<UserReferralCreateInput>;
  update?: InputMaybe<UserReferralUpsertUpdateInput>;
};

export type UserReferralUpsertUpdateInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  referralTemplateId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<UserReferralStatus>;
};

export type UserSubscription = {
  accountOwner?: Maybe<UserSubscription>;
  birthDate?: Maybe<Scalars['Date']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Gender>;
  id?: Maybe<Scalars['ID']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
};

export type UserUniqueInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
};

export type UserUpdateInput = {
  data?: InputMaybe<UserCreateInput>;
  where?: InputMaybe<UniqueInput>;
};

export type UserWhereInput = {
  AND?: InputMaybe<Array<UserWhereInput>>;
  NOT?: InputMaybe<UserWhereInput>;
  OR?: InputMaybe<Array<UserWhereInput>>;
  accountOwner?: InputMaybe<UserWhereInput>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  attendanceCheckIns?: InputMaybe<AttendanceListRelationFilter>;
  attendancesAsStudent?: InputMaybe<AttendanceListRelationFilter>;
  date?: InputMaybe<DateFilter>;
  email?: InputMaybe<StringFilter>;
  firstName?: InputMaybe<StringFilter>;
  groupRegistrations?: InputMaybe<GroupRegistrationListRelationFilter>;
  hideInFilters?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<StringFilter>;
  includedMeetPresentations?: InputMaybe<MeetPresentationListRelationFilter>;
  instructorClasses?: InputMaybe<ClassListRelationFilter>;
  instructors?: InputMaybe<UserListRelationFilter>;
  lastName?: InputMaybe<StringFilter>;
  level?: InputMaybe<LevelFilter>;
  membershipsRoster?: InputMaybe<MembershipListRelationFilter>;
  organizationAccountManager?: InputMaybe<OrganizationListRelationFilter>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  primaryAccountId?: InputMaybe<StringFilter>;
  privateGroupRegistrations?: InputMaybe<GroupRegistrationListRelationFilter>;
  profileId?: InputMaybe<Scalars['String']['input']>;
  settings?: InputMaybe<SettingListRelationFilter>;
  studentGroupRegistrations?: InputMaybe<GroupRegistrationListRelationFilter>;
  students?: InputMaybe<UserListRelationFilter>;
  studentsAdded?: InputMaybe<UserListRelationFilter>;
  usaSwimmingMemberId?: InputMaybe<StringFilter>;
};

export type VolunteerCheckInInput = {
  checkIn?: InputMaybe<Scalars['Boolean']['input']>;
  ids: Array<Scalars['ID']['input']>;
  issueDefaultCredits?: InputMaybe<Scalars['Boolean']['input']>;
  jobCredits?: InputMaybe<Scalars['Float']['input']>;
  removeVolunteers?: InputMaybe<Scalars['Boolean']['input']>;
  resetCredits?: InputMaybe<Scalars['Boolean']['input']>;
  verified?: InputMaybe<Scalars['Boolean']['input']>;
  volunteerEventId: Scalars['ID']['input'];
};

export type VolunteerEvent = {
  counts?: Maybe<VolunteerEventCounts>;
  createdAt: Scalars['Date']['output'];
  description?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['Date']['output']>;
  files: Array<File>;
  id: Scalars['ID']['output'];
  location?: Maybe<Scalars['String']['output']>;
  meet?: Maybe<Meet>;
  meetPresentations: Array<MeetPresentation>;
  organization?: Maybe<Organization>;
  publishDate?: Maybe<Scalars['Date']['output']>;
  responseEndDate?: Maybe<Scalars['Date']['output']>;
  responseStartDate?: Maybe<Scalars['Date']['output']>;
  startDate?: Maybe<Scalars['Date']['output']>;
  status: MeetStatus;
  timeslots?: Maybe<Array<MeetTimeslot>>;
  title: Scalars['String']['output'];
  unpublishDate?: Maybe<Scalars['Date']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  volunteers?: Maybe<Array<MeetVolunteer>>;
};

export type VolunteerEventCounts = {
  checkedIn?: Maybe<Scalars['Int']['output']>;
  spotsFilled?: Maybe<Scalars['Int']['output']>;
  spotsNeeded?: Maybe<Scalars['Int']['output']>;
  totalSpots?: Maybe<Scalars['Int']['output']>;
  verified?: Maybe<Scalars['Int']['output']>;
};

export type VolunteerEventCountsPayload = {
  checkedIn: Scalars['Int']['output'];
  spotsFilled: Scalars['Int']['output'];
  spotsNeeded: Scalars['Int']['output'];
  totalSpots: Scalars['Int']['output'];
  verified: Scalars['Int']['output'];
};

export type VolunteerEventCreateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  files?: InputMaybe<FileManyInput>;
  location?: InputMaybe<Scalars['String']['input']>;
  meet?: InputMaybe<ConnectUniqueInput>;
  meetPresentations?: InputMaybe<MeetPresentationManyInput>;
  organization?: InputMaybe<ConnectUniqueInput>;
  publishDate?: InputMaybe<Scalars['Date']['input']>;
  responseEndDate?: InputMaybe<Scalars['Date']['input']>;
  responseStartDate?: InputMaybe<Scalars['Date']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
  status?: InputMaybe<MeetStatus>;
  timeslots?: InputMaybe<MeetTimeslotManyInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  unpublishDate?: InputMaybe<Scalars['Date']['input']>;
  volunteers?: InputMaybe<MeetVolunteerManyInput>;
};

export type VolunteerEventStatusInputFilter = {
  equals?: InputMaybe<MeetStatus>;
  in?: InputMaybe<Array<InputMaybe<MeetStatus>>>;
  not?: InputMaybe<MeetStatus>;
  notIn?: InputMaybe<Array<InputMaybe<MeetStatus>>>;
};

export type VolunteerEventWhereInput = {
  AND?: InputMaybe<Array<VolunteerEventWhereInput>>;
  OR?: InputMaybe<Array<VolunteerEventWhereInput>>;
  id?: InputMaybe<StringFilter>;
  meet?: InputMaybe<MeetWhereInput>;
  meetId?: InputMaybe<StringFilter>;
  meetPresentations?: InputMaybe<MeetPresentationListRelationFilter>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  publishDate?: InputMaybe<DateFilter>;
  status?: InputMaybe<VolunteerEventStatusInputFilter>;
  volunteers?: InputMaybe<MeetVolunteerListRelationFilter>;
};

export type Zone = {
  createdAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  location?: Maybe<Location>;
  locationId?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
};

export type ZoneCreateInput = {
  order?: InputMaybe<Scalars['Int']['input']>;
  title: Scalars['String']['input'];
};

export type ZoneManyInput = {
  create?: InputMaybe<Array<InputMaybe<ZoneCreateInput>>>;
  delete?: InputMaybe<Array<InputMaybe<UniqueInput>>>;
  update?: InputMaybe<Array<InputMaybe<ZoneUpdateInput>>>;
};

export type ZoneUpdateInput = {
  data?: InputMaybe<ZoneCreateInput>;
  where?: InputMaybe<UniqueInput>;
};
